(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9obss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $817cb3b7c4e8cc1b$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $4exx6 = parcelRequire("4exx6");
parcelRequire("l399s");
var $aYjoe = parcelRequire("aYjoe");

var $1eMPm = parcelRequire("1eMPm");

var $atQuX = parcelRequire("atQuX");

var $bm8xp = parcelRequire("bm8xp");

var $btvu2 = parcelRequire("btvu2");

parcelRequire("j88fz");

// Lazily load heavy subtrees to enable further chunk-splitting
const $817cb3b7c4e8cc1b$var$AtunwaPlayerMeta = /*#__PURE__*/ (0, $8NFma.lazy)(()=>(parcelRequire("droSZ")));

const $817cb3b7c4e8cc1b$var$AtunwaPlayerBundle = /*#__PURE__*/ (0, $8NFma.lazy)(()=>(parcelRequire("iZh84")));
const $817cb3b7c4e8cc1b$var$RootApp = ({ dev: dev })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $aYjoe.default), {
        store: (0, $bm8xp.store),
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eMPm.PersistGate), {
            persistor: (0, $bm8xp.persistor),
            loading: "loading",
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4exx6.ApolloProvider), {
                client: (0, $atQuX.client),
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $btvu2.ThemeProvider), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        id: "atunwa-player",
                        className: "atunwa-player",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8NFma.Suspense), {
                                fallback: null,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)($817cb3b7c4e8cc1b$var$AtunwaPlayerMeta, {})
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8NFma.Suspense), {
                                fallback: null,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)($817cb3b7c4e8cc1b$var$AtunwaPlayerBundle, {})
                            })
                        ]
                    })
                })
            })
        })
    });
var $817cb3b7c4e8cc1b$export$2e2bcd8739ae039 = $817cb3b7c4e8cc1b$var$RootApp;

});
parcelRegister("4exx6", function(module, exports) {

$parcel$export(module.exports, "ApolloProvider", () => $31527b2d4e719e2f$export$c16b04c8a9956446);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $8NFma = parcelRequire("8NFma");

var $2TKzO = parcelRequire("2TKzO");
var $31527b2d4e719e2f$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $2TKzO.getApolloContext)();
    var parentContext = $8NFma.useContext(ApolloContext);
    var context = $8NFma.useMemo(function() {
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $013Qw.invariant)(context.client, 44);
    return $8NFma.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $c106e002a49a00cb$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $c106e002a49a00cb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $c106e002a49a00cb$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $c106e002a49a00cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $c106e002a49a00cb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArray", () => $c106e002a49a00cb$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92
};

});

parcelRegister("1Q1zr", function(module, exports) {

$parcel$export(module.exports, "maybe", () => (parcelRequire("7jWjX")).maybe);
$parcel$export(module.exports, "invariant", () => (parcelRequire("013Qw")).invariant);
$parcel$export(module.exports, "newInvariantError", () => (parcelRequire("013Qw")).newInvariantError);

var $013Qw = parcelRequire("013Qw");

var $7jWjX = parcelRequire("7jWjX");

var $boYaJ = parcelRequire("boYaJ");
var $156bddac0d04fbca$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("013Qw", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $003313e0ec1667d3$export$f5708dca728d7177);
$parcel$export(module.exports, "newInvariantError", () => $003313e0ec1667d3$export$3991762405098ea);

var $gztBd = parcelRequire("gztBd");

var $1TF3b = parcelRequire("1TF3b");

var $33x5Q = parcelRequire("33x5Q");

var $boYaJ = parcelRequire("boYaJ");

var $6x0sD = parcelRequire("6x0sD");
function $003313e0ec1667d3$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") fn($003313e0ec1667d3$var$getErrorMsg(message, args));
        else fn.apply(void 0, (0, $gztBd.__spreadArray)([
            message
        ], args, false));
    };
}
var $003313e0ec1667d3$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $1TF3b.invariant)(condition, $003313e0ec1667d3$var$getErrorMsg(message, args));
}, {
    debug: $003313e0ec1667d3$var$wrap((0, $1TF3b.invariant).debug),
    log: $003313e0ec1667d3$var$wrap((0, $1TF3b.invariant).log),
    warn: $003313e0ec1667d3$var$wrap((0, $1TF3b.invariant).warn),
    error: $003313e0ec1667d3$var$wrap((0, $1TF3b.invariant).error)
});
function $003313e0ec1667d3$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $1TF3b.InvariantError)($003313e0ec1667d3$var$getErrorMsg(message, optionalParams));
}
var $003313e0ec1667d3$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $33x5Q.version));
function $003313e0ec1667d3$var$getErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    var args = messageArgs.map(function(arg) {
        return typeof arg == "string" ? arg : (0, $6x0sD.stringifyForDisplay)(arg, 2).slice(0, 1000);
    });
    return (0, $boYaJ.default)[$003313e0ec1667d3$export$b8ca975fa04efdf3] && (0, $boYaJ.default)[$003313e0ec1667d3$export$b8ca975fa04efdf3](message, args) || "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $33x5Q.version),
        message: message,
        args: args
    })));
}

});
parcelRegister("1TF3b", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $161ac53fb2641fb9$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $161ac53fb2641fb9$export$f5708dca728d7177);

var $gztBd = parcelRequire("gztBd");
var $161ac53fb2641fb9$var$genericMessage = "Invariant Violation";
var $161ac53fb2641fb9$var$_a = Object.setPrototypeOf, $161ac53fb2641fb9$var$setPrototypeOf = $161ac53fb2641fb9$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $161ac53fb2641fb9$var$_a;
var $161ac53fb2641fb9$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $161ac53fb2641fb9$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $161ac53fb2641fb9$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $161ac53fb2641fb9$var$genericMessage;
        $161ac53fb2641fb9$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $161ac53fb2641fb9$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $161ac53fb2641fb9$export$cea12affaee22fe8(message);
}
var $161ac53fb2641fb9$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $161ac53fb2641fb9$var$verbosityLevel = $161ac53fb2641fb9$var$verbosityLevels.indexOf("log");
function $161ac53fb2641fb9$var$wrapConsoleMethod(name) {
    return function() {
        if ($161ac53fb2641fb9$var$verbosityLevels.indexOf(name) >= $161ac53fb2641fb9$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $161ac53fb2641fb9$var$wrapConsoleMethod("debug");
    invariant.log = $161ac53fb2641fb9$var$wrapConsoleMethod("log");
    invariant.warn = $161ac53fb2641fb9$var$wrapConsoleMethod("warn");
    invariant.error = $161ac53fb2641fb9$var$wrapConsoleMethod("error");
})($161ac53fb2641fb9$export$f5708dca728d7177 || ($161ac53fb2641fb9$export$f5708dca728d7177 = {}));
function $161ac53fb2641fb9$export$a80e09f2cd325fb8(level) {
    var old = $161ac53fb2641fb9$var$verbosityLevels[$161ac53fb2641fb9$var$verbosityLevel];
    $161ac53fb2641fb9$var$verbosityLevel = Math.max(0, $161ac53fb2641fb9$var$verbosityLevels.indexOf(level));
    return old;
}
var $161ac53fb2641fb9$export$2e2bcd8739ae039 = $161ac53fb2641fb9$export$f5708dca728d7177;

});

parcelRegister("33x5Q", function(module, exports) {

$parcel$export(module.exports, "version", () => $239b528caa7d51c3$export$83d89fbfd8236492);
var $239b528caa7d51c3$export$83d89fbfd8236492 = "3.8.4";

});

parcelRegister("boYaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d09c85a9a7b402$export$2e2bcd8739ae039);

var $7jWjX = parcelRequire("7jWjX");
var $84d09c85a9a7b402$export$2e2bcd8739ae039 = (0, $7jWjX.maybe)(function() {
    return globalThis;
}) || (0, $7jWjX.maybe)(function() {
    return window;
}) || (0, $7jWjX.maybe)(function() {
    return self;
}) || (0, $7jWjX.maybe)(function() {
    return $parcel$global;
}) || (0, $7jWjX.maybe)(function() {
    return (0, $7jWjX.maybe).constructor("return this")();
});

});
parcelRegister("7jWjX", function(module, exports) {

$parcel$export(module.exports, "maybe", () => $55478c0b9b5a727a$export$f8b8b9ce72e9ccbf);
function $55478c0b9b5a727a$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("6x0sD", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", () => $4c162ea7f45b3413$export$f341b4883239463f);

var $ii86D = parcelRequire("ii86D");
function $4c162ea7f45b3413$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $ii86D.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("ii86D", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", () => $d510321921a165fa$export$d0c8ec0fe1b18b70);
var $d510321921a165fa$var$prefixCounts = new Map();
function $d510321921a165fa$export$d0c8ec0fe1b18b70(prefix) {
    var count = $d510321921a165fa$var$prefixCounts.get(prefix) || 1;
    $d510321921a165fa$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("2TKzO", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $21c4d8fbf78c83a6$export$a47505d961ee3a1);

var $8NFma = parcelRequire("8NFma");

var $1w01O = parcelRequire("1w01O");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
var $21c4d8fbf78c83a6$var$contextKey = (0, $1w01O.canUseSymbol) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $21c4d8fbf78c83a6$export$a47505d961ee3a1() {
    (0, $013Qw.invariant)("createContext" in $8NFma, 43);
    var context = $8NFma.createContext[$21c4d8fbf78c83a6$var$contextKey];
    if (!context) {
        Object.defineProperty($8NFma.createContext, $21c4d8fbf78c83a6$var$contextKey, {
            value: context = $8NFma.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $21c4d8fbf78c83a6$export$c2ee824bcc89ca6a = $21c4d8fbf78c83a6$export$a47505d961ee3a1;

});
parcelRegister("1w01O", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", () => $11a8cd3787abe194$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "canUseWeakSet", () => $11a8cd3787abe194$export$7293b8a0b474028d);
$parcel$export(module.exports, "canUseSymbol", () => $11a8cd3787abe194$export$23ba675b4b838b92);
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", () => $11a8cd3787abe194$export$c34f882e9f1c1637);
$parcel$export(module.exports, "canUseLayoutEffect", () => $11a8cd3787abe194$export$4001f6cd4a62405b);
parcelRequire("1Q1zr");
var $7jWjX = parcelRequire("7jWjX");
var $11a8cd3787abe194$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && (0, $7jWjX.maybe)(function() {
    return navigator.product;
}) !== "ReactNative";
var $11a8cd3787abe194$export$7293b8a0b474028d = typeof WeakSet === "function";
var $11a8cd3787abe194$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $11a8cd3787abe194$export$c34f882e9f1c1637 = $11a8cd3787abe194$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $11a8cd3787abe194$export$71594e8a50f746f4 = typeof (0, $7jWjX.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $11a8cd3787abe194$var$usingJSDOM = (0, $7jWjX.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $11a8cd3787abe194$export$4001f6cd4a62405b = $11a8cd3787abe194$export$71594e8a50f746f4 && !$11a8cd3787abe194$var$usingJSDOM;

});



parcelRegister("l399s", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("aYjoe")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("aq5p5")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("kNYU3")).useSelector);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $ck4pA = parcelRequire("ck4pA");

var $8jW4Q = parcelRequire("8jW4Q");
parcelRequire("3BNOS");
var $2pmb0 = parcelRequire("2pmb0");

var $6FR0P = parcelRequire("6FR0P");

var $kNYU3 = parcelRequire("kNYU3");

var $9Scls = parcelRequire("9Scls");
parcelRequire("eSoBj");
(0, $kNYU3.initializeUseSelector)((0, $8jW4Q.useSyncExternalStoreWithSelector));
(0, $9Scls.initializeConnect)((0, $ck4pA.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $6FR0P.setBatch)((0, $2pmb0.unstable_batchedUpdates));

});
parcelRegister("ck4pA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gIe59"));

});
parcelRegister("gIe59", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $0323cd20515dc210$export$306c0aa65ff9ec16, (v) => $0323cd20515dc210$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0323cd20515dc210$export$306c0aa65ff9ec16;
'use strict';

var $8NFma = parcelRequire("8NFma");
function $0323cd20515dc210$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0323cd20515dc210$var$k = "function" === typeof Object.is ? Object.is : $0323cd20515dc210$var$h, $0323cd20515dc210$var$l = $8NFma.useState, $0323cd20515dc210$var$m = $8NFma.useEffect, $0323cd20515dc210$var$n = $8NFma.useLayoutEffect, $0323cd20515dc210$var$p = $8NFma.useDebugValue;
function $0323cd20515dc210$var$q(a, b) {
    var d = b(), f = $0323cd20515dc210$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $0323cd20515dc210$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $0323cd20515dc210$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $0323cd20515dc210$var$m(function() {
        $0323cd20515dc210$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $0323cd20515dc210$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $0323cd20515dc210$var$p(d);
    return d;
}
function $0323cd20515dc210$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$0323cd20515dc210$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $0323cd20515dc210$var$t(a, b) {
    return b();
}
var $0323cd20515dc210$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $0323cd20515dc210$var$t : $0323cd20515dc210$var$q;
$0323cd20515dc210$export$306c0aa65ff9ec16 = void 0 !== $8NFma.useSyncExternalStore ? $8NFma.useSyncExternalStore : $0323cd20515dc210$var$u;

});


parcelRegister("8jW4Q", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gq538"));

});
parcelRegister("gq538", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $bf42fdc57ea366b0$export$bf730a2d8bf68b42, (v) => $bf42fdc57ea366b0$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf42fdc57ea366b0$export$bf730a2d8bf68b42;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");
function $bf42fdc57ea366b0$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bf42fdc57ea366b0$var$q = "function" === typeof Object.is ? Object.is : $bf42fdc57ea366b0$var$p, $bf42fdc57ea366b0$var$r = $ck4pA.useSyncExternalStore, $bf42fdc57ea366b0$var$t = $8NFma.useRef, $bf42fdc57ea366b0$var$u = $8NFma.useEffect, $bf42fdc57ea366b0$var$v = $8NFma.useMemo, $bf42fdc57ea366b0$var$w = $8NFma.useDebugValue;
$bf42fdc57ea366b0$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $bf42fdc57ea366b0$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $bf42fdc57ea366b0$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($bf42fdc57ea366b0$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $bf42fdc57ea366b0$var$r(a, c[0], c[1]);
    $bf42fdc57ea366b0$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $bf42fdc57ea366b0$var$w(d);
    return d;
};

});


parcelRegister("3BNOS", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("2pmb0")).unstable_batchedUpdates);

var $2pmb0 = parcelRequire("2pmb0");

});

parcelRegister("6FR0P", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $4dbfb18b4a292cac$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $4dbfb18b4a292cac$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $4dbfb18b4a292cac$var$defaultNoopBatch(callback) {
    callback();
}
let $4dbfb18b4a292cac$var$batch = $4dbfb18b4a292cac$var$defaultNoopBatch; // Allow injecting another batching function later
const $4dbfb18b4a292cac$export$4b9874722d0da7bc = (newBatch)=>$4dbfb18b4a292cac$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $4dbfb18b4a292cac$export$fc47d4c0ba3bd2c6 = ()=>$4dbfb18b4a292cac$var$batch;

});

parcelRegister("kNYU3", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $f257a05469835033$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $f257a05469835033$export$2105062e25df4afe);

var $8NFma = parcelRequire("8NFma");

var $eQjyW = parcelRequire("eQjyW");

var $ehbAR = parcelRequire("ehbAR");

var $bMa68 = parcelRequire("bMa68");
let $f257a05469835033$var$useSyncExternalStoreWithSelector = (0, $bMa68.notInitialized);
const $f257a05469835033$export$e2e6e3f3f3b782e3 = (fn)=>{
    $f257a05469835033$var$useSyncExternalStoreWithSelector = fn;
};
const $f257a05469835033$var$refEquality = (a, b)=>a === b;
function $f257a05469835033$export$2b53f90d2bd1cbfb(context = (0, $ehbAR.ReactReduxContext)) {
    const useReduxContext = context === (0, $ehbAR.ReactReduxContext) ? (0, $eQjyW.useReduxContext) : (0, $eQjyW.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $f257a05469835033$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $8NFma.useRef)(true);
        const wrappedSelector = (0, $8NFma.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $f257a05469835033$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $8NFma.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $f257a05469835033$export$2105062e25df4afe = /*#__PURE__*/ $f257a05469835033$export$2b53f90d2bd1cbfb();

});
parcelRegister("eQjyW", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $ace518bc4186cce8$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $ace518bc4186cce8$export$c1275ca9a6fd3ec5);

var $8NFma = parcelRequire("8NFma");

var $ehbAR = parcelRequire("ehbAR");
function $ace518bc4186cce8$export$d4d6226d5fc61558(context = (0, $ehbAR.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $8NFma.useContext)(context);
        return contextValue;
    };
}
const $ace518bc4186cce8$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $ace518bc4186cce8$export$d4d6226d5fc61558();

});
parcelRegister("ehbAR", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $a64ba574b2c9ceff$export$cc80c08dc91f1c00);

var $8NFma = parcelRequire("8NFma");
const $a64ba574b2c9ceff$var$ContextKey = Symbol.for(`react-redux-context`);
const $a64ba574b2c9ceff$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $a64ba574b2c9ceff$var$getContext() {
    var _gT$ContextKey;
    if (!$8NFma.createContext) return {};
    const contextMap = (_gT$ContextKey = $a64ba574b2c9ceff$var$gT[$a64ba574b2c9ceff$var$ContextKey]) != null ? _gT$ContextKey : $a64ba574b2c9ceff$var$gT[$a64ba574b2c9ceff$var$ContextKey] = new Map();
    let realContext = contextMap.get($8NFma.createContext);
    if (!realContext) {
        realContext = $8NFma.createContext(null);
        contextMap.set($8NFma.createContext, realContext);
    }
    return realContext;
}
const $a64ba574b2c9ceff$export$cc80c08dc91f1c00 = /*#__PURE__*/ $a64ba574b2c9ceff$var$getContext();
var $a64ba574b2c9ceff$export$2e2bcd8739ae039 = $a64ba574b2c9ceff$export$cc80c08dc91f1c00;

});


parcelRegister("bMa68", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $892c02a44e5b9467$export$20656a4825650bd0);
const $892c02a44e5b9467$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("9Scls", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $7302bbaf1b5be944$export$36d45daa6a4925b8);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $l3NX5 = parcelRequire("l3NX5");

var $8NFma = parcelRequire("8NFma");

var $59BDH = parcelRequire("59BDH");

var $b8Jkb = parcelRequire("b8Jkb");

var $jCRvh = parcelRequire("jCRvh");

var $ghkMh = parcelRequire("ghkMh");

var $j5Zev = parcelRequire("j5Zev");

var $21oin = parcelRequire("21oin");

var $gP8XC = parcelRequire("gP8XC");

var $jnMAW = parcelRequire("jnMAW");
parcelRequire("dTx0l");

var $ehbAR = parcelRequire("ehbAR");

var $bMa68 = parcelRequire("bMa68");
const $7302bbaf1b5be944$var$_excluded = [
    "reactReduxForwardedRef"
];
let $7302bbaf1b5be944$var$useSyncExternalStore = (0, $bMa68.notInitialized);
const $7302bbaf1b5be944$export$36d45daa6a4925b8 = (fn)=>{
    $7302bbaf1b5be944$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $7302bbaf1b5be944$var$EMPTY_ARRAY = [
    null,
    0
];
const $7302bbaf1b5be944$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $7302bbaf1b5be944$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $7302bbaf1b5be944$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $gP8XC.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $7302bbaf1b5be944$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $7302bbaf1b5be944$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $7302bbaf1b5be944$var$initStateUpdates = ()=>$7302bbaf1b5be944$var$EMPTY_ARRAY;
function $7302bbaf1b5be944$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $7302bbaf1b5be944$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $7302bbaf1b5be944$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $7302bbaf1b5be944$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $jnMAW.default), areStatePropsEqual: areStatePropsEqual = (0, $jnMAW.default), areMergedPropsEqual: areMergedPropsEqual = (0, $jnMAW.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $ehbAR.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $ghkMh.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $jCRvh.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $j5Zev.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $8NFma.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $hQtye.default)(props, $7302bbaf1b5be944$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $8NFma.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $59BDH.isContextConsumer)(/*#__PURE__*/ $8NFma.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $8NFma.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $8NFma.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $b8Jkb.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $8NFma.useMemo(()=>{
                if (!shouldHandleStateChanges) return $7302bbaf1b5be944$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $21oin.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $8NFma.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $jz4iA.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $8NFma.useRef();
            const lastWrapperProps = $8NFma.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $8NFma.useRef();
            const renderIsScheduled = $8NFma.useRef(false);
            const isProcessingDispatch = $8NFma.useRef(false);
            const isMounted = $8NFma.useRef(false);
            const latestSubscriptionCallbackError = $8NFma.useRef();
            (0, $gP8XC.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $8NFma.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $8NFma.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $7302bbaf1b5be944$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $7302bbaf1b5be944$var$useIsomorphicLayoutEffectWithArgs($7302bbaf1b5be944$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7302bbaf1b5be944$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $gP8XC.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $8NFma.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $8NFma.createElement(WrappedComponent, (0, $jz4iA.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $8NFma.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $8NFma.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $8NFma.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $8NFma.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $8NFma.createElement(Connect, (0, $jz4iA.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($l3NX5)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($l3NX5)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $7302bbaf1b5be944$export$2e2bcd8739ae039 = $7302bbaf1b5be944$var$connect;

});
parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("l3NX5", function(module, exports) {
'use strict';

var $1TAMD = parcelRequire("1TAMD");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($1TAMD.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component['$$typeof']] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;

});
parcelRegister("1TAMD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cdwfJ"));

});
parcelRegister("cdwfJ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $8e4fb7a6186ef4a8$export$2b8d127b894957b9, (v) => $8e4fb7a6186ef4a8$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $8e4fb7a6186ef4a8$export$cea3a54a6425200c, (v) => $8e4fb7a6186ef4a8$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae, (v) => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d, (v) => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac, (v) => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35, (v) => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8e4fb7a6186ef4a8$export$ffb0004e005737fa, (v) => $8e4fb7a6186ef4a8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8e4fb7a6186ef4a8$export$b624eff549462981, (v) => $8e4fb7a6186ef4a8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8e4fb7a6186ef4a8$export$7897aa7841a5380c, (v) => $8e4fb7a6186ef4a8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8e4fb7a6186ef4a8$export$602eac185826482c, (v) => $8e4fb7a6186ef4a8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8e4fb7a6186ef4a8$export$e2c29f18771995cb, (v) => $8e4fb7a6186ef4a8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8e4fb7a6186ef4a8$export$5f8d39834fd61797, (v) => $8e4fb7a6186ef4a8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5, (v) => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8e4fb7a6186ef4a8$export$92387174baf9b227, (v) => $8e4fb7a6186ef4a8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6, (v) => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8e4fb7a6186ef4a8$export$b706b080d889d2c9, (v) => $8e4fb7a6186ef4a8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc, (v) => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d, (v) => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8e4fb7a6186ef4a8$export$455c2e768291efa6, (v) => $8e4fb7a6186ef4a8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8e4fb7a6186ef4a8$export$9522e17588c12572, (v) => $8e4fb7a6186ef4a8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8e4fb7a6186ef4a8$export$2110ac352bb060b9, (v) => $8e4fb7a6186ef4a8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab, (v) => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de, (v) => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8e4fb7a6186ef4a8$export$b82d16f27459e05a, (v) => $8e4fb7a6186ef4a8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8, (v) => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6, (v) => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8e4fb7a6186ef4a8$export$9b621391a187a31a, (v) => $8e4fb7a6186ef4a8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f, (v) => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e4fb7a6186ef4a8$export$2b8d127b894957b9;
var $8e4fb7a6186ef4a8$export$cea3a54a6425200c;
var $8e4fb7a6186ef4a8$export$a7c73072b1a182ae;
var $8e4fb7a6186ef4a8$export$9f27bc3417b4524d;
var $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac;
var $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35;
var $8e4fb7a6186ef4a8$export$ffb0004e005737fa;
var $8e4fb7a6186ef4a8$export$b624eff549462981;
var $8e4fb7a6186ef4a8$export$7897aa7841a5380c;
var $8e4fb7a6186ef4a8$export$602eac185826482c;
var $8e4fb7a6186ef4a8$export$e2c29f18771995cb;
var $8e4fb7a6186ef4a8$export$5f8d39834fd61797;
var $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5;
var $8e4fb7a6186ef4a8$export$92387174baf9b227;
var $8e4fb7a6186ef4a8$export$ec112efeb987d9c6;
var $8e4fb7a6186ef4a8$export$b706b080d889d2c9;
var $8e4fb7a6186ef4a8$export$5be5a87408f70ddc;
var $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d;
var $8e4fb7a6186ef4a8$export$455c2e768291efa6;
var $8e4fb7a6186ef4a8$export$9522e17588c12572;
var $8e4fb7a6186ef4a8$export$2110ac352bb060b9;
var $8e4fb7a6186ef4a8$export$56885ab8b9c456ab;
var $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de;
var $8e4fb7a6186ef4a8$export$b82d16f27459e05a;
var $8e4fb7a6186ef4a8$export$522c17b4f5e123e8;
var $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6;
var $8e4fb7a6186ef4a8$export$9b621391a187a31a;
var $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f;
'use strict';
var $8e4fb7a6186ef4a8$var$b = "function" === typeof Symbol && Symbol.for, $8e4fb7a6186ef4a8$var$c = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.element") : 60103, $8e4fb7a6186ef4a8$var$d = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.portal") : 60106, $8e4fb7a6186ef4a8$var$e = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fragment") : 60107, $8e4fb7a6186ef4a8$var$f = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.strict_mode") : 60108, $8e4fb7a6186ef4a8$var$g = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.profiler") : 60114, $8e4fb7a6186ef4a8$var$h = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.provider") : 60109, $8e4fb7a6186ef4a8$var$k = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.context") : 60110, $8e4fb7a6186ef4a8$var$l = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.async_mode") : 60111, $8e4fb7a6186ef4a8$var$m = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8e4fb7a6186ef4a8$var$n = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.forward_ref") : 60112, $8e4fb7a6186ef4a8$var$p = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense") : 60113, $8e4fb7a6186ef4a8$var$q = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense_list") : 60120, $8e4fb7a6186ef4a8$var$r = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.memo") : 60115, $8e4fb7a6186ef4a8$var$t = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.lazy") : 60116, $8e4fb7a6186ef4a8$var$v = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.block") : 60121, $8e4fb7a6186ef4a8$var$w = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fundamental") : 60117, $8e4fb7a6186ef4a8$var$x = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.responder") : 60118, $8e4fb7a6186ef4a8$var$y = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.scope") : 60119;
function $8e4fb7a6186ef4a8$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8e4fb7a6186ef4a8$var$c:
                switch(a = a.type, a){
                    case $8e4fb7a6186ef4a8$var$l:
                    case $8e4fb7a6186ef4a8$var$m:
                    case $8e4fb7a6186ef4a8$var$e:
                    case $8e4fb7a6186ef4a8$var$g:
                    case $8e4fb7a6186ef4a8$var$f:
                    case $8e4fb7a6186ef4a8$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8e4fb7a6186ef4a8$var$k:
                            case $8e4fb7a6186ef4a8$var$n:
                            case $8e4fb7a6186ef4a8$var$t:
                            case $8e4fb7a6186ef4a8$var$r:
                            case $8e4fb7a6186ef4a8$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8e4fb7a6186ef4a8$var$d:
                return u;
        }
    }
}
function $8e4fb7a6186ef4a8$var$A(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$m;
}
$8e4fb7a6186ef4a8$export$2b8d127b894957b9 = $8e4fb7a6186ef4a8$var$l;
$8e4fb7a6186ef4a8$export$cea3a54a6425200c = $8e4fb7a6186ef4a8$var$m;
$8e4fb7a6186ef4a8$export$a7c73072b1a182ae = $8e4fb7a6186ef4a8$var$k;
$8e4fb7a6186ef4a8$export$9f27bc3417b4524d = $8e4fb7a6186ef4a8$var$h;
$8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = $8e4fb7a6186ef4a8$var$c;
$8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = $8e4fb7a6186ef4a8$var$n;
$8e4fb7a6186ef4a8$export$ffb0004e005737fa = $8e4fb7a6186ef4a8$var$e;
$8e4fb7a6186ef4a8$export$b624eff549462981 = $8e4fb7a6186ef4a8$var$t;
$8e4fb7a6186ef4a8$export$7897aa7841a5380c = $8e4fb7a6186ef4a8$var$r;
$8e4fb7a6186ef4a8$export$602eac185826482c = $8e4fb7a6186ef4a8$var$d;
$8e4fb7a6186ef4a8$export$e2c29f18771995cb = $8e4fb7a6186ef4a8$var$g;
$8e4fb7a6186ef4a8$export$5f8d39834fd61797 = $8e4fb7a6186ef4a8$var$f;
$8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = $8e4fb7a6186ef4a8$var$p;
$8e4fb7a6186ef4a8$export$92387174baf9b227 = function(a) {
    return $8e4fb7a6186ef4a8$var$A(a) || $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$l;
};
$8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = $8e4fb7a6186ef4a8$var$A;
$8e4fb7a6186ef4a8$export$b706b080d889d2c9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$k;
};
$8e4fb7a6186ef4a8$export$5be5a87408f70ddc = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$h;
};
$8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8e4fb7a6186ef4a8$var$c;
};
$8e4fb7a6186ef4a8$export$455c2e768291efa6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$n;
};
$8e4fb7a6186ef4a8$export$9522e17588c12572 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$e;
};
$8e4fb7a6186ef4a8$export$2110ac352bb060b9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$t;
};
$8e4fb7a6186ef4a8$export$56885ab8b9c456ab = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$r;
};
$8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$d;
};
$8e4fb7a6186ef4a8$export$b82d16f27459e05a = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$g;
};
$8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$f;
};
$8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$p;
};
$8e4fb7a6186ef4a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8e4fb7a6186ef4a8$var$e || a === $8e4fb7a6186ef4a8$var$m || a === $8e4fb7a6186ef4a8$var$g || a === $8e4fb7a6186ef4a8$var$f || a === $8e4fb7a6186ef4a8$var$p || a === $8e4fb7a6186ef4a8$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8e4fb7a6186ef4a8$var$t || a.$$typeof === $8e4fb7a6186ef4a8$var$r || a.$$typeof === $8e4fb7a6186ef4a8$var$h || a.$$typeof === $8e4fb7a6186ef4a8$var$k || a.$$typeof === $8e4fb7a6186ef4a8$var$n || a.$$typeof === $8e4fb7a6186ef4a8$var$w || a.$$typeof === $8e4fb7a6186ef4a8$var$x || a.$$typeof === $8e4fb7a6186ef4a8$var$y || a.$$typeof === $8e4fb7a6186ef4a8$var$v);
};
$8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = $8e4fb7a6186ef4a8$var$z;

});



parcelRegister("59BDH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gleym"));

});
parcelRegister("gleym", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $be59e573b4742318$export$a7c73072b1a182ae, (v) => $be59e573b4742318$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $be59e573b4742318$export$9f27bc3417b4524d, (v) => $be59e573b4742318$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $be59e573b4742318$export$db77ccec0bb4ccac, (v) => $be59e573b4742318$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $be59e573b4742318$export$8392c0c9d3dcbd35, (v) => $be59e573b4742318$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $be59e573b4742318$export$ffb0004e005737fa, (v) => $be59e573b4742318$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $be59e573b4742318$export$b624eff549462981, (v) => $be59e573b4742318$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $be59e573b4742318$export$7897aa7841a5380c, (v) => $be59e573b4742318$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $be59e573b4742318$export$602eac185826482c, (v) => $be59e573b4742318$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $be59e573b4742318$export$e2c29f18771995cb, (v) => $be59e573b4742318$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $be59e573b4742318$export$5f8d39834fd61797, (v) => $be59e573b4742318$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $be59e573b4742318$export$74bf444e3cd11ea5, (v) => $be59e573b4742318$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $be59e573b4742318$export$998bcd577473dd93, (v) => $be59e573b4742318$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $be59e573b4742318$export$92387174baf9b227, (v) => $be59e573b4742318$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $be59e573b4742318$export$ec112efeb987d9c6, (v) => $be59e573b4742318$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $be59e573b4742318$export$b706b080d889d2c9, (v) => $be59e573b4742318$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $be59e573b4742318$export$5be5a87408f70ddc, (v) => $be59e573b4742318$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $be59e573b4742318$export$45a5e7f76e0caa8d, (v) => $be59e573b4742318$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $be59e573b4742318$export$455c2e768291efa6, (v) => $be59e573b4742318$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $be59e573b4742318$export$9522e17588c12572, (v) => $be59e573b4742318$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $be59e573b4742318$export$2110ac352bb060b9, (v) => $be59e573b4742318$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $be59e573b4742318$export$56885ab8b9c456ab, (v) => $be59e573b4742318$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $be59e573b4742318$export$d927fcb6adf8f9de, (v) => $be59e573b4742318$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $be59e573b4742318$export$b82d16f27459e05a, (v) => $be59e573b4742318$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $be59e573b4742318$export$522c17b4f5e123e8, (v) => $be59e573b4742318$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $be59e573b4742318$export$1aabd8a0274ecfd6, (v) => $be59e573b4742318$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $be59e573b4742318$export$3d6c20d97e46b957, (v) => $be59e573b4742318$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $be59e573b4742318$export$9b621391a187a31a, (v) => $be59e573b4742318$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $be59e573b4742318$export$f5bbd400c2f4426f, (v) => $be59e573b4742318$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $be59e573b4742318$export$a7c73072b1a182ae;
var $be59e573b4742318$export$9f27bc3417b4524d;
var $be59e573b4742318$export$db77ccec0bb4ccac;
var $be59e573b4742318$export$8392c0c9d3dcbd35;
var $be59e573b4742318$export$ffb0004e005737fa;
var $be59e573b4742318$export$b624eff549462981;
var $be59e573b4742318$export$7897aa7841a5380c;
var $be59e573b4742318$export$602eac185826482c;
var $be59e573b4742318$export$e2c29f18771995cb;
var $be59e573b4742318$export$5f8d39834fd61797;
var $be59e573b4742318$export$74bf444e3cd11ea5;
var $be59e573b4742318$export$998bcd577473dd93;
var $be59e573b4742318$export$92387174baf9b227;
var $be59e573b4742318$export$ec112efeb987d9c6;
var $be59e573b4742318$export$b706b080d889d2c9;
var $be59e573b4742318$export$5be5a87408f70ddc;
var $be59e573b4742318$export$45a5e7f76e0caa8d;
var $be59e573b4742318$export$455c2e768291efa6;
var $be59e573b4742318$export$9522e17588c12572;
var $be59e573b4742318$export$2110ac352bb060b9;
var $be59e573b4742318$export$56885ab8b9c456ab;
var $be59e573b4742318$export$d927fcb6adf8f9de;
var $be59e573b4742318$export$b82d16f27459e05a;
var $be59e573b4742318$export$522c17b4f5e123e8;
var $be59e573b4742318$export$1aabd8a0274ecfd6;
var $be59e573b4742318$export$3d6c20d97e46b957;
var $be59e573b4742318$export$9b621391a187a31a;
var $be59e573b4742318$export$f5bbd400c2f4426f;
'use strict';
var $be59e573b4742318$var$b = Symbol.for("react.element"), $be59e573b4742318$var$c = Symbol.for("react.portal"), $be59e573b4742318$var$d = Symbol.for("react.fragment"), $be59e573b4742318$var$e = Symbol.for("react.strict_mode"), $be59e573b4742318$var$f = Symbol.for("react.profiler"), $be59e573b4742318$var$g = Symbol.for("react.provider"), $be59e573b4742318$var$h = Symbol.for("react.context"), $be59e573b4742318$var$k = Symbol.for("react.server_context"), $be59e573b4742318$var$l = Symbol.for("react.forward_ref"), $be59e573b4742318$var$m = Symbol.for("react.suspense"), $be59e573b4742318$var$n = Symbol.for("react.suspense_list"), $be59e573b4742318$var$p = Symbol.for("react.memo"), $be59e573b4742318$var$q = Symbol.for("react.lazy"), $be59e573b4742318$var$t = Symbol.for("react.offscreen"), $be59e573b4742318$var$u;
$be59e573b4742318$var$u = Symbol.for("react.module.reference");
function $be59e573b4742318$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $be59e573b4742318$var$b:
                switch(a = a.type, a){
                    case $be59e573b4742318$var$d:
                    case $be59e573b4742318$var$f:
                    case $be59e573b4742318$var$e:
                    case $be59e573b4742318$var$m:
                    case $be59e573b4742318$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $be59e573b4742318$var$k:
                            case $be59e573b4742318$var$h:
                            case $be59e573b4742318$var$l:
                            case $be59e573b4742318$var$q:
                            case $be59e573b4742318$var$p:
                            case $be59e573b4742318$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $be59e573b4742318$var$c:
                return r;
        }
    }
}
$be59e573b4742318$export$a7c73072b1a182ae = $be59e573b4742318$var$h;
$be59e573b4742318$export$9f27bc3417b4524d = $be59e573b4742318$var$g;
$be59e573b4742318$export$db77ccec0bb4ccac = $be59e573b4742318$var$b;
$be59e573b4742318$export$8392c0c9d3dcbd35 = $be59e573b4742318$var$l;
$be59e573b4742318$export$ffb0004e005737fa = $be59e573b4742318$var$d;
$be59e573b4742318$export$b624eff549462981 = $be59e573b4742318$var$q;
$be59e573b4742318$export$7897aa7841a5380c = $be59e573b4742318$var$p;
$be59e573b4742318$export$602eac185826482c = $be59e573b4742318$var$c;
$be59e573b4742318$export$e2c29f18771995cb = $be59e573b4742318$var$f;
$be59e573b4742318$export$5f8d39834fd61797 = $be59e573b4742318$var$e;
$be59e573b4742318$export$74bf444e3cd11ea5 = $be59e573b4742318$var$m;
$be59e573b4742318$export$998bcd577473dd93 = $be59e573b4742318$var$n;
$be59e573b4742318$export$92387174baf9b227 = function() {
    return !1;
};
$be59e573b4742318$export$ec112efeb987d9c6 = function() {
    return !1;
};
$be59e573b4742318$export$b706b080d889d2c9 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$h;
};
$be59e573b4742318$export$5be5a87408f70ddc = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$g;
};
$be59e573b4742318$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $be59e573b4742318$var$b;
};
$be59e573b4742318$export$455c2e768291efa6 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$l;
};
$be59e573b4742318$export$9522e17588c12572 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$d;
};
$be59e573b4742318$export$2110ac352bb060b9 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$q;
};
$be59e573b4742318$export$56885ab8b9c456ab = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$p;
};
$be59e573b4742318$export$d927fcb6adf8f9de = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$c;
};
$be59e573b4742318$export$b82d16f27459e05a = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$f;
};
$be59e573b4742318$export$522c17b4f5e123e8 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$e;
};
$be59e573b4742318$export$1aabd8a0274ecfd6 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$m;
};
$be59e573b4742318$export$3d6c20d97e46b957 = function(a) {
    return $be59e573b4742318$var$v(a) === $be59e573b4742318$var$n;
};
$be59e573b4742318$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $be59e573b4742318$var$d || a === $be59e573b4742318$var$f || a === $be59e573b4742318$var$e || a === $be59e573b4742318$var$m || a === $be59e573b4742318$var$n || a === $be59e573b4742318$var$t || "object" === typeof a && null !== a && (a.$$typeof === $be59e573b4742318$var$q || a.$$typeof === $be59e573b4742318$var$p || a.$$typeof === $be59e573b4742318$var$g || a.$$typeof === $be59e573b4742318$var$h || a.$$typeof === $be59e573b4742318$var$l || a.$$typeof === $be59e573b4742318$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$be59e573b4742318$export$f5bbd400c2f4426f = $be59e573b4742318$var$v;

});


parcelRegister("b8Jkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c3998d4b7a1610$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");
parcelRequire("8498I");
const $81c3998d4b7a1610$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $81c3998d4b7a1610$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $81c3998d4b7a1610$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $hQtye.default)(_ref, $81c3998d4b7a1610$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $81c3998d4b7a1610$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("8498I", function(module, exports) {

var $dTx0l = parcelRequire("dTx0l");
function $5df5c960457c6c6f$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $dTx0l.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $5df5c960457c6c6f$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $5df5c960457c6c6f$var$verify(mapStateToProps, 'mapStateToProps');
    $5df5c960457c6c6f$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $5df5c960457c6c6f$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("dTx0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1da036e0434dc00$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a1da036e0434dc00$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("jCRvh", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $e49b119ead212aa4$export$b69a785ceac019a6);

var $iBdvv = parcelRequire("iBdvv");

var $jMQJz = parcelRequire("jMQJz");

var $4tpAT = parcelRequire("4tpAT");
function $e49b119ead212aa4$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $jMQJz.wrapMapToPropsConstant)((dispatch)=>(0, $iBdvv.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $jMQJz.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $jMQJz.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $4tpAT.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("iBdvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a628f1644fbc8f$export$2e2bcd8739ae039);
function $d8a628f1644fbc8f$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("jMQJz", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $e67b67eaaa8f8c25$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $e67b67eaaa8f8c25$export$8d46c7f53c8c602f);
parcelRequire("dKlar");
function $e67b67eaaa8f8c25$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $e67b67eaaa8f8c25$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $e67b67eaaa8f8c25$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e67b67eaaa8f8c25$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e67b67eaaa8f8c25$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("dKlar", function(module, exports) {

var $4N7os = parcelRequire("4N7os");

var $dTx0l = parcelRequire("dTx0l");
function $a01ffd9f6ead941d$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $4N7os.default)(value)) (0, $dTx0l.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("4N7os", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d1793933eb7014$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $37d1793933eb7014$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("4tpAT", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $341db94dfd71b2d1$export$19ef7b929f7e2559);
function $341db94dfd71b2d1$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("ghkMh", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $bd9e59e0dbeb300f$export$e00e93951827eda7);

var $jMQJz = parcelRequire("jMQJz");

var $4tpAT = parcelRequire("4tpAT");
function $bd9e59e0dbeb300f$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $jMQJz.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $jMQJz.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $4tpAT.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("j5Zev", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $de6dfb8e4293efc0$export$17457cf6fa742f84);

var $jz4iA = parcelRequire("jz4iA");
parcelRequire("dKlar");

var $4tpAT = parcelRequire("4tpAT");
function $de6dfb8e4293efc0$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $jz4iA.default)({}, ownProps, stateProps, dispatchProps);
}
function $de6dfb8e4293efc0$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $de6dfb8e4293efc0$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$de6dfb8e4293efc0$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $de6dfb8e4293efc0$export$5b105939c84b5234(mergeProps) : (0, $4tpAT.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("21oin", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $178e855991788f74$export$d567d2b9af322f8f);

var $6FR0P = parcelRequire("6FR0P");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $178e855991788f74$var$createListenerCollection() {
    const batch = (0, $6FR0P.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $178e855991788f74$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $178e855991788f74$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $178e855991788f74$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $178e855991788f74$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $178e855991788f74$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("gP8XC", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $c3f85c29ab810158$export$700979bc83e7db82);

var $8NFma = parcelRequire("8NFma");
const $c3f85c29ab810158$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $c3f85c29ab810158$export$700979bc83e7db82 = $c3f85c29ab810158$export$71594e8a50f746f4 ? $8NFma.useLayoutEffect : $8NFma.useEffect;

});

parcelRegister("jnMAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c5dc3cf9057bfd$export$2e2bcd8739ae039);
function $e1c5dc3cf9057bfd$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e1c5dc3cf9057bfd$export$2e2bcd8739ae039(objA, objB) {
    if ($e1c5dc3cf9057bfd$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e1c5dc3cf9057bfd$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("eSoBj", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("aYjoe")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("aq5p5")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("kNYU3")).useSelector);

var $aYjoe = parcelRequire("aYjoe");

var $9Scls = parcelRequire("9Scls");

var $ehbAR = parcelRequire("ehbAR");

var $aq5p5 = parcelRequire("aq5p5");

var $kNYU3 = parcelRequire("kNYU3");

var $iabxK = parcelRequire("iabxK");

var $jnMAW = parcelRequire("jnMAW");
parcelRequire("iYEvx");

});
parcelRegister("aYjoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fce8c6c059729e2$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $ehbAR = parcelRequire("ehbAR");

var $21oin = parcelRequire("21oin");

var $gP8XC = parcelRequire("gP8XC");
function $7fce8c6c059729e2$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $8NFma.useMemo(()=>{
        const subscription = (0, $21oin.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $8NFma.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $gP8XC.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $ehbAR.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $8NFma.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $7fce8c6c059729e2$export$2e2bcd8739ae039 = $7fce8c6c059729e2$var$Provider;

});

parcelRegister("aq5p5", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $79608626729e33e4$export$8ad76b76a4c905f8);

var $ehbAR = parcelRequire("ehbAR");

var $iabxK = parcelRequire("iabxK");
function $79608626729e33e4$export$bc9b55530897c558(context = (0, $ehbAR.ReactReduxContext)) {
    const useStore = context === (0, $ehbAR.ReactReduxContext) ? (0, $iabxK.useStore) : (0, $iabxK.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $79608626729e33e4$export$8ad76b76a4c905f8 = /*#__PURE__*/ $79608626729e33e4$export$bc9b55530897c558();

});
parcelRegister("iabxK", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $d3921d6b2c67f378$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $d3921d6b2c67f378$export$6ccbb43953eebf8);

var $ehbAR = parcelRequire("ehbAR");

var $eQjyW = parcelRequire("eQjyW");
function $d3921d6b2c67f378$export$671dba69185d0304(context = (0, $ehbAR.ReactReduxContext)) {
    const useReduxContext = context === (0, $ehbAR.ReactReduxContext) ? (0, $eQjyW.useReduxContext) : (0, $eQjyW.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $d3921d6b2c67f378$export$6ccbb43953eebf8 = /*#__PURE__*/ $d3921d6b2c67f378$export$671dba69185d0304();

});


parcelRegister("iYEvx", function(module, exports) {

});



parcelRegister("1eMPm", function(module, exports) {

$parcel$export(module.exports, "PersistGate", () => $0e6cf95db9b74fea$export$311ca220e7478cda);

var $8NFma = parcelRequire("8NFma");
function $0e6cf95db9b74fea$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0e6cf95db9b74fea$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0e6cf95db9b74fea$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0e6cf95db9b74fea$var$_typeof(obj);
}
function $0e6cf95db9b74fea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0e6cf95db9b74fea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0e6cf95db9b74fea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0e6cf95db9b74fea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0e6cf95db9b74fea$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0e6cf95db9b74fea$var$_possibleConstructorReturn(self, call) {
    if (call && ($0e6cf95db9b74fea$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $0e6cf95db9b74fea$var$_assertThisInitialized(self);
}
function $0e6cf95db9b74fea$var$_getPrototypeOf(o) {
    $0e6cf95db9b74fea$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0e6cf95db9b74fea$var$_getPrototypeOf(o);
}
function $0e6cf95db9b74fea$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0e6cf95db9b74fea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0e6cf95db9b74fea$var$_setPrototypeOf(subClass, superClass);
}
function $0e6cf95db9b74fea$var$_setPrototypeOf(o, p) {
    $0e6cf95db9b74fea$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e6cf95db9b74fea$var$_setPrototypeOf(o, p);
}
function $0e6cf95db9b74fea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0e6cf95db9b74fea$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $0e6cf95db9b74fea$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $0e6cf95db9b74fea$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0e6cf95db9b74fea$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $0e6cf95db9b74fea$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $0e6cf95db9b74fea$var$_defineProperty($0e6cf95db9b74fea$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $0e6cf95db9b74fea$var$_defineProperty($0e6cf95db9b74fea$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $0e6cf95db9b74fea$var$_defineProperty($0e6cf95db9b74fea$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $0e6cf95db9b74fea$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $8NFma.PureComponent));
$0e6cf95db9b74fea$var$_defineProperty($0e6cf95db9b74fea$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});

});

parcelRegister("atQuX", function(module, exports) {

$parcel$export(module.exports, "client", () => $75a06611d1d13955$export$388e0302ca0d9a41);

var $aSGvq = parcelRequire("aSGvq");
var $b4pd8 = parcelRequire("b4pd8");

var $ME7ho = parcelRequire("ME7ho");
let $75a06611d1d13955$var$baseUrl;
const $75a06611d1d13955$var$baseOrigin = window.location.origin;
if ((0, $ME7ho.config).mode === 'DEV') $75a06611d1d13955$var$baseUrl = `${(0, $ME7ho.config).baseUrl}`;
else if ($75a06611d1d13955$var$baseOrigin.includes('atunwadigital.com')) $75a06611d1d13955$var$baseUrl = `${window.location.origin}/graphql`;
else $75a06611d1d13955$var$baseUrl = 'https://amp.atunwadigital.com/graphql';
const $75a06611d1d13955$export$388e0302ca0d9a41 = new (0, $aSGvq.ApolloClient)({
    uri: $75a06611d1d13955$var$baseUrl,
    cache: new (0, $b4pd8.InMemoryCache)()
});

});
parcelRegister("aSGvq", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", () => $7ebfeb54385b6a36$export$13f5a5f0f1dbab88);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $dDbEd = parcelRequire("dDbEd");
var $962JL = parcelRequire("962JL");

var $33x5Q = parcelRequire("33x5Q");

var $1lYxC = parcelRequire("1lYxC");

var $eM6nG = parcelRequire("eM6nG");

var $3K6Qm = parcelRequire("3K6Qm");

var $9Hpdo = parcelRequire("9Hpdo");
var $7ebfeb54385b6a36$var$hasSuggestedDevtools = false;
var $7ebfeb54385b6a36$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $013Qw.newInvariantError)(13);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $1lYxC.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $dDbEd.ApolloLink).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $33x5Q.version);
        this.localState = new (0, $3K6Qm.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $eM6nG.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        if (!$7ebfeb54385b6a36$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $7ebfeb54385b6a36$var$hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $013Qw.invariant).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $9Hpdo.mergeOptions)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $9Hpdo.mergeOptions)(this.defaultOptions.query, options);
        (0, $013Qw.invariant)(options.fetchPolicy !== "cache-and-network", 14);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $9Hpdo.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $962JL.execute)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $013Qw.invariant).debug(15, error);
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();

});
parcelRegister("dDbEd", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", () => $9ec7f3d732285c7b$export$2fed3d61f740bc7f);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");

var $9gliM = parcelRequire("9gliM");
var $lCAL8 = parcelRequire("lCAL8");
var $2A7ot = parcelRequire("2A7ot");
function $9ec7f3d732285c7b$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $3LFQt.Observable).of();
}
function $9ec7f3d732285c7b$var$toLink(handler) {
    return typeof handler === "function" ? new $9ec7f3d732285c7b$export$2fed3d61f740bc7f(handler) : handler;
}
function $9ec7f3d732285c7b$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $9ec7f3d732285c7b$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $3LFQt.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($9ec7f3d732285c7b$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $9ec7f3d732285c7b$var$toLink(left);
        var rightLink = $9ec7f3d732285c7b$var$toLink(right || new ApolloLink($9ec7f3d732285c7b$var$passthrough));
        if ($9ec7f3d732285c7b$var$isTerminating(leftLink) && $9ec7f3d732285c7b$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $3LFQt.Observable).of() : rightLink.request(operation) || (0, $3LFQt.Observable).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $3LFQt.Observable).of() : rightLink.request(operation, forward) || (0, $3LFQt.Observable).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $9gliM.createOperation)(operation.context, (0, $lCAL8.transformOperation)((0, $2A7ot.validateOperation)(operation)))) || (0, $3LFQt.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $9ec7f3d732285c7b$var$toLink(first);
        if ($9ec7f3d732285c7b$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(33, firstLink);
            return firstLink;
        }
        var nextLink = $9ec7f3d732285c7b$var$toLink(second);
        if ($9ec7f3d732285c7b$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $3LFQt.Observable).of();
            }) || (0, $3LFQt.Observable).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $3LFQt.Observable).of();
            }) || (0, $3LFQt.Observable).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($9ec7f3d732285c7b$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $013Qw.newInvariantError)(34);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("6ucBc", function(module, exports) {

$parcel$export(module.exports, "Observable", () => (parcelRequire("3LFQt")).Observable);

var $3LFQt = parcelRequire("3LFQt");
parcelRequire("5pegU");
var $4b8f51561f15b678$var$prototype = (0, $3LFQt.Observable).prototype;
var $4b8f51561f15b678$var$fakeObsSymbol = "@@observable";
if (!$4b8f51561f15b678$var$prototype[$4b8f51561f15b678$var$fakeObsSymbol]) $4b8f51561f15b678$var$prototype[$4b8f51561f15b678$var$fakeObsSymbol] = function() {
    return this;
};

});
parcelRegister("3LFQt", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $2be6387a1c8e7847$export$77cea355fa80b5f4);
function $2be6387a1c8e7847$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2be6387a1c8e7847$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2be6387a1c8e7847$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2be6387a1c8e7847$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2be6387a1c8e7847$var$_arrayLikeToArray(o, minLen);
}
function $2be6387a1c8e7847$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2be6387a1c8e7847$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2be6387a1c8e7847$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2be6387a1c8e7847$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2be6387a1c8e7847$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $2be6387a1c8e7847$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $2be6387a1c8e7847$var$hasSymbol = function(name) {
    return $2be6387a1c8e7847$var$hasSymbols() && Boolean(Symbol[name]);
};
var $2be6387a1c8e7847$var$getSymbol = function(name) {
    return $2be6387a1c8e7847$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($2be6387a1c8e7847$var$hasSymbols() && !$2be6387a1c8e7847$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $2be6387a1c8e7847$var$SymbolIterator = $2be6387a1c8e7847$var$getSymbol('iterator');
var $2be6387a1c8e7847$var$SymbolObservable = $2be6387a1c8e7847$var$getSymbol('observable');
var $2be6387a1c8e7847$var$SymbolSpecies = $2be6387a1c8e7847$var$getSymbol('species'); // === Abstract Operations ===
function $2be6387a1c8e7847$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $2be6387a1c8e7847$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$2be6387a1c8e7847$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $2be6387a1c8e7847$export$77cea355fa80b5f4;
}
function $2be6387a1c8e7847$var$isObservable(x) {
    return x instanceof $2be6387a1c8e7847$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $2be6387a1c8e7847$var$hostReportError(e) {
    if ($2be6387a1c8e7847$var$hostReportError.log) $2be6387a1c8e7847$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $2be6387a1c8e7847$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $2be6387a1c8e7847$var$hostReportError(e);
        }
    });
}
function $2be6387a1c8e7847$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $2be6387a1c8e7847$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $2be6387a1c8e7847$var$hostReportError(e);
    }
}
function $2be6387a1c8e7847$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $2be6387a1c8e7847$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $2be6387a1c8e7847$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $2be6387a1c8e7847$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $2be6387a1c8e7847$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $2be6387a1c8e7847$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $2be6387a1c8e7847$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $2be6387a1c8e7847$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $2be6387a1c8e7847$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $2be6387a1c8e7847$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $2be6387a1c8e7847$var$enqueue(function() {
            return $2be6387a1c8e7847$var$flushSubscription(subscription);
        });
        return;
    }
    $2be6387a1c8e7847$var$notifySubscription(subscription, type, value);
}
var $2be6387a1c8e7847$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $2be6387a1c8e7847$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $2be6387a1c8e7847$var$closeSubscription(this);
            $2be6387a1c8e7847$var$cleanupSubscription(this);
        }
    };
    $2be6387a1c8e7847$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $2be6387a1c8e7847$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $2be6387a1c8e7847$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $2be6387a1c8e7847$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $2be6387a1c8e7847$var$onNotify(this._subscription, 'complete');
    };
    $2be6387a1c8e7847$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $2be6387a1c8e7847$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $2be6387a1c8e7847$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2be6387a1c8e7847$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2be6387a1c8e7847$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2be6387a1c8e7847$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $2be6387a1c8e7847$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2be6387a1c8e7847$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$2be6387a1c8e7847$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $2be6387a1c8e7847$var$getMethod(x, $2be6387a1c8e7847$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($2be6387a1c8e7847$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($2be6387a1c8e7847$var$hasSymbol('iterator')) {
            method = $2be6387a1c8e7847$var$getMethod(x, $2be6387a1c8e7847$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $2be6387a1c8e7847$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $2be6387a1c8e7847$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $2be6387a1c8e7847$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $2be6387a1c8e7847$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $2be6387a1c8e7847$var$_createClass(Observable, null, [
        {
            key: $2be6387a1c8e7847$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($2be6387a1c8e7847$var$hasSymbols()) Object.defineProperty($2be6387a1c8e7847$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $2be6387a1c8e7847$var$SymbolObservable,
        hostReportError: $2be6387a1c8e7847$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("5pegU", function(module, exports) {
/* global window */ 
var $9zJPz = parcelRequire("9zJPz");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $9zJPz.default)(root);
var $3efa5b9e7c4f9356$export$2e2bcd8739ae039 = result;

});
parcelRegister("9zJPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8aeef5d23ad0c5$export$2e2bcd8739ae039);
function $6f8aeef5d23ad0c5$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("9gliM", function(module, exports) {

$parcel$export(module.exports, "createOperation", () => $6be621cf36871f3d$export$f29bedd62f56fcb2);

var $gztBd = parcelRequire("gztBd");
function $6be621cf36871f3d$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $gztBd.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), next(context));
        else context = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $gztBd.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("lCAL8", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $fbd9a931fc2518ea$export$4f3f7df1b558c729);

var $kQxgw = parcelRequire("kQxgw");
function $fbd9a931fc2518ea$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $kQxgw.getOperationName)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}

});
parcelRegister("kQxgw", function(module, exports) {

$parcel$export(module.exports, "checkDocument", () => $f2d277d3b1c65317$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $f2d277d3b1c65317$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $f2d277d3b1c65317$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $f2d277d3b1c65317$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $f2d277d3b1c65317$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getFragmentDefinition", () => $f2d277d3b1c65317$export$772111caef41b3f5);
$parcel$export(module.exports, "getMainDefinition", () => $f2d277d3b1c65317$export$f431198736b7f96d);
$parcel$export(module.exports, "getDefaultValues", () => $f2d277d3b1c65317$export$84c19026e616569e);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $fpDPU = parcelRequire("fpDPU");
function $f2d277d3b1c65317$export$a7d0d8111d2386df(doc) {
    (0, $013Qw.invariant)(doc && doc.kind === "Document", 71);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $013Qw.newInvariantError)(72, definition.kind);
        return definition;
    });
    (0, $013Qw.invariant)(operations.length <= 1, 73, operations.length);
    return doc;
}
function $f2d277d3b1c65317$export$7a5b1fa979d2c158(doc) {
    $f2d277d3b1c65317$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $f2d277d3b1c65317$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $f2d277d3b1c65317$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $f2d277d3b1c65317$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $f2d277d3b1c65317$export$7a5b1fa979d2c158(doc);
    (0, $013Qw.invariant)(queryDef && queryDef.operation === "query", 74);
    return queryDef;
}
function $f2d277d3b1c65317$export$772111caef41b3f5(doc) {
    (0, $013Qw.invariant)(doc.kind === "Document", 75);
    (0, $013Qw.invariant)(doc.definitions.length <= 1, 76);
    var fragmentDef = doc.definitions[0];
    (0, $013Qw.invariant)(fragmentDef.kind === "FragmentDefinition", 77);
    return fragmentDef;
}
function $f2d277d3b1c65317$export$f431198736b7f96d(queryDoc) {
    $f2d277d3b1c65317$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $013Qw.newInvariantError)(78);
}
function $f2d277d3b1c65317$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $fpDPU.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("fpDPU", function(module, exports) {

$parcel$export(module.exports, "makeReference", () => $b388177190ce6014$export$634ae0e932e9be99);
$parcel$export(module.exports, "isReference", () => $b388177190ce6014$export$fa99cac1c0883c47);
$parcel$export(module.exports, "isDocumentNode", () => $b388177190ce6014$export$540432d49fcec6c9);
$parcel$export(module.exports, "valueToObjectRepresentation", () => $b388177190ce6014$export$a1dab82d368d6525);
$parcel$export(module.exports, "storeKeyNameFromField", () => $b388177190ce6014$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $b388177190ce6014$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $b388177190ce6014$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $b388177190ce6014$export$7d1ad22471852218);
$parcel$export(module.exports, "getTypenameFromResult", () => $b388177190ce6014$export$cf7bf7e4f289cc26);
$parcel$export(module.exports, "isField", () => $b388177190ce6014$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $b388177190ce6014$export$22a1cdafaf27bcff);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $7jBZQ = parcelRequire("7jBZQ");

var $dQg2Z = parcelRequire("dQg2Z");
function $b388177190ce6014$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $b388177190ce6014$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $b388177190ce6014$export$540432d49fcec6c9(value) {
    return (0, $7jBZQ.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $b388177190ce6014$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $b388177190ce6014$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $b388177190ce6014$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $b388177190ce6014$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $b388177190ce6014$var$isVariable(value) {
    return value.kind === "Variable";
}
function $b388177190ce6014$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $b388177190ce6014$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $b388177190ce6014$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $b388177190ce6014$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $b388177190ce6014$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($b388177190ce6014$var$isIntValue(value) || $b388177190ce6014$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($b388177190ce6014$var$isBooleanValue(value) || $b388177190ce6014$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($b388177190ce6014$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $b388177190ce6014$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($b388177190ce6014$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($b388177190ce6014$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $b388177190ce6014$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($b388177190ce6014$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($b388177190ce6014$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $013Qw.newInvariantError)(79, name.value, value.kind);
}
function $b388177190ce6014$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $b388177190ce6014$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $b388177190ce6014$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $b388177190ce6014$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $b388177190ce6014$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
var $b388177190ce6014$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($b388177190ce6014$var$stringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = $b388177190ce6014$var$stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($b388177190ce6014$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($b388177190ce6014$var$stringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $b388177190ce6014$var$stringify;
        $b388177190ce6014$var$stringify = s;
        return previous;
    }
});
var $b388177190ce6014$var$stringify = function defaultStringify(value) {
    return JSON.stringify(value, $b388177190ce6014$var$stringifyReplacer);
};
function $b388177190ce6014$var$stringifyReplacer(_key, value) {
    if ((0, $7jBZQ.isNonNullObject)(value) && !Array.isArray(value)) value = Object.keys(value).sort().reduce(function(copy, key) {
        copy[key] = value[key];
        return copy;
    }, {});
    return value;
}
function $b388177190ce6014$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $b388177190ce6014$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $b388177190ce6014$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $b388177190ce6014$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($b388177190ce6014$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$b388177190ce6014$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $b388177190ce6014$export$cf7bf7e4f289cc26(result, (0, $dQg2Z.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $b388177190ce6014$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $b388177190ce6014$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}

});
parcelRegister("7jBZQ", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", () => $5537c8132578479e$export$417207af72fad9c9);
function $5537c8132578479e$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $5537c8132578479e$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});

parcelRegister("dQg2Z", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", () => $a13c94568f5e6715$export$abbf37c7cf644e41);
$parcel$export(module.exports, "createFragmentMap", () => $a13c94568f5e6715$export$193789b4c8246dd4);
$parcel$export(module.exports, "getFragmentFromSelection", () => $a13c94568f5e6715$export$f80bdb85f299186);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
function $a13c94568f5e6715$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw (0, $013Qw.newInvariantError)(68, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        (0, $013Qw.invariant)(fragments.length === 1, 69, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, document), {
        definitions: (0, $gztBd.__spreadArray)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $a13c94568f5e6715$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $a13c94568f5e6715$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $013Qw.invariant)(fragment, 70, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}

});




parcelRegister("2A7ot", function(module, exports) {

$parcel$export(module.exports, "validateOperation", () => $1e14adcce52b5065$export$a92a48117d546c9);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
function $1e14adcce52b5065$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $013Qw.newInvariantError)(41, key);
    }
    return operation;
}

});


parcelRegister("962JL", function(module, exports) {

$parcel$export(module.exports, "execute", () => $69f6cc1e97218945$export$51396ec711da548b);

var $dDbEd = parcelRequire("dDbEd");
var $69f6cc1e97218945$export$51396ec711da548b = (0, $dDbEd.ApolloLink).execute;

});

parcelRegister("1lYxC", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $0fc6b6d26c07cd5c$export$f4bbf1aec241cc1);

var $gztBd = parcelRequire("gztBd");

var $dDbEd = parcelRequire("dDbEd");

var $9k46e = parcelRequire("9k46e");
var $0fc6b6d26c07cd5c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $gztBd.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $9k46e.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $dDbEd.ApolloLink));

});
parcelRegister("9k46e", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", () => $6c992965bb1ce098$export$95180a16573d6675);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $dDbEd = parcelRequire("dDbEd");

var $kQxgw = parcelRequire("kQxgw");
var $bgnw1 = parcelRequire("bgnw1");parcelRequire("1Q1zr");
var $7jWjX = parcelRequire("7jWjX");parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");
var $2Pgju = parcelRequire("2Pgju");

var $5ZIUg = parcelRequire("5ZIUg");

var $dp60A = parcelRequire("dp60A");

var $cezQn = parcelRequire("cezQn");

var $6whpl = parcelRequire("6whpl");

var $tkfvi = parcelRequire("tkfvi");

var $YbJyt = parcelRequire("YbJyt");

var $jIFXV = parcelRequire("jIFXV");
var $f1egm = parcelRequire("f1egm");
var $6c992965bb1ce098$var$backupFetch = (0, $7jWjX.maybe)(function() {
    return fetch;
});
var $6c992965bb1ce098$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $tkfvi.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $gztBd.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) (0, $6whpl.checkFetcher)(preferredFetch || $6c992965bb1ce098$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $dDbEd.ApolloLink)(function(operation) {
        var chosenURI = (0, $dp60A.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $bgnw1.hasDirectives)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $2Pgju.removeClientSetsFromDocument)(operation.query);
            if (!transformedQuery) return (0, $f1egm.fromError)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        var _b = (0, $tkfvi.selectHttpOptionsAndBodyInternal)(operation, print, (0, $tkfvi.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $jIFXV.filterOperationVariables)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $kQxgw.getMainDefinition)(operation.query));
        var hasDefer = (0, $bgnw1.hasDirectives)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(36);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $YbJyt.rewriteURIForGET)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $f1egm.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $5ZIUg.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, $f1egm.fromError)(parseError);
        }
        return new (0, $3LFQt.Observable)(function(observer) {
            var currentFetch = preferredFetch || (0, $7jWjX.maybe)(function() {
                return fetch;
            }) || $6c992965bb1ce098$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $cezQn.readMultipartBody)(response, observerNext);
                else return (0, $cezQn.parseAndCheckHttpResponse)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $cezQn.handleError)(err, observer);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("bgnw1", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", () => $83336e06d48e9800$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $83336e06d48e9800$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $83336e06d48e9800$export$8d1e9e5bbfa5d09a);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $1H8ag = parcelRequire("1H8ag");
function $83336e06d48e9800$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $83336e06d48e9800$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $013Qw.invariant)(evaledValue !== void 0, 64, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $83336e06d48e9800$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $1H8ag.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $83336e06d48e9800$export$528b5e7d8ba07fbf = function(names, root) {
    return $83336e06d48e9800$export$2dafb573e282fe8d(names, root, false);
};
var $83336e06d48e9800$export$ad1b63b26c1a9b76 = function(names, root) {
    return $83336e06d48e9800$export$2dafb573e282fe8d(names, root, true);
};
function $83336e06d48e9800$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $1H8ag.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $1H8ag.BREAK;
        }
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $83336e06d48e9800$export$8d1e9e5bbfa5d09a(document) {
    return document && $83336e06d48e9800$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $83336e06d48e9800$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $83336e06d48e9800$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$83336e06d48e9800$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $013Qw.invariant)(directiveArguments && directiveArguments.length === 1, 65, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $013Qw.invariant)(ifArgument.name && ifArgument.name.value === "if", 66, directiveName);
        var ifValue = ifArgument.value;
        (0, $013Qw.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 67, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

});
parcelRegister("1H8ag", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $5b314d72cd5fda48$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $5b314d72cd5fda48$export$bf638b60ea8b89b7);

var $2wPtt = parcelRequire("2wPtt");

var $hWhti = parcelRequire("hWhti");

var $7ywRz = parcelRequire("7ywRz");

var $hHVLB = parcelRequire("hHVLB");
const $5b314d72cd5fda48$export$a89c95c098ac2a58 = Object.freeze({});
function $5b314d72cd5fda48$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $7ywRz.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $hHVLB.Kind)))enterLeaveMap.set(kind, $5b314d72cd5fda48$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $7ywRz.isNode)(node) || (0, $2wPtt.devAssert)(false, `Invalid AST Node: ${(0, $hWhti.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $5b314d72cd5fda48$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $7ywRz.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $5b314d72cd5fda48$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $hHVLB.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $5b314d72cd5fda48$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $5b314d72cd5fda48$export$a89c95c098ac2a58) skipping[i] = $5b314d72cd5fda48$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $5b314d72cd5fda48$export$a89c95c098ac2a58) skipping[i] = $5b314d72cd5fda48$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $5b314d72cd5fda48$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $5b314d72cd5fda48$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $5b314d72cd5fda48$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("2wPtt", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $34b01444e3f50510$export$b6cb5906f04696c8);
function $34b01444e3f50510$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("hWhti", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $87816c05f8bc32b9$export$9dec5d1b3b6a130d);
const $87816c05f8bc32b9$var$MAX_ARRAY_LENGTH = 10;
const $87816c05f8bc32b9$var$MAX_RECURSIVE_DEPTH = 2;
function $87816c05f8bc32b9$export$9dec5d1b3b6a130d(value) {
    return $87816c05f8bc32b9$var$formatValue(value, []);
}
function $87816c05f8bc32b9$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $87816c05f8bc32b9$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $87816c05f8bc32b9$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($87816c05f8bc32b9$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $87816c05f8bc32b9$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $87816c05f8bc32b9$var$formatArray(value, seenValues);
    return $87816c05f8bc32b9$var$formatObject(value, seenValues);
}
function $87816c05f8bc32b9$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $87816c05f8bc32b9$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $87816c05f8bc32b9$var$MAX_RECURSIVE_DEPTH) return '[' + $87816c05f8bc32b9$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $87816c05f8bc32b9$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $87816c05f8bc32b9$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $87816c05f8bc32b9$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($87816c05f8bc32b9$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($87816c05f8bc32b9$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $87816c05f8bc32b9$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("7ywRz", function(module, exports) {

$parcel$export(module.exports, "Location", () => $ecc889ad2ba38890$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $ecc889ad2ba38890$export$50792b0e93539fde);
$parcel$export(module.exports, "QueryDocumentKeys", () => $ecc889ad2ba38890$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $ecc889ad2ba38890$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "OperationTypeNode", () => $ecc889ad2ba38890$export$f58c50edb4aef9d4);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $ecc889ad2ba38890$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $ecc889ad2ba38890$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $ecc889ad2ba38890$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $ecc889ad2ba38890$var$kindValues = new Set(Object.keys($ecc889ad2ba38890$export$4fcd777a40ccf407));
function $ecc889ad2ba38890$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $ecc889ad2ba38890$var$kindValues.has(maybeKind);
}
/** Name */ var $ecc889ad2ba38890$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($ecc889ad2ba38890$export$f58c50edb4aef9d4 || ($ecc889ad2ba38890$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("hHVLB", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $d97bc7149e91d740$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $d97bc7149e91d740$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($d97bc7149e91d740$export$a84bdc57c5122798 || ($d97bc7149e91d740$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});



parcelRegister("2Pgju", function(module, exports) {

$parcel$export(module.exports, "removeDirectivesFromDocument", () => $20ecffafd7deb557$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $20ecffafd7deb557$export$43b332f87950a467);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $20ecffafd7deb557$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $20ecffafd7deb557$export$8eae69e876ee321e);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $hHVLB = parcelRequire("hHVLB");
var $1H8ag = parcelRequire("1H8ag");

var $kQxgw = parcelRequire("kQxgw");

var $fpDPU = parcelRequire("fpDPU");

var $dQg2Z = parcelRequire("dQg2Z");

var $7qkJh = parcelRequire("7qkJh");
var $20ecffafd7deb557$var$TYPENAME_FIELD = {
    kind: (0, $hHVLB.Kind).FIELD,
    name: {
        kind: (0, $hHVLB.Kind).NAME,
        value: "__typename"
    }
};
function $20ecffafd7deb557$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $hHVLB.Kind).FRAGMENT_SPREAD && $20ecffafd7deb557$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $20ecffafd7deb557$var$nullIfDocIsEmpty(doc) {
    return $20ecffafd7deb557$var$isEmpty((0, $kQxgw.getOperationDefinition)(doc) || (0, $kQxgw.getFragmentDefinition)(doc), (0, $dQg2Z.createFragmentMap)((0, $kQxgw.getFragmentDefinitions)(doc))) ? null : doc;
}
function $20ecffafd7deb557$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $20ecffafd7deb557$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $20ecffafd7deb557$export$e5ae0530da5fe96c(directives, doc) {
    (0, $kQxgw.checkDocument)(doc);
    var getInUseByOperationName = $20ecffafd7deb557$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $20ecffafd7deb557$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $7qkJh.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, $hHVLB.Kind).OPERATION_DEFINITION) return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $hHVLB.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $013Qw.invariant).error(80);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $hHVLB.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $20ecffafd7deb557$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $7qkJh.isNonEmptyArray)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $1H8ag.visit)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) return node;
                if (operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $hHVLB.Kind).FIELD && selection.name.value === "__typename";
                })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) return doc;
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $hHVLB.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $hHVLB.Kind).FRAGMENT_DEFINITION && operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    allFragmentNamesUsed.forEach(function(fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!(!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $20ecffafd7deb557$var$nullIfDocIsEmpty((0, $1H8ag.visit)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $20ecffafd7deb557$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $1H8ag.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === (0, $hHVLB.Kind).OPERATION_DEFINITION) return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $fpDPU.isField)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $fpDPU.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, node), {
                    selections: (0, $gztBd.__spreadArray)((0, $gztBd.__spreadArray)([], selections, true), [
                        $20ecffafd7deb557$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $20ecffafd7deb557$var$TYPENAME_FIELD;
    }
});
var $20ecffafd7deb557$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(81);
        }
        return willRemove;
    }
};
function $20ecffafd7deb557$export$74985f3324559867(doc) {
    return $20ecffafd7deb557$export$e5ae0530da5fe96c([
        $20ecffafd7deb557$var$connectionRemoveConfig
    ], (0, $kQxgw.checkDocument)(doc));
}
function $20ecffafd7deb557$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $20ecffafd7deb557$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $20ecffafd7deb557$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $fpDPU.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($20ecffafd7deb557$var$getDirectiveMatcher(directives)) || nestedCheck && $20ecffafd7deb557$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $20ecffafd7deb557$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $hHVLB.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $20ecffafd7deb557$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $20ecffafd7deb557$var$getArgumentMatcher(config);
    return $20ecffafd7deb557$var$nullIfDocIsEmpty((0, $1H8ag.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $20ecffafd7deb557$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $20ecffafd7deb557$var$nullIfDocIsEmpty((0, $1H8ag.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $20ecffafd7deb557$export$57c368c23873f32b(document) {
    var definition = (0, $kQxgw.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, $1H8ag.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $20ecffafd7deb557$export$8eae69e876ee321e(document) {
    (0, $kQxgw.checkDocument)(document);
    var modifiedDoc = $20ecffafd7deb557$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}

});
parcelRegister("7qkJh", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $567b0a851db9ce84$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNonEmptyArray", () => $567b0a851db9ce84$export$d307f5934e447d0e);
var $567b0a851db9ce84$export$43bee75e5e14138e = Array.isArray;
function $567b0a851db9ce84$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("5ZIUg", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", () => $45d57bbf05f73c56$export$5f8e80ac52052e28);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
var $45d57bbf05f73c56$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $013Qw.newInvariantError)(37, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("dp60A", function(module, exports) {

$parcel$export(module.exports, "selectURI", () => $9c22454ad254be19$export$63ccc2571850f81a);
var $9c22454ad254be19$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

});

parcelRegister("cezQn", function(module, exports) {

$parcel$export(module.exports, "readMultipartBody", () => $8e8298abd1b48bc1$export$ccb60864026baf09);
$parcel$export(module.exports, "handleError", () => $8e8298abd1b48bc1$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $8e8298abd1b48bc1$export$d4051215bea0639f);

var $gztBd = parcelRequire("gztBd");

var $gAotm = parcelRequire("gAotm");

var $7b92G = parcelRequire("7b92G");

var $luPKN = parcelRequire("luPKN");

var $i2zd7 = parcelRequire("i2zd7");
var $8e8298abd1b48bc1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8e8298abd1b48bc1$export$ccb60864026baf09(response, nextValue) {
    var _a;
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0, $gztBd.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $gAotm.responseIterator)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        iterator.next()
                    ];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $8e8298abd1b48bc1$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $8e8298abd1b48bc1$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $i2zd7.isApolloPayloadResult)(result)) {
                                    next = {};
                                    if ("payload" in result) next = (0, $gztBd.__assign)({}, result.payload);
                                    if ("errors" in result) next = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, next), {
                                        extensions: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, "extensions" in next ? next.extensions : null), (_d = {}, _d[0, $luPKN.PROTOCOL_ERRORS_SYMBOL] = result.errors, _d))
                                    });
                                    nextValue(next);
                                } else nextValue(result);
                            } else if (Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
}
function $8e8298abd1b48bc1$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $8e8298abd1b48bc1$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $7b92G.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $8e8298abd1b48bc1$export$d3da1ecaf1206c58(err, observer) {
    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
    observer.error(err);
}
function $8e8298abd1b48bc1$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $8e8298abd1b48bc1$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (response.status >= 300) (0, $7b92G.throwServerError)(response, result, "Response not successful: Received status code ".concat(response.status));
            if (!Array.isArray(result) && !$8e8298abd1b48bc1$var$hasOwnProperty.call(result, "data") && !$8e8298abd1b48bc1$var$hasOwnProperty.call(result, "errors")) (0, $7b92G.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

});
parcelRegister("gAotm", function(module, exports) {

$parcel$export(module.exports, "responseIterator", () => $c132fde3e41e6604$export$7e4ac9ed9577f145);

var $1w01O = parcelRequire("1w01O");

var $9rJIe = parcelRequire("9rJIe");

var $kMjZF = parcelRequire("kMjZF");

var $cX18H = parcelRequire("cX18H");

var $lkFDO = parcelRequire("lkFDO");
function $c132fde3e41e6604$var$isNodeResponse(value) {
    return !!value.body;
}
function $c132fde3e41e6604$var$isReadableStream(value) {
    return !!value.getReader;
}
function $c132fde3e41e6604$var$isAsyncIterableIterator(value) {
    return !!((0, $1w01O.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function $c132fde3e41e6604$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $c132fde3e41e6604$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $c132fde3e41e6604$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $c132fde3e41e6604$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($c132fde3e41e6604$var$isNodeResponse(response)) body = response.body;
    if ($c132fde3e41e6604$var$isAsyncIterableIterator(body)) return (0, $9rJIe.default)(body);
    if ($c132fde3e41e6604$var$isReadableStream(body)) return (0, $lkFDO.default)(body.getReader());
    if ($c132fde3e41e6604$var$isStreamableBlob(body)) return (0, $lkFDO.default)(body.stream().getReader());
    if ($c132fde3e41e6604$var$isBlob(body)) return (0, $cX18H.default)(body.arrayBuffer());
    if ($c132fde3e41e6604$var$isNodeReadableStream(body)) return (0, $kMjZF.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

});
parcelRegister("9rJIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0a1835b91e7ed9$export$2e2bcd8739ae039);
function $6e0a1835b91e7ed9$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

});

parcelRegister("kMjZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f207ccac2686ac02$export$2e2bcd8739ae039);

var $1w01O = parcelRequire("1w01O");
function $f207ccac2686ac02$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $1w01O.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("cX18H", function(module, exports) {

$parcel$export(module.exports, "default", () => $96dbe0f48beb835f$export$2e2bcd8739ae039);

var $1w01O = parcelRequire("1w01O");
function $96dbe0f48beb835f$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $1w01O.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("lkFDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87bc449df31690a$export$2e2bcd8739ae039);

var $1w01O = parcelRequire("1w01O");
function $f87bc449df31690a$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $1w01O.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});


parcelRegister("7b92G", function(module, exports) {

$parcel$export(module.exports, "throwServerError", () => $53a0931aa17b61f8$export$c33ef9219f27efd7);
var $53a0931aa17b61f8$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});

parcelRegister("luPKN", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ERRORS_SYMBOL", () => $fa648b8a9a52e44b$export$4995664c1b49842e);
$parcel$export(module.exports, "graphQLResultHasProtocolErrors", () => $fa648b8a9a52e44b$export$345f95cc6b6b9b0b);
$parcel$export(module.exports, "isApolloError", () => $fa648b8a9a52e44b$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $fa648b8a9a52e44b$export$26a337512320b8c6);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");

var $7jBZQ = parcelRequire("7jBZQ");
var $fa648b8a9a52e44b$export$4995664c1b49842e = Symbol();
function $fa648b8a9a52e44b$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$fa648b8a9a52e44b$export$4995664c1b49842e]);
    return false;
}
function $fa648b8a9a52e44b$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var $fa648b8a9a52e44b$var$generateErrorMessage = function(err) {
    var errors = (0, $gztBd.__spreadArray)((0, $gztBd.__spreadArray)((0, $gztBd.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors.map(function(err) {
        return (0, $7jBZQ.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $fa648b8a9a52e44b$export$26a337512320b8c6 = function(_super) {
    (0, $gztBd.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $fa648b8a9a52e44b$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("i2zd7", function(module, exports) {

$parcel$export(module.exports, "isExecutionPatchIncrementalResult", () => $d223b9fea88ba736$export$879767c5cdf33cb3);
$parcel$export(module.exports, "isExecutionPatchResult", () => $d223b9fea88ba736$export$f90dc0a3531b8b83);
$parcel$export(module.exports, "isApolloPayloadResult", () => $d223b9fea88ba736$export$3f32b6369f408f33);
$parcel$export(module.exports, "mergeIncrementalData", () => $d223b9fea88ba736$export$9a905f57d6393874);

var $7jBZQ = parcelRequire("7jBZQ");

var $7qkJh = parcelRequire("7qkJh");

var $4quye = parcelRequire("4quye");
function $d223b9fea88ba736$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $d223b9fea88ba736$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $d223b9fea88ba736$export$f90dc0a3531b8b83(value) {
    return $d223b9fea88ba736$export$879767c5cdf33cb3(value) || $d223b9fea88ba736$export$6c17a45d8c64ff02(value);
}
function $d223b9fea88ba736$export$3f32b6369f408f33(value) {
    return (0, $7jBZQ.isNonNullObject)(value) && "payload" in value;
}
function $d223b9fea88ba736$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $4quye.DeepMerger)();
    if ($d223b9fea88ba736$export$879767c5cdf33cb3(result) && (0, $7qkJh.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

});
parcelRegister("4quye", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", () => $339149f45d08b972$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $339149f45d08b972$export$160070228be94b08);
$parcel$export(module.exports, "DeepMerger", () => $339149f45d08b972$export$509e11c221f576c0);

var $gztBd = parcelRequire("gztBd");

var $7jBZQ = parcelRequire("7jBZQ");
var $339149f45d08b972$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $339149f45d08b972$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $339149f45d08b972$export$160070228be94b08(sources);
}
function $339149f45d08b972$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $339149f45d08b972$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $339149f45d08b972$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $339149f45d08b972$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $339149f45d08b972$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $7jBZQ.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $7jBZQ.isNonNullObject)(source) && (0, $7jBZQ.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($339149f45d08b972$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $gztBd.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $7jBZQ.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $gztBd.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

});



parcelRegister("6whpl", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", () => $4bf33c0ff2d16551$export$8423f0cd3773115e);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
var $4bf33c0ff2d16551$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $013Qw.newInvariantError)(35);
};

});

parcelRegister("tkfvi", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $05826a9715da1c6e$export$dd86f00dc866e75d);
$parcel$export(module.exports, "defaultPrinter", () => $05826a9715da1c6e$export$e88934976ca4fd65);
$parcel$export(module.exports, "selectHttpOptionsAndBodyInternal", () => $05826a9715da1c6e$export$12d90ccf75844275);

var $gztBd = parcelRequire("gztBd");

var $8YVFE = parcelRequire("8YVFE");
var $05826a9715da1c6e$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $05826a9715da1c6e$var$defaultHeaders = {
    accept: "*/*",
    "content-type": "application/json"
};
var $05826a9715da1c6e$var$defaultOptions = {
    method: "POST"
};
var $05826a9715da1c6e$export$dd86f00dc866e75d = {
    http: $05826a9715da1c6e$var$defaultHttpOptions,
    headers: $05826a9715da1c6e$var$defaultHeaders,
    options: $05826a9715da1c6e$var$defaultOptions
};
var $05826a9715da1c6e$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $05826a9715da1c6e$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $05826a9715da1c6e$export$12d90ccf75844275.apply(void 0, (0, $gztBd.__spreadArray)([
        operation,
        $05826a9715da1c6e$export$e88934976ca4fd65
    ], configs, false));
}
function $05826a9715da1c6e$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), config.options), {
            headers: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $05826a9715da1c6e$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = printer(query, (0, $8YVFE.print));
    return {
        options: options,
        body: body
    };
}
function $05826a9715da1c6e$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

});
parcelRegister("8YVFE", function(module, exports) {

$parcel$export(module.exports, "print", () => $68a0a99153dad243$export$c2d084dc44961371);

var $bNwX9 = parcelRequire("bNwX9");

var $1w01O = parcelRequire("1w01O");
var $68a0a99153dad243$var$printCache = (0, $1w01O.canUseWeakMap) ? new WeakMap() : undefined;
var $68a0a99153dad243$export$c2d084dc44961371 = function(ast) {
    var result;
    result = $68a0a99153dad243$var$printCache === null || $68a0a99153dad243$var$printCache === void 0 ? void 0 : $68a0a99153dad243$var$printCache.get(ast);
    if (!result) {
        result = (0, $bNwX9.print)(ast);
        $68a0a99153dad243$var$printCache === null || $68a0a99153dad243$var$printCache === void 0 || $68a0a99153dad243$var$printCache.set(ast, result);
    }
    return result;
};

});
parcelRegister("bNwX9", function(module, exports) {

$parcel$export(module.exports, "print", () => $00c1965f52f432ef$export$c2d084dc44961371);

var $dDENo = parcelRequire("dDENo");

var $6HJJ3 = parcelRequire("6HJJ3");

var $1H8ag = parcelRequire("1H8ag");
function $00c1965f52f432ef$export$c2d084dc44961371(ast) {
    return (0, $1H8ag.visit)(ast, $00c1965f52f432ef$var$printDocASTReducer);
}
const $00c1965f52f432ef$var$MAX_LINE_LENGTH = 80;
const $00c1965f52f432ef$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$00c1965f52f432ef$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $00c1965f52f432ef$var$join([
                node.operation,
                $00c1965f52f432ef$var$join([
                    node.name,
                    varDefs
                ]),
                $00c1965f52f432ef$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $00c1965f52f432ef$var$wrap(' = ', defaultValue) + $00c1965f52f432ef$var$wrap(' ', $00c1965f52f432ef$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$00c1965f52f432ef$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $00c1965f52f432ef$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(args, ', '), ')');
            if (argsLine.length > $00c1965f52f432ef$var$MAX_LINE_LENGTH) argsLine = prefix + $00c1965f52f432ef$var$wrap('(\n', $00c1965f52f432ef$var$indent($00c1965f52f432ef$var$join(args, '\n')), '\n)');
            return $00c1965f52f432ef$var$join([
                argsLine,
                $00c1965f52f432ef$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $00c1965f52f432ef$var$wrap(' ', $00c1965f52f432ef$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$00c1965f52f432ef$var$join([
                '...',
                $00c1965f52f432ef$var$wrap('on ', typeCondition),
                $00c1965f52f432ef$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$00c1965f52f432ef$var$wrap('', $00c1965f52f432ef$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $dDENo.printBlockString)(value) : (0, $6HJJ3.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $00c1965f52f432ef$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $00c1965f52f432ef$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'schema',
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'scalar',
                name,
                $00c1965f52f432ef$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'type',
                name,
                $00c1965f52f432ef$var$wrap('implements ', $00c1965f52f432ef$var$join(interfaces, ' & ')),
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$00c1965f52f432ef$var$wrap('', description, '\n') + name + ($00c1965f52f432ef$var$hasMultilineItems(args) ? $00c1965f52f432ef$var$wrap('(\n', $00c1965f52f432ef$var$indent($00c1965f52f432ef$var$join(args, '\n')), '\n)') : $00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(args, ', '), ')')) + ': ' + type + $00c1965f52f432ef$var$wrap(' ', $00c1965f52f432ef$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                name + ': ' + type,
                $00c1965f52f432ef$var$wrap('= ', defaultValue),
                $00c1965f52f432ef$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'interface',
                name,
                $00c1965f52f432ef$var$wrap('implements ', $00c1965f52f432ef$var$join(interfaces, ' & ')),
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'union',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$wrap('= ', $00c1965f52f432ef$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'enum',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                name,
                $00c1965f52f432ef$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$00c1965f52f432ef$var$wrap('', description, '\n') + $00c1965f52f432ef$var$join([
                'input',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$00c1965f52f432ef$var$wrap('', description, '\n') + 'directive @' + name + ($00c1965f52f432ef$var$hasMultilineItems(args) ? $00c1965f52f432ef$var$wrap('(\n', $00c1965f52f432ef$var$indent($00c1965f52f432ef$var$join(args, '\n')), '\n)') : $00c1965f52f432ef$var$wrap('(', $00c1965f52f432ef$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $00c1965f52f432ef$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$00c1965f52f432ef$var$join([
                'extend schema',
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$00c1965f52f432ef$var$join([
                'extend scalar',
                name,
                $00c1965f52f432ef$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$00c1965f52f432ef$var$join([
                'extend type',
                name,
                $00c1965f52f432ef$var$wrap('implements ', $00c1965f52f432ef$var$join(interfaces, ' & ')),
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$00c1965f52f432ef$var$join([
                'extend interface',
                name,
                $00c1965f52f432ef$var$wrap('implements ', $00c1965f52f432ef$var$join(interfaces, ' & ')),
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$00c1965f52f432ef$var$join([
                'extend union',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$wrap('= ', $00c1965f52f432ef$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$00c1965f52f432ef$var$join([
                'extend enum',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$00c1965f52f432ef$var$join([
                'extend input',
                name,
                $00c1965f52f432ef$var$join(directives, ' '),
                $00c1965f52f432ef$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $00c1965f52f432ef$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $00c1965f52f432ef$var$block(array) {
    return $00c1965f52f432ef$var$wrap('{\n', $00c1965f52f432ef$var$indent($00c1965f52f432ef$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $00c1965f52f432ef$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $00c1965f52f432ef$var$indent(str) {
    return $00c1965f52f432ef$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $00c1965f52f432ef$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("dDENo", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", () => $e8d32533cecba28b$export$d5ee19b441e8d2ae);
$parcel$export(module.exports, "printBlockString", () => $e8d32533cecba28b$export$adb6ca997eeb1f45);

var $a9vjx = parcelRequire("a9vjx");
function $e8d32533cecba28b$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $e8d32533cecba28b$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $e8d32533cecba28b$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $a9vjx.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $e8d32533cecba28b$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $e8d32533cecba28b$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $a9vjx.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $a9vjx.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("a9vjx", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $fe1e55f01afa9ff5$export$3c52dd84024ae72c);
$parcel$export(module.exports, "isDigit", () => $fe1e55f01afa9ff5$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isNameStart", () => $fe1e55f01afa9ff5$export$45a677ea7cb6d5c8);
$parcel$export(module.exports, "isNameContinue", () => $fe1e55f01afa9ff5$export$d3f406ff46035894);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $fe1e55f01afa9ff5$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $fe1e55f01afa9ff5$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $fe1e55f01afa9ff5$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $fe1e55f01afa9ff5$export$45a677ea7cb6d5c8(code) {
    return $fe1e55f01afa9ff5$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $fe1e55f01afa9ff5$export$d3f406ff46035894(code) {
    return $fe1e55f01afa9ff5$export$79c5d5217943d6a7(code) || $fe1e55f01afa9ff5$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("6HJJ3", function(module, exports) {

$parcel$export(module.exports, "printString", () => $ec77a3ed94739a3d$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $ec77a3ed94739a3d$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($ec77a3ed94739a3d$var$escapedRegExp, $ec77a3ed94739a3d$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $ec77a3ed94739a3d$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $ec77a3ed94739a3d$var$escapedReplacer(str) {
    return $ec77a3ed94739a3d$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $ec77a3ed94739a3d$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});




parcelRegister("YbJyt", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", () => $0b4eb4caa0a48d79$export$fb82bb094b6f76b5);

var $5ZIUg = parcelRequire("5ZIUg");
function $0b4eb4caa0a48d79$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $5ZIUg.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $5ZIUg.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}

});

parcelRegister("jIFXV", function(module, exports) {

$parcel$export(module.exports, "filterOperationVariables", () => $e5b2add886555892$export$de246493ae27fe3f);

var $gztBd = parcelRequire("gztBd");

var $1H8ag = parcelRequire("1H8ag");
function $e5b2add886555892$export$de246493ae27fe3f(variables, query) {
    var result = (0, $gztBd.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $1H8ag.visit)(query, {
        Variable: function(node, _key, parent) {
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}

});

parcelRegister("f1egm", function(module, exports) {

$parcel$export(module.exports, "fromError", () => $aef203517fec552d$export$4fd972edbe7450d3);
parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");
function $aef203517fec552d$export$4fd972edbe7450d3(errorValue) {
    return new (0, $3LFQt.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

});



parcelRegister("eM6nG", function(module, exports) {

$parcel$export(module.exports, "QueryManager", () => $ac1a7f8930d4d2ad$export$b986383a50b53ea4);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $77T3v = parcelRequire("77T3v");

var $962JL = parcelRequire("962JL");

var $akbZP = parcelRequire("akbZP");
var $1w01O = parcelRequire("1w01O");
var $gEIbk = parcelRequire("gEIbk");
var $dC50B = parcelRequire("dC50B");
var $kQxgw = parcelRequire("kQxgw");
var $7VAEO = parcelRequire("7VAEO");
var $bgnw1 = parcelRequire("bgnw1");
var $fpDPU = parcelRequire("fpDPU");
var $i2zd7 = parcelRequire("i2zd7");
var $7qkJh = parcelRequire("7qkJh");
var $7jBZQ = parcelRequire("7jBZQ");
var $ii86D = parcelRequire("ii86D");parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");
var $8YVFE = parcelRequire("8YVFE");
var $2Pgju = parcelRequire("2Pgju");

var $2dZXC = parcelRequire("2dZXC");

var $i2zd7 = parcelRequire("i2zd7");

var $luPKN = parcelRequire("luPKN");

var $6hQZT = parcelRequire("6hQZT");

var $6l79c = parcelRequire("6l79c");

var $3K6Qm = parcelRequire("3K6Qm");

var $evUDN = parcelRequire("evUDN");
var $ac1a7f8930d4d2ad$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ac1a7f8930d4d2ad$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var _this = this;
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $1w01O.canUseWeakMap) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        var defaultDocumentTransform = new (0, $dC50B.DocumentTransform)(function(document) {
            return _this.cache.transformDocument(document);
        }, {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $3K6Qm.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform).concat(defaultDocumentTransform) : defaultDocumentTransform;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $013Qw.newInvariantError)(23));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var mutationId, hasClientExports, mutationStoreValue, self;
            return (0, $gztBd.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (0, $013Qw.invariant)(mutation, 24);
                        (0, $013Qw.invariant)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 25);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _h.sent();
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return (0, $akbZP.asyncMap)(self.getObservableFromLink(mutation, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false), function(result) {
                                    if ((0, $7VAEO.graphQLResultHasError)(result) && errorPolicy === "none") throw new (0, $luPKN.ApolloError)({
                                        graphQLErrors: (0, $7VAEO.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $gztBd.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $7VAEO.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $luPKN.ApolloError) ? err : new (0, $luPKN.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $evUDN.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, $i2zd7.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $i2zd7.isExecutionPatchIncrementalResult)(result) && (0, $7qkJh.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $i2zd7.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$ac1a7f8930d4d2ad$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $kQxgw.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    var update = mutation.update;
                    var isFinalResult = !(0, $i2zd7.isExecutionPatchResult)(result) || (0, $i2zd7.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $gztBd.__assign)((0, $gztBd.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $013Qw.invariant).error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                hasClientExports: (0, $bgnw1.hasClientExports)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $bgnw1.hasDirectives)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $2Pgju.removeDirectivesFromDocument)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $kQxgw.getDefaultValues)((0, $kQxgw.getOperationDefinition)(document)),
                asQuery: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        options = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $evUDN.QueryInfo)(this);
        var observable = new (0, $6hQZT.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $013Qw.invariant)(options.query, 26);
        (0, $013Qw.invariant)(options.query.kind === "Document", 27);
        (0, $013Qw.invariant)(!options.returnPartialData, 28);
        (0, $013Qw.invariant)(!options.pollInterval, 29);
        return this.fetchQuery(queryId, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        this.cancelPendingFetches((0, $013Qw.newInvariantError)(30));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $6l79c.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $fpDPU.isDocumentNode)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $7jBZQ.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            var queryId = (0, $ii86D.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $6hQZT.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $013Qw.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(typeof nameOrDoc === "string" ? 31 : 32, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    if ((0, $evUDN.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $7VAEO.graphQLResultHasError)(result);
                var hasProtocolErrors = (0, $luPKN.graphQLResultHasProtocolErrors)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $luPKN.PROTOCOL_ERRORS_SYMBOL];
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $luPKN.ApolloError)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $3LFQt.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $kQxgw.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $8YVFE.print)(serverQuery);
                var byVariables_1 = inFlightLinkObservables_1.get(printedServerQuery_1) || new Map();
                inFlightLinkObservables_1.set(printedServerQuery_1, byVariables_1);
                var varJson_1 = (0, $2dZXC.canonicalStringify)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $gEIbk.Concast)([
                        (0, $962JL.execute)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(printedServerQuery_1);
                    });
                }
            } else observable = new (0, $gEIbk.Concast)([
                (0, $962JL.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $gEIbk.Concast)([
                (0, $3LFQt.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $akbZP.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $akbZP.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $7VAEO.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $luPKN.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $6l79c.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $6l79c.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $luPKN.isApolloError)(networkError) ? networkError : new (0, $luPKN.ApolloError)({
                networkError: networkError
            });
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $6l79c.NetworkStatus).loading;
        var query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" && sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $gEIbk.Concast)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $gEIbk.Concast)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $ii86D.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            optimistic: optimistic && removeOptimistic || false,
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $evUDN.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) result = oq.refetch();
                        if (result !== false) results.set(oq, result);
                        return result;
                    }
                    if (onQueryUpdated !== null) includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset();
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $6l79c.NetworkStatus).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $77T3v.equal)(data, {})) (0, $6hQZT.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, $3LFQt.Observable).of((0, $gztBd.__assign)({
                    data: data,
                    loading: (0, $6l79c.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            if (errorPolicy === "none" && networkStatus === (0, $6l79c.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === (0, $6l79c.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 : 2;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $6l79c.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $evUDN.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

});
parcelRegister("77T3v", function(module, exports) {

$parcel$export(module.exports, "equal", () => $5303e4b88a2c3949$export$411ce8e5a71e3069);
$parcel$export(module.exports, "default", () => $5303e4b88a2c3949$export$2e2bcd8739ae039);
const { toString: $5303e4b88a2c3949$var$toString, hasOwnProperty: $5303e4b88a2c3949$var$hasOwnProperty } = Object.prototype;
const $5303e4b88a2c3949$var$fnToStr = Function.prototype.toString;
const $5303e4b88a2c3949$var$previousComparisons = new Map();
function $5303e4b88a2c3949$export$411ce8e5a71e3069(a, b) {
    try {
        return $5303e4b88a2c3949$var$check(a, b);
    } finally{
        $5303e4b88a2c3949$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$5303e4b88a2c3949$export$2e2bcd8739ae039 = $5303e4b88a2c3949$export$411ce8e5a71e3069;
function $5303e4b88a2c3949$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $5303e4b88a2c3949$var$toString.call(a);
    const bTag = $5303e4b88a2c3949$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($5303e4b88a2c3949$var$previouslyCompared(a, b)) return true;
                const aKeys = $5303e4b88a2c3949$var$definedKeys(a);
                const bKeys = $5303e4b88a2c3949$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$5303e4b88a2c3949$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$5303e4b88a2c3949$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($5303e4b88a2c3949$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$5303e4b88a2c3949$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $5303e4b88a2c3949$var$fnToStr.call(a);
                if (aCode !== $5303e4b88a2c3949$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$5303e4b88a2c3949$var$endsWith(aCode, $5303e4b88a2c3949$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $5303e4b88a2c3949$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($5303e4b88a2c3949$var$isDefinedKey, obj);
}
function $5303e4b88a2c3949$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $5303e4b88a2c3949$var$nativeCodeSuffix = "{ [native code] }";
function $5303e4b88a2c3949$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $5303e4b88a2c3949$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $5303e4b88a2c3949$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $5303e4b88a2c3949$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("akbZP", function(module, exports) {

$parcel$export(module.exports, "asyncMap", () => $784513d87a02d230$export$707ee4c4c95d39e3);
parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");
function $784513d87a02d230$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $3LFQt.Observable)(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                var both = function() {
                    return examiner(arg);
                };
                promiseQueue = promiseQueue.then(both, both).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(error) {
                    --activeCallbackCount;
                    throw error;
                }).catch(function(caught) {
                    error && error.call(observer, caught);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("gEIbk", function(module, exports) {

$parcel$export(module.exports, "Concast", () => $c202a75408d1e8f9$export$ae0cf2ec7a6fa78e);

var $gztBd = parcelRequire("gztBd");
parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");

var $c0HTY = parcelRequire("c0HTY");

var $fga6F = parcelRequire("fga6F");
function $c202a75408d1e8f9$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $c202a75408d1e8f9$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $gztBd.__extends)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $c0HTY.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $c0HTY.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        (0, $c0HTY.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($c202a75408d1e8f9$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, $3LFQt.Observable)(sources)
        ];
        if ($c202a75408d1e8f9$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $3LFQt.Observable));
(0, $fga6F.fixObservableSubclass)($c202a75408d1e8f9$export$ae0cf2ec7a6fa78e);

});
parcelRegister("c0HTY", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", () => $8be78a1ff61e0695$export$9f6c99ae166dbeca);
function $8be78a1ff61e0695$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("fga6F", function(module, exports) {

$parcel$export(module.exports, "fixObservableSubclass", () => $b1c030913d6409b8$export$33c8bd820eece9b2);
parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");

var $1w01O = parcelRequire("1w01O");
function $b1c030913d6409b8$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, $3LFQt.Observable)
        });
    }
    if ((0, $1w01O.canUseSymbol) && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}

});


parcelRegister("dC50B", function(module, exports) {

$parcel$export(module.exports, "DocumentTransform", () => $9e92b59be14ccb35$export$f887060e48e5dc1b);

var $1TIIy = parcelRequire("1TIIy");

var $1w01O = parcelRequire("1w01O");

var $kQxgw = parcelRequire("kQxgw");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
function $9e92b59be14ccb35$var$identity(document) {
    return document;
}
var $9e92b59be14ccb35$export$f887060e48e5dc1b = function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $1w01O.canUseWeakSet) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) this.getCacheKey = options.getCacheKey;
        if (options.cache !== false) this.stableCacheKeys = new (0, $1TIIy.Trie)((0, $1w01O.canUseWeakMap), function(key) {
            return {
                key: key
            };
        });
    }
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        return new DocumentTransform($9e92b59be14ccb35$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, {
            cache: false
        });
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        if (this.resultCache.has(document)) return document;
        var cacheEntry = this.getStableCacheEntry(document);
        if (cacheEntry && cacheEntry.value) return cacheEntry.value;
        (0, $kQxgw.checkDocument)(document);
        var transformedDocument = this.transform(document);
        this.resultCache.add(transformedDocument);
        if (cacheEntry) cacheEntry.value = transformedDocument;
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, {
            cache: false
        });
    };
    DocumentTransform.prototype.getStableCacheEntry = function(document) {
        if (!this.stableCacheKeys) return;
        var cacheKeys = this.getCacheKey(document);
        if (cacheKeys) {
            (0, $013Qw.invariant)(Array.isArray(cacheKeys), 63);
            return this.stableCacheKeys.lookupArray(cacheKeys);
        }
    };
    return DocumentTransform;
}();

});
parcelRegister("1TIIy", function(module, exports) {

$parcel$export(module.exports, "Trie", () => $161d9d81a0385458$export$73571c50d0f2507e);
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $161d9d81a0385458$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $161d9d81a0385458$var$forEach, slice: $161d9d81a0385458$var$slice } = Array.prototype;
const { hasOwnProperty: $161d9d81a0385458$var$hasOwnProperty } = Object.prototype;
class $161d9d81a0385458$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $161d9d81a0385458$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $161d9d81a0385458$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $161d9d81a0385458$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($161d9d81a0385458$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $161d9d81a0385458$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $161d9d81a0385458$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $161d9d81a0385458$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $161d9d81a0385458$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});


parcelRegister("7VAEO", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", () => $5c5a4aa7af6365bb$export$b4df399e879e53ab);
$parcel$export(module.exports, "getGraphQLErrorsFromResult", () => $5c5a4aa7af6365bb$export$a163557155188b6e);

var $7qkJh = parcelRequire("7qkJh");

var $i2zd7 = parcelRequire("i2zd7");
function $5c5a4aa7af6365bb$export$b4df399e879e53ab(result) {
    var errors = $5c5a4aa7af6365bb$export$a163557155188b6e(result);
    return (0, $7qkJh.isNonEmptyArray)(errors);
}
function $5c5a4aa7af6365bb$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $7qkJh.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $i2zd7.isExecutionPatchIncrementalResult)(result) && (0, $7qkJh.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

});

parcelRegister("2dZXC", function(module, exports) {

$parcel$export(module.exports, "ObjectCanon", () => $19ecdbc073a8798b$export$c2e7fdd82233f4a4);
$parcel$export(module.exports, "canonicalStringify", () => $19ecdbc073a8798b$export$88a0ad9b6f961b51);

var $gztBd = parcelRequire("gztBd");

var $1TIIy = parcelRequire("1TIIy");

var $1w01O = parcelRequire("1w01O");
var $7jBZQ = parcelRequire("7jBZQ");
parcelRequire("32UuX");
var $7qkJh = parcelRequire("7qkJh");
function $19ecdbc073a8798b$var$shallowCopy(value) {
    if ((0, $7jBZQ.isNonNullObject)(value)) return (0, $7qkJh.isArray)(value) ? value.slice(0) : (0, $gztBd.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
var $19ecdbc073a8798b$export$c2e7fdd82233f4a4 = function() {
    function ObjectCanon() {
        this.known = new ((0, $1w01O.canUseWeakSet) ? WeakSet : Set)();
        this.pool = new (0, $1TIIy.Trie)((0, $1w01O.canUseWeakMap));
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $7jBZQ.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $7jBZQ.isNonNullObject)(value)) {
            var copy = $19ecdbc073a8798b$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $7jBZQ.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();
var $19ecdbc073a8798b$export$88a0ad9b6f961b51 = Object.assign(function(value) {
    if ((0, $7jBZQ.isNonNullObject)(value)) {
        if ($19ecdbc073a8798b$var$stringifyCanon === void 0) $19ecdbc073a8798b$var$resetCanonicalStringify();
        var canonical = $19ecdbc073a8798b$var$stringifyCanon.admit(value);
        var json = $19ecdbc073a8798b$var$stringifyCache.get(canonical);
        if (json === void 0) $19ecdbc073a8798b$var$stringifyCache.set(canonical, json = JSON.stringify(canonical));
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: $19ecdbc073a8798b$var$resetCanonicalStringify
});
var $19ecdbc073a8798b$var$stringifyCanon;
var $19ecdbc073a8798b$var$stringifyCache;
function $19ecdbc073a8798b$var$resetCanonicalStringify() {
    $19ecdbc073a8798b$var$stringifyCanon = new $19ecdbc073a8798b$export$c2e7fdd82233f4a4();
    $19ecdbc073a8798b$var$stringifyCache = new ((0, $1w01O.canUseWeakMap) ? WeakMap : Map)();
}

});
parcelRegister("32UuX", function(module, exports) {

$parcel$export(module.exports, "hasOwn", () => $237d6260c2314564$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $237d6260c2314564$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "normalizeConfig", () => $237d6260c2314564$export$fa542f9ee3f7f4e2);
$parcel$export(module.exports, "shouldCanonizeResults", () => $237d6260c2314564$export$3ac2a95fbd99c479);
$parcel$export(module.exports, "getTypenameFromStoreObject", () => $237d6260c2314564$export$fdef206c83ff2c09);
$parcel$export(module.exports, "TypeOrFieldNameRegExp", () => $237d6260c2314564$export$6ed54d4784f1ce28);
$parcel$export(module.exports, "fieldNameFromStoreName", () => $237d6260c2314564$export$37874422037b6029);
$parcel$export(module.exports, "selectionSetMatchesResult", () => $237d6260c2314564$export$60bd1cbb09c1a4a2);
$parcel$export(module.exports, "storeValueIsStoreObject", () => $237d6260c2314564$export$4f39afca21bd938e);
$parcel$export(module.exports, "makeProcessedFieldsMerger", () => $237d6260c2314564$export$b874a818f7a2fa6d);
$parcel$export(module.exports, "extractFragmentContext", () => $237d6260c2314564$export$3a33c00f0ae4a480);
$parcel$export(module.exports, "isArray", () => (parcelRequire("7qkJh")).isArray);

var $hORxN = parcelRequire("hORxN");
var $dQg2Z = parcelRequire("dQg2Z");
var $4quye = parcelRequire("4quye");
var $kQxgw = parcelRequire("kQxgw");
var $7qkJh = parcelRequire("7qkJh");
var $fpDPU = parcelRequire("fpDPU");
var $7jBZQ = parcelRequire("7jBZQ");
var $bgnw1 = parcelRequire("bgnw1");
var $237d6260c2314564$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $237d6260c2314564$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $237d6260c2314564$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$237d6260c2314564$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$237d6260c2314564$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        if ($237d6260c2314564$export$b931b78cbb3caf86(id) && !$237d6260c2314564$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$237d6260c2314564$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $237d6260c2314564$var$defaultConfig = {
    dataIdFromObject: $237d6260c2314564$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false
};
function $237d6260c2314564$export$fa542f9ee3f7f4e2(config) {
    return (0, $hORxN.compact)($237d6260c2314564$var$defaultConfig, config);
}
function $237d6260c2314564$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $237d6260c2314564$var$defaultConfig.canonizeResults : value;
}
function $237d6260c2314564$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $fpDPU.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $237d6260c2314564$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $237d6260c2314564$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($237d6260c2314564$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $237d6260c2314564$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $7jBZQ.isNonNullObject)(result)) return (0, $7qkJh.isArray)(result) ? result.every(function(item) {
        return $237d6260c2314564$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $fpDPU.isField)(field) && (0, $bgnw1.shouldInclude)(field, variables)) {
            var key = (0, $fpDPU.resultKeyNameFromField)(field);
            return $237d6260c2314564$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $237d6260c2314564$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $237d6260c2314564$export$4f39afca21bd938e(value) {
    return (0, $7jBZQ.isNonNullObject)(value) && !(0, $fpDPU.isReference)(value) && !(0, $7qkJh.isArray)(value);
}
function $237d6260c2314564$export$b874a818f7a2fa6d() {
    return new (0, $4quye.DeepMerger)();
}
function $237d6260c2314564$export$3a33c00f0ae4a480(document, fragments) {
    var fragmentMap = (0, $dQg2Z.createFragmentMap)((0, $kQxgw.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

});
parcelRegister("hORxN", function(module, exports) {

$parcel$export(module.exports, "compact", () => $cf90a3eb212c53fb$export$8e16b83750b44988);
function $cf90a3eb212c53fb$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});



parcelRegister("6hQZT", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", () => $493d70bec1143de5$export$6c1b56eac59c9584);
$parcel$export(module.exports, "logMissingFieldErrors", () => $493d70bec1143de5$export$b7e1973aacac3ae7);
$parcel$export(module.exports, "reobserveCacheFirst", () => $493d70bec1143de5$export$419171d60552792a);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $77T3v = parcelRequire("77T3v");

var $6l79c = parcelRequire("6l79c");

var $c8Tgc = parcelRequire("c8Tgc");
var $hORxN = parcelRequire("hORxN");
var $fga6F = parcelRequire("fga6F");
var $kQxgw = parcelRequire("kQxgw");
var $c0HTY = parcelRequire("c0HTY");parcelRequire("6ucBc");
var $3LFQt = parcelRequire("3LFQt");

var $7nk6X = parcelRequire("7nk6X");
var $493d70bec1143de5$var$assign = Object.assign, $493d70bec1143de5$var$hasOwnProperty = Object.hasOwnProperty;
var $493d70bec1143de5$export$6c1b56eac59c9584 = function(_super) {
    (0, $gztBd.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $493d70bec1143de5$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            if (first) _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.waitForOwnResult = $493d70bec1143de5$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            initialFetchPolicy: initialFetchPolicy,
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $kQxgw.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $6l79c.NetworkStatus).ready;
        var result = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, lastResult), {
            loading: (0, $6l79c.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if ($493d70bec1143de5$var$skipCacheDataFor(fetchPolicy) || this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $77T3v.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                delete result.partial;
                if (diff.complete && result.networkStatus === (0, $6l79c.NetworkStatus).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $6l79c.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $493d70bec1143de5$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $7nk6X.equalByQuery)(this.query, this.last.result, newResult, this.variables) : !(0, $77T3v.equal)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $77T3v.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $77T3v.equal)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $493d70bec1143de5$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $kQxgw.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(18, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $77T3v.equal)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $6l79c.NetworkStatus).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $6l79c.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $6l79c.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $6l79c.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            if (!updatedQuerySet.has(_this.query)) $493d70bec1143de5$export$419171d60552792a(_this);
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $013Qw.invariant).error(19, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $hORxN.compact)(this.options, newOptions || {});
        $493d70bec1143de5$var$assign(this.options, mergedOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $77T3v.equal)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $6l79c.NetworkStatus).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $013Qw.invariant)(pollInterval, 20);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (!(0, $6l79c.isNetworkRequestInFlight)(_this.queryInfo.networkStatus)) _this.reobserve({
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $6l79c.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        if (error && this.last && !(0, $77T3v.equal)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $gztBd.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $c8Tgc.cloneDeep)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === (0, $6l79c.NetworkStatus).refetch || newNetworkStatus === (0, $6l79c.NetworkStatus).fetchMore || newNetworkStatus === (0, $6l79c.NetworkStatus).poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $hORxN.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? mergedOptions : $493d70bec1143de5$var$assign(this.options, mergedOptions);
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions && newOptions.variables && !(0, $77T3v.equal)(newOptions.variables, oldVariables) && options.fetchPolicy !== "standby" && options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $6l79c.NetworkStatus).setVariables;
            }
        }
        var fetchOptions = query === options.query ? options : (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            query: query
        });
        this.waitForOwnResult && (this.waitForOwnResult = $493d70bec1143de5$var$skipCacheDataFor(fetchOptions.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = fetchOptions.variables && (0, $gztBd.__assign)({}, fetchOptions.variables);
        var _a = this.fetch(fetchOptions, newNetworkStatus), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                finishWaitingForOwnResult();
                _this.reportResult(result, variables);
            },
            error: function(error) {
                finishWaitingForOwnResult();
                _this.reportError(error, variables);
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    ObservableQuery.prototype.observe = function() {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $c0HTY.iterateObserversSafely)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var errorResult = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $6l79c.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $c0HTY.iterateObserversSafely)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $3LFQt.Observable));
(0, $fga6F.fixObservableSubclass)($493d70bec1143de5$export$6c1b56eac59c9584);
function $493d70bec1143de5$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        nextFetchPolicy: function() {
            this.nextFetchPolicy = nextFetchPolicy;
            if (typeof nextFetchPolicy === "function") return nextFetchPolicy.apply(this, arguments);
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $493d70bec1143de5$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $013Qw.invariant).error(21, error.message, error.stack);
}
function $493d70bec1143de5$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $013Qw.invariant).debug(22, missing);
}
function $493d70bec1143de5$var$skipCacheDataFor(fetchPolicy) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}

});
parcelRegister("6l79c", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $49da3f9343f89220$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isNetworkRequestInFlight", () => $49da3f9343f89220$export$37509604341a3464);
var $49da3f9343f89220$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($49da3f9343f89220$export$bd096ddbd246c79c || ($49da3f9343f89220$export$bd096ddbd246c79c = {}));
function $49da3f9343f89220$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $49da3f9343f89220$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

});

parcelRegister("c8Tgc", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $8d7118e9965d9076$export$629a2bd3f5a49ecc);
var $8d7118e9965d9076$var$toString = Object.prototype.toString;
function $8d7118e9965d9076$export$629a2bd3f5a49ecc(value) {
    return $8d7118e9965d9076$var$cloneDeepHelper(value);
}
function $8d7118e9965d9076$var$cloneDeepHelper(val, seen) {
    switch($8d7118e9965d9076$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $8d7118e9965d9076$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $8d7118e9965d9076$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("7nk6X", function(module, exports) {

$parcel$export(module.exports, "equalByQuery", () => $55ea4813de263ec7$export$5e40714c5ad44445);

var $gztBd = parcelRequire("gztBd");

var $77T3v = parcelRequire("77T3v");

var $dQg2Z = parcelRequire("dQg2Z");
var $kQxgw = parcelRequire("kQxgw");
var $fpDPU = parcelRequire("fpDPU");
var $bgnw1 = parcelRequire("bgnw1");
function $55ea4813de263ec7$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $gztBd.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $gztBd.__rest)(_b, [
        "data"
    ]);
    return (0, $77T3v.default)(aRest, bRest) && $55ea4813de263ec7$var$equalBySelectionSet((0, $kQxgw.getMainDefinition)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $dQg2Z.createFragmentMap)((0, $kQxgw.getFragmentDefinitions)(query)),
        variables: variables
    });
}
function $55ea4813de263ec7$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    return selectionSet.selections.every(function(selection) {
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        if (!(0, $bgnw1.shouldInclude)(selection, context.variables)) return true;
        if ($55ea4813de263ec7$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $fpDPU.isField)(selection)) {
            var resultKey = (0, $fpDPU.resultKeyNameFromField)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) return (0, $77T3v.default)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$55ea4813de263ec7$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $55ea4813de263ec7$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $dQg2Z.getFragmentFromSelection)(selection, context.fragmentMap);
            if (fragment) {
                if ($55ea4813de263ec7$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $55ea4813de263ec7$var$equalBySelectionSet(fragment.selectionSet, aResult, bResult, context);
            }
        }
    });
}
function $55ea4813de263ec7$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($55ea4813de263ec7$var$directiveIsNonreactive);
}
function $55ea4813de263ec7$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

});


parcelRegister("3K6Qm", function(module, exports) {

$parcel$export(module.exports, "LocalState", () => $2b9af9f8e7b32243$export$19901bcd339c3ded);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $1H8ag = parcelRequire("1H8ag");
var $11YUg = parcelRequire("11YUg");

var $fpDPU = parcelRequire("fpDPU");
var $2Pgju = parcelRequire("2Pgju");
var $dQg2Z = parcelRequire("dQg2Z");
var $kQxgw = parcelRequire("kQxgw");
var $bgnw1 = parcelRequire("bgnw1");
var $4quye = parcelRequire("4quye");

var $2s6Zq = parcelRequire("2s6Zq");
var $2b9af9f8e7b32243$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $4quye.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $4quye.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            return (0, $gztBd.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $bgnw1.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $2Pgju.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            return (0, $gztBd.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $gztBd.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $1H8ag.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $1H8ag.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $2Pgju.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, $gztBd.__generator)(this, function(_b) {
                mainDefinition = (0, $kQxgw.getMainDefinition)(document);
                fragments = (0, $kQxgw.getFragmentDefinitions)(document);
                fragmentMap = (0, $dQg2Z.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $gztBd.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $gztBd.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $gztBd.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) return [
                                2
                            ];
                            if (!(0, $bgnw1.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $fpDPU.isField)(selection)) return [
                                2,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $fpDPU.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $fpDPU.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $013Qw.invariant)(fragment, 16, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $4quye.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $gztBd.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $fpDPU.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $2s6Zq.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $fpDPU.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $1H8ag.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $11YUg.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $013Qw.invariant)(fragment, 17, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $11YUg.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

});
parcelRegister("11YUg", function(module, exports) {

$parcel$export(module.exports, "isSelectionNode", () => $e5efc7d5a66904a5$export$65772b71e1d017ba);

var $hHVLB = parcelRequire("hHVLB");
function $e5efc7d5a66904a5$export$e7ecd7c16613ccfd(node) {
    return $e5efc7d5a66904a5$export$4cedd8740794bd78(node) || $e5efc7d5a66904a5$export$b05c7141ec7770ba(node) || $e5efc7d5a66904a5$export$fbc18e88163d676d(node);
}
function $e5efc7d5a66904a5$export$4cedd8740794bd78(node) {
    return node.kind === (0, $hHVLB.Kind).OPERATION_DEFINITION || node.kind === (0, $hHVLB.Kind).FRAGMENT_DEFINITION;
}
function $e5efc7d5a66904a5$export$65772b71e1d017ba(node) {
    return node.kind === (0, $hHVLB.Kind).FIELD || node.kind === (0, $hHVLB.Kind).FRAGMENT_SPREAD || node.kind === (0, $hHVLB.Kind).INLINE_FRAGMENT;
}
function $e5efc7d5a66904a5$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $hHVLB.Kind).VARIABLE || node.kind === (0, $hHVLB.Kind).INT || node.kind === (0, $hHVLB.Kind).FLOAT || node.kind === (0, $hHVLB.Kind).STRING || node.kind === (0, $hHVLB.Kind).BOOLEAN || node.kind === (0, $hHVLB.Kind).NULL || node.kind === (0, $hHVLB.Kind).ENUM || node.kind === (0, $hHVLB.Kind).LIST || node.kind === (0, $hHVLB.Kind).OBJECT;
}
function $e5efc7d5a66904a5$export$f95bfad9e6aea45f(node) {
    return $e5efc7d5a66904a5$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $hHVLB.Kind).LIST ? node.values.some($e5efc7d5a66904a5$export$f95bfad9e6aea45f) : node.kind === (0, $hHVLB.Kind).OBJECT ? node.fields.some((field)=>$e5efc7d5a66904a5$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $hHVLB.Kind).VARIABLE);
}
function $e5efc7d5a66904a5$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $hHVLB.Kind).NAMED_TYPE || node.kind === (0, $hHVLB.Kind).LIST_TYPE || node.kind === (0, $hHVLB.Kind).NON_NULL_TYPE;
}
function $e5efc7d5a66904a5$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $hHVLB.Kind).SCHEMA_DEFINITION || $e5efc7d5a66904a5$export$a3584bba04f5bfe0(node) || node.kind === (0, $hHVLB.Kind).DIRECTIVE_DEFINITION;
}
function $e5efc7d5a66904a5$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $hHVLB.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $hHVLB.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $hHVLB.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $hHVLB.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $hHVLB.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $hHVLB.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $e5efc7d5a66904a5$export$fbc18e88163d676d(node) {
    return node.kind === (0, $hHVLB.Kind).SCHEMA_EXTENSION || $e5efc7d5a66904a5$export$d7907721b241e11f(node);
}
function $e5efc7d5a66904a5$export$d7907721b241e11f(node) {
    return node.kind === (0, $hHVLB.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $hHVLB.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $hHVLB.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $hHVLB.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $hHVLB.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $hHVLB.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});

parcelRegister("2s6Zq", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", () => $1c939e52cd624a16$export$ac9723609f5c76c2);
$parcel$export(module.exports, "forgetCache", () => $1c939e52cd624a16$export$cbe12faed7725318);
$parcel$export(module.exports, "recallCache", () => $1c939e52cd624a16$export$f342bdd61b3e9412);
$parcel$export(module.exports, "makeVar", () => $1c939e52cd624a16$export$5345c8ac69b4a9db);
parcelRequire("3Pvkw");
var $3bFLA = parcelRequire("3bFLA");
parcelRequire("70AqI");
var $cysx9 = parcelRequire("cysx9");
var $1c939e52cd624a16$export$ac9723609f5c76c2 = new (0, $cysx9.Slot)();
var $1c939e52cd624a16$var$cacheInfoMap = new WeakMap();
function $1c939e52cd624a16$var$getCacheInfo(cache) {
    var info = $1c939e52cd624a16$var$cacheInfoMap.get(cache);
    if (!info) $1c939e52cd624a16$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $3bFLA.dep)()
    });
    return info;
}
function $1c939e52cd624a16$export$cbe12faed7725318(cache) {
    $1c939e52cd624a16$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $1c939e52cd624a16$export$f342bdd61b3e9412(cache) {
    $1c939e52cd624a16$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $1c939e52cd624a16$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $1c939e52cd624a16$var$getCacheInfo(cache).dep.dirty(rv);
                    $1c939e52cd624a16$var$broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $1c939e52cd624a16$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $1c939e52cd624a16$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $1c939e52cd624a16$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $1c939e52cd624a16$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});
parcelRegister("3Pvkw", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $2c9e6ffeee976519$export$4997ffc0176396a6);
$parcel$export(module.exports, "dep", () => (parcelRequire("3bFLA")).dep);

var $1TIIy = parcelRequire("1TIIy");

var $2WmHz = parcelRequire("2WmHz");

var $bq0Rl = parcelRequire("bq0Rl");

var $6bhUf = parcelRequire("6bhUf");

var $3bFLA = parcelRequire("3bFLA");
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $2c9e6ffeee976519$var$defaultKeyTrie;
function $2c9e6ffeee976519$export$cd3144f8dd136006(...args) {
    const trie = $2c9e6ffeee976519$var$defaultKeyTrie || ($2c9e6ffeee976519$var$defaultKeyTrie = new (0, $1TIIy.Trie)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $2c9e6ffeee976519$var$caches = new Set();
function $2c9e6ffeee976519$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), makeCacheKey: makeCacheKey = $2c9e6ffeee976519$export$cd3144f8dd136006, keyArgs: keyArgs, subscribe: subscribe } = Object.create(null)) {
    const cache = new (0, $2WmHz.Cache)(max, (entry)=>entry.dispose());
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $bq0Rl.Entry)(originalFunction));
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $2c9e6ffeee976519$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $6bhUf.parentEntrySlot).hasValue()) {
            $2c9e6ffeee976519$var$caches.forEach((cache)=>cache.clean());
            $2c9e6ffeee976519$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        makeCacheKey: makeCacheKey,
        keyArgs: keyArgs,
        subscribe: subscribe
    });
    function dirtyKey(key) {
        const entry = cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

});
parcelRegister("2WmHz", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $22429ba46b050352$export$94affb487e701bf2);
function $22429ba46b050352$var$defaultDispose() {}
class $22429ba46b050352$export$94affb487e701bf2 {
    constructor(max = Infinity, dispose = $22429ba46b050352$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

});

parcelRegister("bq0Rl", function(module, exports) {

$parcel$export(module.exports, "Entry", () => $8502ca1798432464$export$3bb977b3ba9d3b59);

var $6bhUf = parcelRequire("6bhUf");

var $iVzHT = parcelRequire("iVzHT");
const $8502ca1798432464$var$emptySetPool = [];
const $8502ca1798432464$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $8502ca1798432464$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $8502ca1798432464$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $8502ca1798432464$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $8502ca1798432464$var$valueCopy(value) {
    return value.slice(0);
}
class $8502ca1798432464$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$8502ca1798432464$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$8502ca1798432464$var$mightBeDirty(this)) {
            $8502ca1798432464$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $8502ca1798432464$var$assert(!this.recomputing, "already recomputing");
        $8502ca1798432464$var$rememberParent(this);
        return $8502ca1798432464$var$mightBeDirty(this) ? $8502ca1798432464$var$reallyRecompute(this, args) : $8502ca1798432464$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $8502ca1798432464$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $iVzHT.maybeUnsubscribe)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $8502ca1798432464$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $8502ca1798432464$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $8502ca1798432464$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $8502ca1798432464$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $iVzHT.arrayFromSet)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $8502ca1798432464$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$8502ca1798432464$export$3bb977b3ba9d3b59.count = 0;
function $8502ca1798432464$var$rememberParent(child) {
    const parent = (0, $6bhUf.parentEntrySlot).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($8502ca1798432464$var$mightBeDirty(child)) $8502ca1798432464$var$reportDirtyChild(parent, child);
        else $8502ca1798432464$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $8502ca1798432464$var$reallyRecompute(entry, args) {
    $8502ca1798432464$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $6bhUf.parentEntrySlot).withValue(entry, $8502ca1798432464$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($8502ca1798432464$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $8502ca1798432464$var$setClean(entry);
    return $8502ca1798432464$var$valueGet(entry.value);
}
function $8502ca1798432464$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $8502ca1798432464$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $8502ca1798432464$var$setClean(entry) {
    entry.dirty = false;
    if ($8502ca1798432464$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $8502ca1798432464$var$reportClean(entry);
}
function $8502ca1798432464$var$reportDirty(child) {
    $8502ca1798432464$var$eachParent(child, $8502ca1798432464$var$reportDirtyChild);
}
function $8502ca1798432464$var$reportClean(child) {
    $8502ca1798432464$var$eachParent(child, $8502ca1798432464$var$reportCleanChild);
}
function $8502ca1798432464$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $iVzHT.arrayFromSet)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $8502ca1798432464$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $8502ca1798432464$var$assert(parent.childValues.has(child));
    $8502ca1798432464$var$assert($8502ca1798432464$var$mightBeDirty(child));
    const parentWasClean = !$8502ca1798432464$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $8502ca1798432464$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $8502ca1798432464$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $8502ca1798432464$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $8502ca1798432464$var$assert(parent.childValues.has(child));
    $8502ca1798432464$var$assert(!$8502ca1798432464$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $8502ca1798432464$var$valueCopy(child.value));
    else if (!$8502ca1798432464$var$valueIs(childValue, child.value)) parent.setDirty();
    $8502ca1798432464$var$removeDirtyChild(parent, child);
    if ($8502ca1798432464$var$mightBeDirty(parent)) return;
    $8502ca1798432464$var$reportClean(parent);
}
function $8502ca1798432464$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($8502ca1798432464$var$emptySetPool.length < $8502ca1798432464$var$POOL_TARGET_SIZE) $8502ca1798432464$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $8502ca1798432464$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $8502ca1798432464$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $8502ca1798432464$var$assert(parent.dirtyChildren === null);
}
function $8502ca1798432464$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $8502ca1798432464$var$removeDirtyChild(parent, child);
}
function $8502ca1798432464$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $iVzHT.maybeUnsubscribe)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

});
parcelRegister("6bhUf", function(module, exports) {

$parcel$export(module.exports, "parentEntrySlot", () => $4801a8f99349baf5$export$11fa9682b6ba79b1);
parcelRequire("70AqI");
var $cysx9 = parcelRequire("cysx9");
const $4801a8f99349baf5$export$11fa9682b6ba79b1 = new (0, $cysx9.Slot)();
function $4801a8f99349baf5$export$d906efd39458576(fn) {
    return $4801a8f99349baf5$export$11fa9682b6ba79b1.withValue(void 0, fn);
}

});
parcelRegister("70AqI", function(module, exports) {

$parcel$export(module.exports, "Slot", () => (parcelRequire("cysx9")).Slot);

var $cysx9 = parcelRequire("cysx9");
const { bind: $51a4cab26adb0695$export$2385a24977818dd0, noContext: $51a4cab26adb0695$export$9fa6f2e300a97f8 } = (0, $cysx9.Slot);
function $51a4cab26adb0695$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($51a4cab26adb0695$export$2385a24977818dd0(callback), delay);
}
function $51a4cab26adb0695$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $51a4cab26adb0695$export$2385a24977818dd0(gen.next);
        const boundThrow = $51a4cab26adb0695$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($51a4cab26adb0695$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $51a4cab26adb0695$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $51a4cab26adb0695$var$wrappedFibers = [];
function $51a4cab26adb0695$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($51a4cab26adb0695$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $51a4cab26adb0695$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $51a4cab26adb0695$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});
parcelRegister("cysx9", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $923ecb2f62a601be$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $923ecb2f62a601be$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $923ecb2f62a601be$var$MISSING_VALUE = {};
let $923ecb2f62a601be$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $923ecb2f62a601be$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $923ecb2f62a601be$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $923ecb2f62a601be$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $923ecb2f62a601be$var$MISSING_VALUE) break;
                if (context !== $923ecb2f62a601be$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $923ecb2f62a601be$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($923ecb2f62a601be$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $923ecb2f62a601be$var$currentContext.slots[this.id] = $923ecb2f62a601be$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $923ecb2f62a601be$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $923ecb2f62a601be$var$currentContext;
            $923ecb2f62a601be$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $923ecb2f62a601be$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $923ecb2f62a601be$var$currentContext;
            return function() {
                const saved = $923ecb2f62a601be$var$currentContext;
                try {
                    $923ecb2f62a601be$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $923ecb2f62a601be$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($923ecb2f62a601be$var$currentContext) {
                const saved = $923ecb2f62a601be$var$currentContext;
                try {
                    $923ecb2f62a601be$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $923ecb2f62a601be$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $923ecb2f62a601be$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $923ecb2f62a601be$var$globalKey = "@wry/context:Slot";
const $923ecb2f62a601be$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$923ecb2f62a601be$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$923ecb2f62a601be$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $923ecb2f62a601be$var$globalHost = $923ecb2f62a601be$var$host;
const $923ecb2f62a601be$export$8c6ed5c666ac1360 = $923ecb2f62a601be$var$globalHost[$923ecb2f62a601be$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$923ecb2f62a601be$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($923ecb2f62a601be$var$globalHost, $923ecb2f62a601be$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($923ecb2f62a601be$var$makeSlotClass());

});



parcelRegister("iVzHT", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", () => $dc793f80c780a068$export$5a15a386532a5ea4);
$parcel$export(module.exports, "arrayFromSet", () => $dc793f80c780a068$export$1eb72f2488cedd93);
$parcel$export(module.exports, "maybeUnsubscribe", () => $dc793f80c780a068$export$50527b97338c0f71);
const { hasOwnProperty: $dc793f80c780a068$export$5a15a386532a5ea4 } = Object.prototype;
const $dc793f80c780a068$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $dc793f80c780a068$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

});


parcelRegister("3bFLA", function(module, exports) {

$parcel$export(module.exports, "dep", () => $2522cc1e9f9800c0$export$c723b7eff9d8f870);

var $6bhUf = parcelRequire("6bhUf");

var $iVzHT = parcelRequire("iVzHT");
const $2522cc1e9f9800c0$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $2522cc1e9f9800c0$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $6bhUf.parentEntrySlot).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $iVzHT.maybeUnsubscribe)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $iVzHT.hasOwnProperty).call($2522cc1e9f9800c0$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $iVzHT.arrayFromSet)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $iVzHT.maybeUnsubscribe)(dep);
        }
    };
    return depend;
}

});




parcelRegister("evUDN", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", () => $a90fe5a40c5c788c$export$79a6120a39c90b6a);
$parcel$export(module.exports, "shouldWriteResult", () => $a90fe5a40c5c788c$export$5f47a9fb9a521654);

var $gztBd = parcelRequire("gztBd");

var $77T3v = parcelRequire("77T3v");

var $1w01O = parcelRequire("1w01O");
var $4quye = parcelRequire("4quye");
var $7VAEO = parcelRequire("7VAEO");
var $7qkJh = parcelRequire("7qkJh");
var $i2zd7 = parcelRequire("i2zd7");

var $6hQZT = parcelRequire("6hQZT");

var $6l79c = parcelRequire("6l79c");
var $a90fe5a40c5c788c$var$destructiveMethodCounts = new ((0, $1w01O.canUseWeakMap) ? WeakMap : Map)();
function $a90fe5a40c5c788c$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $a90fe5a40c5c788c$var$destructiveMethodCounts.set(cache, ($a90fe5a40c5c788c$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $a90fe5a40c5c788c$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $a90fe5a40c5c788c$export$79a6120a39c90b6a = function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!$a90fe5a40c5c788c$var$destructiveMethodCounts.has(cache)) {
            $a90fe5a40c5c788c$var$destructiveMethodCounts.set(cache, 0);
            $a90fe5a40c5c788c$var$wrapDestructiveCacheMethod(cache, "evict");
            $a90fe5a40c5c788c$var$wrapDestructiveCacheMethod(cache, "modify");
            $a90fe5a40c5c788c$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $6l79c.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $6l79c.NetworkStatus).loading && !(0, $77T3v.equal)(this.variables, query.variables)) networkStatus = (0, $6l79c.NetworkStatus).setVariables;
        if (!(0, $77T3v.equal)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $a90fe5a40c5c788c$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $77T3v.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $77T3v.equal)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) oq["observe"]();
                else (0, $6hQZT.reobserveCacheFirst)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $a90fe5a40c5c788c$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $6l79c.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $77T3v.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $a90fe5a40c5c788c$var$destructiveMethodCounts.get(this.cache) && (0, $77T3v.equal)(variables, lastWrite.variables) && (0, $77T3v.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $4quye.DeepMerger)();
        var graphQLErrors = (0, $7qkJh.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        this.reset();
        if ("incremental" in result && (0, $7qkJh.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, $i2zd7.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0) {
            if ($a90fe5a40c5c788c$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $a90fe5a40c5c788c$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                if (!_this.stopped && (0, $77T3v.equal)(_this.variables, options.variables)) _this.updateWatch(options.variables);
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $6l79c.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $6l79c.NetworkStatus).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $a90fe5a40c5c788c$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $7VAEO.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});


parcelRegister("9Hpdo", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", () => $70fbb0642dc921e0$export$235b7fc70b9fc359);

var $gztBd = parcelRequire("gztBd");

var $hORxN = parcelRequire("hORxN");
function $70fbb0642dc921e0$export$235b7fc70b9fc359(defaults, options) {
    return (0, $hORxN.compact)(defaults, options, options.variables && {
        variables: (0, $hORxN.compact)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});


parcelRegister("b4pd8", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", () => $80f39fc2fdae3cc1$export$467265324939f47f);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");


var $3Pvkw = parcelRequire("3Pvkw");

var $77T3v = parcelRequire("77T3v");

var $cID7s = parcelRequire("cID7s");

var $3dxVp = parcelRequire("3dxVp");

var $2Pgju = parcelRequire("2Pgju");
var $dC50B = parcelRequire("dC50B");
var $fpDPU = parcelRequire("fpDPU");

var $9VcGT = parcelRequire("9VcGT");

var $4bcrQ = parcelRequire("4bcrQ");

var $dXHfn = parcelRequire("dXHfn");

var $2s6Zq = parcelRequire("2s6Zq");

var $ivbyO = parcelRequire("ivbyO");

var $32UuX = parcelRequire("32UuX");

var $2dZXC = parcelRequire("2dZXC");
var $80f39fc2fdae3cc1$export$467265324939f47f = function(_super) {
    (0, $gztBd.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $dC50B.DocumentTransform)((0, $2Pgju.addTypenameToDocument));
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $2s6Zq.makeVar);
        _this.txCount = 0;
        _this.config = (0, $32UuX.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $ivbyO.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        var rootStore = this.data = new (0, $dXHfn.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new (0, $4bcrQ.StoreWriter)(this, this.storeReader = new (0, $9VcGT.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $32UuX.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $3Pvkw.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $dXHfn.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0, $2dZXC.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $3dxVp.MissingFieldError)) return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $32UuX.hasOwn).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) (0, $2s6Zq.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $2s6Zq.forgetCache)(_this);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        (0, $2dZXC.canonicalStringify).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $fpDPU.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $32UuX.hasOwn).call(options, "id")) return false;
            options = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $2dZXC.canonicalStringify).reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $2s6Zq.forgetCache)(this);
        } else this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) this.broadcastWatches((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) perform(this.data);
        else perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) alreadyDirty.delete(watch);
                    return result;
                }
            }));
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) return;
        }
        if (!lastDiff || !(0, $77T3v.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $cID7s.ApolloCache));

});
parcelRegister("cID7s", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $9427f060fd271642$export$5fc74f25506aa9c);

var $gztBd = parcelRequire("gztBd");

var $3Pvkw = parcelRequire("3Pvkw");

var $dQg2Z = parcelRequire("dQg2Z");
var $9427f060fd271642$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        this.getFragmentDoc = (0, $3Pvkw.wrap)((0, $dQg2Z.getFragmentQueryDocument));
    }
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $gztBd.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $gztBd.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();

});

parcelRegister("3dxVp", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", () => $257ce6c90abcf5e1$export$257c68286583b0f9);

var $gztBd = parcelRequire("gztBd");
var $257ce6c90abcf5e1$export$257c68286583b0f9 = function(_super) {
    (0, $gztBd.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

});

parcelRegister("9VcGT", function(module, exports) {

$parcel$export(module.exports, "StoreReader", () => $73934812392b291b$export$628ef07ba8965f12);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $hHVLB = parcelRequire("hHVLB");

var $3Pvkw = parcelRequire("3Pvkw");

var $2Pgju = parcelRequire("2Pgju");
var $1w01O = parcelRequire("1w01O");
var $hORxN = parcelRequire("hORxN");
var $4quye = parcelRequire("4quye");
var $kQxgw = parcelRequire("kQxgw");
var $dQg2Z = parcelRequire("dQg2Z");
var $fpDPU = parcelRequire("fpDPU");
var $7jBZQ = parcelRequire("7jBZQ");
var $7RkbH = parcelRequire("7RkbH");
var $bgnw1 = parcelRequire("bgnw1");

var $dXHfn = parcelRequire("dXHfn");

var $32UuX = parcelRequire("32UuX");
var $7qkJh = parcelRequire("7qkJh");

var $3dxVp = parcelRequire("3dxVp");

var $2dZXC = parcelRequire("2dZXC");
function $73934812392b291b$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults
    ];
}
var $73934812392b291b$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $1w01O.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, $hORxN.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $32UuX.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, $2dZXC.ObjectCanon)();
        this.executeSelectionSet = (0, $3Pvkw.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $73934812392b291b$var$execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, other), {
                    result: _this.canon.admit(other.result)
                });
                return other;
            }
            (0, $dXHfn.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: $73934812392b291b$var$execSelectionSetKeyArgs,
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $dXHfn.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $fpDPU.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $3Pvkw.wrap)(function(options) {
            (0, $dXHfn.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $dXHfn.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $2dZXC.ObjectCanon)();
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, (0, $kQxgw.getDefaultValues)((0, $kQxgw.getQueryDefinition)(query))), variables);
        var rootRef = (0, $fpDPU.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $kQxgw.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $gztBd.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $2dZXC.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, $32UuX.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            missing = [
                new (0, $3dxVp.MissingFieldError)($73934812392b291b$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $dXHfn.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $fpDPU.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $4quye.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            if (!(0, $bgnw1.shouldInclude)(selection, variables)) return;
            if ((0, $fpDPU.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $fpDPU.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $2Pgju.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $fpDPU.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $7qkJh.isArray)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $fpDPU.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $dQg2Z.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $hHVLB.Kind).FRAGMENT_SPREAD) throw (0, $013Qw.newInvariantError)(7, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $4quye.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $7RkbH.maybeDeepFreeze)(finalResult);
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $4quye.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            if ((0, $7qkJh.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $fpDPU.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $73934812392b291b$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $73934812392b291b$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $73934812392b291b$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $7jBZQ.isNonNullObject)(value)) {
                (0, $013Qw.invariant)(!(0, $fpDPU.isReference)(value), 8, (0, $32UuX.getTypenameFromStoreObject)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("7RkbH", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", () => $5b8d2485452e2fc6$export$7f9c177735b71f18);

var $7jBZQ = parcelRequire("7jBZQ");
function $5b8d2485452e2fc6$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $7jBZQ.isNonNullObject)(obj) && $5b8d2485452e2fc6$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $7jBZQ.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $5b8d2485452e2fc6$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $5b8d2485452e2fc6$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $5b8d2485452e2fc6$var$deepFreeze(obj);
    return obj;
}

});

parcelRegister("dXHfn", function(module, exports) {

$parcel$export(module.exports, "EntityStore", () => $a2a2550715192135$export$cb507f57054c7321);
$parcel$export(module.exports, "maybeDependOnExistenceOfEntity", () => $a2a2550715192135$export$f8068a30967ddc18);
$parcel$export(module.exports, "supportsResultCaching", () => $a2a2550715192135$export$488c0743feab3d61);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");
parcelRequire("3Pvkw");
var $3bFLA = parcelRequire("3bFLA");

var $77T3v = parcelRequire("77T3v");

var $1TIIy = parcelRequire("1TIIy");

var $1w01O = parcelRequire("1w01O");
var $4quye = parcelRequire("4quye");
var $7jBZQ = parcelRequire("7jBZQ");
var $fpDPU = parcelRequire("fpDPU");
var $7RkbH = parcelRequire("7RkbH");

var $32UuX = parcelRequire("32UuX");
var $a2a2550715192135$var$DELETE = Object.create(null);
var $a2a2550715192135$var$delModifier = function() {
    return $a2a2550715192135$var$DELETE;
};
var $a2a2550715192135$var$INVALIDATE = Object.create(null);
var $a2a2550715192135$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $7RkbH.maybeDeepFreeze)((0, $fpDPU.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $fpDPU.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $fpDPU.makeReference)(objOrIdOrRef);
            if ((0, $fpDPU.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $fpDPU.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $gztBd.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $32UuX.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $32UuX.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $32UuX.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $a2a2550715192135$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $32UuX.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $a2a2550715192135$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        if ((0, $fpDPU.isReference)(older)) older = older.__ref;
        if ((0, $fpDPU.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        if (!incoming) return;
        (0, $013Qw.invariant)(typeof dataId === "string", 1);
        var merged = new (0, $4quye.DeepMerger)($a2a2550715192135$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $a2a2550715192135$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $a2a2550715192135$var$DELETE,
                INVALIDATE: $a2a2550715192135$var$INVALIDATE,
                isReference: (0, $fpDPU.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $fpDPU.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $a2a2550715192135$var$delModifier ? $a2a2550715192135$var$DELETE : modify((0, $7RkbH.maybeDeepFreeze)(fieldValue), (0, $gztBd.__assign)((0, $gztBd.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $a2a2550715192135$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $a2a2550715192135$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $a2a2550715192135$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $a2a2550715192135$var$delModifier, _a) : $a2a2550715192135$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $32UuX.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $a2a2550715192135$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $32UuX.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $32UuX.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $gztBd.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $a2a2550715192135$var$Layer) this.parent.getRootIdSet(ids);
        else Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $32UuX.hasOwn).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $a2a2550715192135$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $32UuX.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            workSet_1.forEach(function(obj) {
                if ((0, $fpDPU.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, $7jBZQ.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    if ((0, $7jBZQ.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
var $a2a2550715192135$var$CacheGroup = function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $3bFLA.dep)() : null;
        this.keyMaker = new (0, $1TIIy.Trie)((0, $1w01O.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($a2a2550715192135$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) this.d($a2a2550715192135$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($a2a2550715192135$var$makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $a2a2550715192135$var$makeDepKey(dataId, storeFieldName) {
    return storeFieldName + "#" + dataId;
}
function $a2a2550715192135$export$f8068a30967ddc18(store, entityId) {
    if ($a2a2550715192135$export$488c0743feab3d61(store)) store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $gztBd.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $a2a2550715192135$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $a2a2550715192135$var$Stump(_this);
            _this.storageTrie = new (0, $1TIIy.Trie)((0, $1w01O.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($a2a2550715192135$export$cb507f57054c7321 || ($a2a2550715192135$export$cb507f57054c7321 = {}));
var $a2a2550715192135$var$Layer = function(_super) {
    (0, $gztBd.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) _this.delete(dataId);
                else if (!ownStoreObject) {
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $77T3v.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $32UuX.hasOwn).call(this.data, dataId) ? (0, $gztBd.__assign)((0, $gztBd.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}($a2a2550715192135$export$cb507f57054c7321);
var $a2a2550715192135$var$Stump = function(_super) {
    (0, $gztBd.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $a2a2550715192135$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        return this;
    };
    Stump.prototype.merge = function() {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}($a2a2550715192135$var$Layer);
function $a2a2550715192135$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $77T3v.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $a2a2550715192135$export$488c0743feab3d61(store) {
    return !!(store instanceof $a2a2550715192135$export$cb507f57054c7321 && store.group.caching);
}

});


parcelRegister("4bcrQ", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", () => $30b1d870164f3a27$export$eb8361c5d132fb8f);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $77T3v = parcelRequire("77T3v");

var $1TIIy = parcelRequire("1TIIy");

var $hHVLB = parcelRequire("hHVLB");

var $2Pgju = parcelRequire("2Pgju");
var $fpDPU = parcelRequire("fpDPU");
var $c8Tgc = parcelRequire("c8Tgc");
var $kQxgw = parcelRequire("kQxgw");
var $dQg2Z = parcelRequire("dQg2Z");
var $7qkJh = parcelRequire("7qkJh");
var $bgnw1 = parcelRequire("bgnw1");

var $32UuX = parcelRequire("32UuX");
var $7qkJh = parcelRequire("7qkJh");

var $2dZXC = parcelRequire("2dZXC");

var $ivbyO = parcelRequire("ivbyO");
function $30b1d870164f3a27$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $30b1d870164f3a27$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $kQxgw.getOperationDefinition)(query);
        var merger = (0, $32UuX.makeProcessedFieldsMerger)();
        variables = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, (0, $kQxgw.getDefaultValues)(operationDefinition)), variables);
        var context = (0, $gztBd.__assign)((0, $gztBd.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $2dZXC.canonicalStringify)(variables)
        }, (0, $32UuX.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $fpDPU.isReference)(ref)) throw (0, $013Qw.newInvariantError)(9, result);
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $fpDPU.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $fpDPU.isReference)(applied)) return;
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $32UuX.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $30b1d870164f3a27$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $fpDPU.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        var readField = function() {
            var options = (0, $ivbyO.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, $fpDPU.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $fpDPU.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $30b1d870164f3a27$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet ? $30b1d870164f3a27$var$getContextFlavor(context, false, false) : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet && ((0, $fpDPU.isReference)(incomingValue) || (0, $32UuX.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $30b1d870164f3a27$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $2Pgju.addTypenameToDocument).added(field) && !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $013Qw.invariant).error(10, (0, $fpDPU.resultKeyNameFromField)(field), result);
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) incoming = context.merge(incoming, keyObject);
        } catch (e) {
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $fpDPU.makeReference)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $30b1d870164f3a27$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                mergeTree: $30b1d870164f3a27$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) return globalThis.__DEV__ !== false ? (0, $c8Tgc.cloneDeep)(value) : value;
        if ((0, $7qkJh.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $30b1d870164f3a27$var$getChildMergeTree(mergeTree, i));
            $30b1d870164f3a27$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $fpDPU.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $1TIIy.Trie)(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $bgnw1.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) && (0, $7qkJh.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $fpDPU.argumentsObjectFromField)(dir, context.variables);
                        if (!args || args.if !== false) deferred = true;
                    }
                });
                if ((0, $fpDPU.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $30b1d870164f3a27$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $dQg2Z.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $hHVLB.Kind).FRAGMENT_SPREAD) throw (0, $013Qw.newInvariantError)(11, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $30b1d870164f3a27$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $fpDPU.isReference)(incoming)) {
            var e_1 = !(0, $7qkJh.isArray)(incoming) && ((0, $fpDPU.isReference)(existing) || (0, $32UuX.storeValueIsStoreObject)(existing)) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $fpDPU.isReference)(e_1) ? e_1.__ref : e_1
            ];
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $7qkJh.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $013Qw.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                incoming = (0, $7qkJh.isArray)(i_1) ? i_1.slice(0) : (0, $gztBd.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $30b1d870164f3a27$var$emptyMergeTreePool = [];
function $30b1d870164f3a27$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $30b1d870164f3a27$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $30b1d870164f3a27$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $30b1d870164f3a27$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $30b1d870164f3a27$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $gztBd.__assign)((0, $gztBd.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $30b1d870164f3a27$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $30b1d870164f3a27$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $30b1d870164f3a27$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $30b1d870164f3a27$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $30b1d870164f3a27$var$mergeTreeIsEmpty(childTree)) {
        $30b1d870164f3a27$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $30b1d870164f3a27$var$warnings = new Set();
function $30b1d870164f3a27$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $fpDPU.isReference)(existing)) return;
    if ((0, $77T3v.equal)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if ($30b1d870164f3a27$var$warnings.has(typeDotName)) return;
    $30b1d870164f3a27$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0, $7qkJh.isArray)(existing) && !(0, $7qkJh.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(12, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}

});
parcelRegister("ivbyO", function(module, exports) {

$parcel$export(module.exports, "Policies", () => $0379df566dc6e8e1$export$e9859ad90648930b);
$parcel$export(module.exports, "normalizeReadFieldOptions", () => $0379df566dc6e8e1$export$1ad7a877581bdf2e);

var $gztBd = parcelRequire("gztBd");
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $fpDPU = parcelRequire("fpDPU");
var $7jBZQ = parcelRequire("7jBZQ");
var $6x0sD = parcelRequire("6x0sD");

var $32UuX = parcelRequire("32UuX");
var $7qkJh = parcelRequire("7qkJh");

var $2s6Zq = parcelRequire("2s6Zq");

var $2dZXC = parcelRequire("2dZXC");

var $2aaJy = parcelRequire("2aaJy");
(0, $fpDPU.getStoreKeyName).setStringify((0, $2dZXC.canonicalStringify));
function $0379df566dc6e8e1$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $fpDPU.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $0379df566dc6e8e1$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $0379df566dc6e8e1$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $0379df566dc6e8e1$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $0379df566dc6e8e1$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $0379df566dc6e8e1$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $gztBd.__assign)({
            dataIdFromObject: (0, $32UuX.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $0379df566dc6e8e1$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $gztBd.__assign)((0, $gztBd.__assign)({}, object), storeObject), context);
            if ((0, $7qkJh.isArray)(specifierOrId)) keyFn = (0, $2aaJy.keyFieldsFnFromSpecifier)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $gztBd.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $32UuX.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $0379df566dc6e8e1$var$mergeTrueFn : merge === false ? $0379df566dc6e8e1$var$mergeFalseFn : existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn = keyFields === false ? $0379df566dc6e8e1$var$nullKeyFieldsFn : (0, $7qkJh.isArray)(keyFields) ? (0, $2aaJy.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = keyArgs === false ? $0379df566dc6e8e1$var$simpleKeyArgsFn : (0, $7qkJh.isArray)(keyArgs) ? (0, $2aaJy.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $0379df566dc6e8e1$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $013Qw.invariant)(!old || old === which, 3, which);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $32UuX.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $32UuX.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                supertypes_1 = this.getSupertypeSet(typename, true);
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $gztBd.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(4, typename, supertype);
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $32UuX.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $0379df566dc6e8e1$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $7qkJh.isArray)(specifierOrString)) keyFn = (0, $2aaJy.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $fpDPU.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $fpDPU.getStoreKeyName)(fieldName, $0379df566dc6e8e1$var$argsFromFieldSpecifier(fieldSpec));
        if (storeFieldName === false) return fieldName;
        return fieldName === (0, $32UuX.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $0379df566dc6e8e1$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $fpDPU.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $2s6Zq.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $0379df566dc6e8e1$var$mergeTrueFn) return $0379df566dc6e8e1$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $0379df566dc6e8e1$var$mergeFalseFn) return incoming;
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $0379df566dc6e8e1$var$makeFieldFunctionOptions(this, void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $0379df566dc6e8e1$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $32UuX.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $0379df566dc6e8e1$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $fpDPU.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($0379df566dc6e8e1$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $0379df566dc6e8e1$var$makeMergeObjectsFunction(context.store)
    };
}
function $0379df566dc6e8e1$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $gztBd.__assign)({}, fieldNameOrOptions);
        if (!(0, $32UuX.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $013Qw.invariant).warn(5, (0, $6x0sD.stringifyForDisplay)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $0379df566dc6e8e1$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $7qkJh.isArray)(existing) || (0, $7qkJh.isArray)(incoming)) throw (0, $013Qw.newInvariantError)(6);
        if ((0, $7jBZQ.isNonNullObject)(existing) && (0, $7jBZQ.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $fpDPU.isReference)(existing) && (0, $32UuX.storeValueIsStoreObject)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $32UuX.storeValueIsStoreObject)(existing) && (0, $fpDPU.isReference)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $32UuX.storeValueIsStoreObject)(existing) && (0, $32UuX.storeValueIsStoreObject)(incoming)) return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

});
parcelRegister("2aaJy", function(module, exports) {

$parcel$export(module.exports, "keyFieldsFnFromSpecifier", () => $1934d770913b4ac6$export$f1953a0407594d2c);
$parcel$export(module.exports, "keyArgsFnFromSpecifier", () => $1934d770913b4ac6$export$550737ee0cc371ac);
parcelRequire("1Q1zr");
var $013Qw = parcelRequire("013Qw");

var $fpDPU = parcelRequire("fpDPU");
var $4quye = parcelRequire("4quye");
var $7qkJh = parcelRequire("7qkJh");
var $7jBZQ = parcelRequire("7jBZQ");

var $32UuX = parcelRequire("32UuX");
var $7qkJh = parcelRequire("7qkJh");
var $1934d770913b4ac6$var$specifierInfoCache = Object.create(null);
function $1934d770913b4ac6$var$lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return $1934d770913b4ac6$var$specifierInfoCache[cacheKey] || ($1934d770913b4ac6$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $1934d770913b4ac6$export$f1953a0407594d2c(specifier) {
    var info = $1934d770913b4ac6$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $1934d770913b4ac6$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $1934d770913b4ac6$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $32UuX.hasOwn).call(object, schemaKeyPath[0])) extracted = $1934d770913b4ac6$export$e8f64f7a025887d3(object, schemaKeyPath, $1934d770913b4ac6$var$extractKey);
            (0, $013Qw.invariant)(extracted !== void 0, 2, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $1934d770913b4ac6$export$550737ee0cc371ac(specifier) {
    var info = $1934d770913b4ac6$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $1934d770913b4ac6$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $7qkJh.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    var directiveArgs = d && (0, $fpDPU.argumentsObjectFromField)(d, variables);
                    return directiveArgs && $1934d770913b4ac6$export$e8f64f7a025887d3(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $32UuX.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $1934d770913b4ac6$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                return;
            }
            if (args) return $1934d770913b4ac6$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $1934d770913b4ac6$export$2db31da99613c21f(specifier, extractor) {
    var merger = new (0, $4quye.DeepMerger)();
    return $1934d770913b4ac6$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $1934d770913b4ac6$export$eca459f173e85801(spec) {
    var info = $1934d770913b4ac6$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $7qkJh.isArray)(s)) {
                $1934d770913b4ac6$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $7qkJh.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $1934d770913b4ac6$var$extractKey(object, key) {
    return object[key];
}
function $1934d770913b4ac6$export$e8f64f7a025887d3(object, path, extract) {
    extract = extract || $1934d770913b4ac6$var$extractKey;
    return $1934d770913b4ac6$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $7qkJh.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $1934d770913b4ac6$var$normalize(value) {
    if ((0, $7jBZQ.isNonNullObject)(value)) {
        if ((0, $7qkJh.isArray)(value)) return value.map($1934d770913b4ac6$var$normalize);
        return $1934d770913b4ac6$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $1934d770913b4ac6$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}

});




parcelRegister("ME7ho", function(module, exports) {

$parcel$export(module.exports, "config", () => $f827bfcc4d4977ca$export$e506a1d27d1eaa20);
var $f827bfcc4d4977ca$import_meta = Object.assign(Object.create(null), {
    url: "file:///config.ts"
});

var $ibaza = parcelRequire("ibaza");
const $f827bfcc4d4977ca$var$computeEnv = ()=>{
    const parentContainer = document.getElementById("atunwa-player");
    const h = parentContainer?.clientHeight;
    const w = parentContainer?.clientWidth;
    if (typeof $ibaza === "object") return {
        mode: undefined ?? "",
        baseUrl: `${undefined}/graphql` ?? "",
        playerSecretKey: "aa026661cb059bbb2b4da3d214b1fa90" ?? "",
        analyticMeasurementId: "G-HM83V0L8R6" ?? "",
        googleApiKey: "AIzaSyA9QQyjpnpKcONWypq6BwRzkIeLiHpTTUs" ?? "",
        height: h,
        width: w,
        bannerId: 'atunwa-player-banner-element',
        contentElementId: 'atunwa-player-content-element',
        companionElementId: 'atunwa-player-companion-element',
        controlsId: 'atunwa-player-control-container'
    };
    else return {
        mode: $f827bfcc4d4977ca$import_meta.env?.VITE_NODE_ENV_MODE ?? "",
        baseUrl: `${$f827bfcc4d4977ca$import_meta.env.VITE_BASE_URL}/graphql` ?? "",
        playerSecretKey: $f827bfcc4d4977ca$import_meta.env.VITE_PLAYER_SECRET_KEY ?? "",
        analyticMeasurementId: $f827bfcc4d4977ca$import_meta.env?.VITE_GOOGLE_ANALYTIC_MEASUREMENT_ID ?? "",
        googleApiKey: $f827bfcc4d4977ca$import_meta.env?.VITE_GOOGLE_API_KEY ?? "",
        height: h,
        width: w,
        bannerId: 'atunwa-player-banner-element',
        contentElementId: 'atunwa-player-content-element',
        companionElementId: 'atunwa-player-companion-element',
        controlsId: 'atunwa-player-control-container'
    };
};
const $f827bfcc4d4977ca$export$e506a1d27d1eaa20 = $f827bfcc4d4977ca$var$computeEnv();

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});



parcelRegister("bm8xp", function(module, exports) {

$parcel$export(module.exports, "store", () => $3e17d8207aeba759$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "persistor", () => $3e17d8207aeba759$export$7b682ac9934ca3e4);

var $41dmB = parcelRequire("41dmB");
var $c0Lyo = parcelRequire("c0Lyo");

var $fR0sl = parcelRequire("fR0sl");
parcelRequire("hJZ3Y");
var $5W88v = parcelRequire("5W88v");
var $jBKhA = parcelRequire("jBKhA");

var $jW68n = parcelRequire("jW68n");

var $gecCs = parcelRequire("gecCs");

var $dD8Ud = parcelRequire("dD8Ud");
const $3e17d8207aeba759$var$rootReducer = (0, $41dmB.combineReducers)({
    player: (0, $gecCs.default),
    ads: (0, $dD8Ud.default)
});
const $3e17d8207aeba759$var$persistConfig = {
    key: 'root',
    storage: (0, $jW68n.default),
    whitelist: [
        ''
    ]
};
const $3e17d8207aeba759$var$persistedReducer = (0, $5W88v.default)($3e17d8207aeba759$var$persistConfig, $3e17d8207aeba759$var$rootReducer);
const $3e17d8207aeba759$export$6f57813fe9f31bf9 = (0, $c0Lyo.configureStore)({
    reducer: $3e17d8207aeba759$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: false
        })
});
(0, $fR0sl.setupListeners)($3e17d8207aeba759$export$6f57813fe9f31bf9.dispatch);
const $3e17d8207aeba759$export$7b682ac9934ca3e4 = (0, $jBKhA.default)($3e17d8207aeba759$export$6f57813fe9f31bf9);

});
parcelRegister("41dmB", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $2ed19f26b5ab4120$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $2ed19f26b5ab4120$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $2ed19f26b5ab4120$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $2ed19f26b5ab4120$export$9ff26e0402cc7b7);

var $5EBXX = parcelRequire("5EBXX");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $2ed19f26b5ab4120$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $2ed19f26b5ab4120$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $2ed19f26b5ab4120$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $2ed19f26b5ab4120$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $2ed19f26b5ab4120$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $2ed19f26b5ab4120$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $2ed19f26b5ab4120$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $2ed19f26b5ab4120$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $2ed19f26b5ab4120$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($2ed19f26b5ab4120$var$isDate(val)) return 'date';
    if ($2ed19f26b5ab4120$var$isError(val)) return 'error';
    var constructorName = $2ed19f26b5ab4120$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $2ed19f26b5ab4120$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $2ed19f26b5ab4120$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $2ed19f26b5ab4120$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $2ed19f26b5ab4120$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $2ed19f26b5ab4120$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(1));
        return enhancer($2ed19f26b5ab4120$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$2ed19f26b5ab4120$var$isPlainObject(action)) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $2ed19f26b5ab4120$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$2ed19f26b5ab4120$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $2ed19f26b5ab4120$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$2ed19f26b5ab4120$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $2ed19f26b5ab4120$export$8928921ea2d3b126 = $2ed19f26b5ab4120$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $2ed19f26b5ab4120$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $2ed19f26b5ab4120$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $2ed19f26b5ab4120$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$2ed19f26b5ab4120$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $2ed19f26b5ab4120$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $2ed19f26b5ab4120$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $2ed19f26b5ab4120$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $2ed19f26b5ab4120$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $2ed19f26b5ab4120$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $2ed19f26b5ab4120$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $2ed19f26b5ab4120$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $2ed19f26b5ab4120$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $2ed19f26b5ab4120$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $2ed19f26b5ab4120$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $2ed19f26b5ab4120$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $2ed19f26b5ab4120$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $2ed19f26b5ab4120$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($2ed19f26b5ab4120$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $2ed19f26b5ab4120$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $5EBXX.default)((0, $5EBXX.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("5EBXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de237383779de8$export$2e2bcd8739ae039);

var $2qeFG = parcelRequire("2qeFG");
function $41de237383779de8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41de237383779de8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41de237383779de8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2qeFG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41de237383779de8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("2qeFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3963e2ec4676f7$export$2e2bcd8739ae039);

var $k2Kke = parcelRequire("k2Kke");
function $1c3963e2ec4676f7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $k2Kke.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("k2Kke", function(module, exports) {

$parcel$export(module.exports, "default", () => $e977edce0f75b0db$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $fEskS = parcelRequire("fEskS");
function $e977edce0f75b0db$export$2e2bcd8739ae039(t) {
    var i = (0, $fEskS.default)(t, "string");
    return "symbol" == (0, $jOMXy.default)(i) ? i : i + "";
}

});
parcelRegister("jOMXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d8aa307cfbe8b4$export$2e2bcd8739ae039);
function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fEskS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b650924e9996270c$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");
function $b650924e9996270c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jOMXy.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jOMXy.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("c0Lyo", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $8bea5f472f64765d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "configureStore", () => $8bea5f472f64765d$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createAction", () => $8bea5f472f64765d$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "createSlice", () => $8bea5f472f64765d$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "nanoid", () => $8bea5f472f64765d$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "createAsyncThunk", () => $8bea5f472f64765d$export$6abd22dc03e5063f);
$parcel$export(module.exports, "isAnyOf", () => $8bea5f472f64765d$export$2c3435c7647f7b0d);
$parcel$export(module.exports, "isAllOf", () => $8bea5f472f64765d$export$9dd1fb32974da385);
$parcel$export(module.exports, "isPending", () => $8bea5f472f64765d$export$872dec21e9a69476);
$parcel$export(module.exports, "isRejected", () => $8bea5f472f64765d$export$a5c5d27e3994c5be);
$parcel$export(module.exports, "isRejectedWithValue", () => $8bea5f472f64765d$export$fcc3388fb56de601);
$parcel$export(module.exports, "isFulfilled", () => $8bea5f472f64765d$export$1da80a6ef1307441);
$parcel$export(module.exports, "isAsyncThunkAction", () => $8bea5f472f64765d$export$6aa4142d99c1abce);
$parcel$export(module.exports, "SHOULD_AUTOBATCH", () => $8bea5f472f64765d$export$8fb31c0f05df007b);
$parcel$export(module.exports, "prepareAutoBatched", () => $8bea5f472f64765d$export$39fcd5145ec5e4e2);
$parcel$export(module.exports, "createNextState", () => (parcelRequire("3Llm4")).default);
$parcel$export(module.exports, "createSelector", () => (parcelRequire("4Xu5k")).createSelector);

var $3Llm4 = parcelRequire("3Llm4");

var $41dmB = parcelRequire("41dmB");

var $4Xu5k = parcelRequire("4Xu5k");

var $gL3ZL = parcelRequire("gL3ZL");

var $ibaza = parcelRequire("ibaza");
var $8bea5f472f64765d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8bea5f472f64765d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8bea5f472f64765d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $8bea5f472f64765d$var$__defProp = Object.defineProperty;
var $8bea5f472f64765d$var$__defProps = Object.defineProperties;
var $8bea5f472f64765d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8bea5f472f64765d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8bea5f472f64765d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8bea5f472f64765d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8bea5f472f64765d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $8bea5f472f64765d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $8bea5f472f64765d$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($8bea5f472f64765d$var$__hasOwnProp.call(b, prop)) $8bea5f472f64765d$var$__defNormalProp(a, prop, b[prop]);
    if ($8bea5f472f64765d$var$__getOwnPropSymbols) for(var _i = 0, _c = $8bea5f472f64765d$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($8bea5f472f64765d$var$__propIsEnum.call(b, prop)) $8bea5f472f64765d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8bea5f472f64765d$var$__spreadProps = function(a, b) {
    return $8bea5f472f64765d$var$__defProps(a, $8bea5f472f64765d$var$__getOwnPropDescs(b));
};
var $8bea5f472f64765d$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $8bea5f472f64765d$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $4Xu5k.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $8bea5f472f64765d$var$__spreadArray([
            (0, $3Llm4.isDraft)(value) ? (0, $3Llm4.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $8bea5f472f64765d$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $41dmB.compose;
    return (0, $41dmB.compose).apply(null, arguments);
};
var $8bea5f472f64765d$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $8bea5f472f64765d$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $8bea5f472f64765d$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $8bea5f472f64765d$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $8bea5f472f64765d$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $8bea5f472f64765d$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $8bea5f472f64765d$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $8bea5f472f64765d$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $8bea5f472f64765d$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $8bea5f472f64765d$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $8bea5f472f64765d$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $8bea5f472f64765d$var$freezeDraftable(val) {
    return (0, $3Llm4.isDraftable)(val) ? (0, $3Llm4.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $8bea5f472f64765d$var$isProduction = true;
var $8bea5f472f64765d$var$prefix = "Invariant failed";
function $8bea5f472f64765d$var$invariant(condition, message) {
    if (condition) return;
    if ($8bea5f472f64765d$var$isProduction) throw new Error($8bea5f472f64765d$var$prefix);
    throw new Error($8bea5f472f64765d$var$prefix + ": " + (message || ""));
}
function $8bea5f472f64765d$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $8bea5f472f64765d$var$getSerialize(serializer, decycler), indent);
}
function $8bea5f472f64765d$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $8bea5f472f64765d$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $8bea5f472f64765d$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $8bea5f472f64765d$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $8bea5f472f64765d$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $8bea5f472f64765d$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $8bea5f472f64765d$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $8bea5f472f64765d$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $8bea5f472f64765d$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $8bea5f472f64765d$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $8bea5f472f64765d$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $8bea5f472f64765d$export$53b83ca8eaab0383(val);
}
function $8bea5f472f64765d$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $8bea5f472f64765d$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $8bea5f472f64765d$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $8bea5f472f64765d$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $8bea5f472f64765d$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$8bea5f472f64765d$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $8bea5f472f64765d$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $8bea5f472f64765d$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $8bea5f472f64765d$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $8bea5f472f64765d$export$36c1185aeee5b0a6(options);
    };
}
function $8bea5f472f64765d$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $8bea5f472f64765d$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($8bea5f472f64765d$var$isBoolean(thunk)) middlewareArray.push((0, $gL3ZL.default));
        else middlewareArray.push((0, $gL3ZL.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $8bea5f472f64765d$var$IS_PRODUCTION = true;
function $8bea5f472f64765d$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $8bea5f472f64765d$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($8bea5f472f64765d$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $41dmB.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$8bea5f472f64765d$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$8bea5f472f64765d$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $41dmB.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $41dmB.compose);
    if (devTools) finalCompose = $8bea5f472f64765d$var$composeWithDevTools($8bea5f472f64765d$var$__spreadValues({
        trace: !$8bea5f472f64765d$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $8bea5f472f64765d$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $8bea5f472f64765d$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $41dmB.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $8bea5f472f64765d$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $8bea5f472f64765d$var$__spreadValues($8bea5f472f64765d$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $8bea5f472f64765d$export$b956e38827fca970(action) {
    return $8bea5f472f64765d$export$53b83ca8eaab0383(action) && "type" in action;
}
function $8bea5f472f64765d$export$ebd532f9034651f3(action) {
    return $8bea5f472f64765d$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($8bea5f472f64765d$var$isValidKey);
}
function $8bea5f472f64765d$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $8bea5f472f64765d$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $8bea5f472f64765d$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $8bea5f472f64765d$var$isStateFunction(x) {
    return typeof x === "function";
}
var $8bea5f472f64765d$var$hasWarnedAboutObjectNotation = false;
function $8bea5f472f64765d$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $8bea5f472f64765d$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($8bea5f472f64765d$var$isStateFunction(initialState)) getInitialState = function() {
        return $8bea5f472f64765d$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $8bea5f472f64765d$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $8bea5f472f64765d$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $3Llm4.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $3Llm4.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $3Llm4.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $8bea5f472f64765d$var$hasWarnedAboutObjectNotation2 = false;
function $8bea5f472f64765d$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $8bea5f472f64765d$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $ibaza;
    var initialState = typeof options.initialState == "function" ? options.initialState : $8bea5f472f64765d$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $8bea5f472f64765d$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $8bea5f472f64765d$export$309c7a02b0b0bc62(type, prepareCallback) : $8bea5f472f64765d$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $8bea5f472f64765d$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $8bea5f472f64765d$var$__spreadValues($8bea5f472f64765d$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $8bea5f472f64765d$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $8bea5f472f64765d$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $8bea5f472f64765d$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($8bea5f472f64765d$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $8bea5f472f64765d$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $8bea5f472f64765d$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $8bea5f472f64765d$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $8bea5f472f64765d$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $8bea5f472f64765d$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $8bea5f472f64765d$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $8bea5f472f64765d$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $8bea5f472f64765d$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $8bea5f472f64765d$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $8bea5f472f64765d$var$createSingleArgumentStateOperator(mutator) {
    var operator = $8bea5f472f64765d$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $8bea5f472f64765d$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $8bea5f472f64765d$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $3Llm4.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $3Llm4.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $8bea5f472f64765d$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $8bea5f472f64765d$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $8bea5f472f64765d$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $8bea5f472f64765d$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $8bea5f472f64765d$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $8bea5f472f64765d$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $8bea5f472f64765d$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $8bea5f472f64765d$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $8bea5f472f64765d$var$__spreadValues($8bea5f472f64765d$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $8bea5f472f64765d$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $8bea5f472f64765d$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $8bea5f472f64765d$var$createStateOperator(addOneMutably),
        addMany: $8bea5f472f64765d$var$createStateOperator(addManyMutably),
        setOne: $8bea5f472f64765d$var$createStateOperator(setOneMutably),
        setMany: $8bea5f472f64765d$var$createStateOperator(setManyMutably),
        setAll: $8bea5f472f64765d$var$createStateOperator(setAllMutably),
        updateOne: $8bea5f472f64765d$var$createStateOperator(updateOneMutably),
        updateMany: $8bea5f472f64765d$var$createStateOperator(updateManyMutably),
        upsertOne: $8bea5f472f64765d$var$createStateOperator(upsertOneMutably),
        upsertMany: $8bea5f472f64765d$var$createStateOperator(upsertManyMutably),
        removeOne: $8bea5f472f64765d$var$createStateOperator(removeOneMutably),
        removeMany: $8bea5f472f64765d$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $8bea5f472f64765d$var$createSortedStateAdapter(selectId, sort) {
    var _c = $8bea5f472f64765d$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($8bea5f472f64765d$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $8bea5f472f64765d$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $8bea5f472f64765d$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $8bea5f472f64765d$var$createStateOperator(addOneMutably),
        updateOne: $8bea5f472f64765d$var$createStateOperator(updateOneMutably),
        upsertOne: $8bea5f472f64765d$var$createStateOperator(upsertOneMutably),
        setOne: $8bea5f472f64765d$var$createStateOperator(setOneMutably),
        setMany: $8bea5f472f64765d$var$createStateOperator(setManyMutably),
        setAll: $8bea5f472f64765d$var$createStateOperator(setAllMutably),
        addMany: $8bea5f472f64765d$var$createStateOperator(addManyMutably),
        updateMany: $8bea5f472f64765d$var$createStateOperator(updateManyMutably),
        upsertMany: $8bea5f472f64765d$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $8bea5f472f64765d$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $8bea5f472f64765d$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $8bea5f472f64765d$var$createInitialStateFactory();
    var selectorsFactory = $8bea5f472f64765d$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $8bea5f472f64765d$var$createSortedStateAdapter(selectId, sortComparer) : $8bea5f472f64765d$var$createUnsortedStateAdapter(selectId);
    return $8bea5f472f64765d$var$__spreadValues($8bea5f472f64765d$var$__spreadValues($8bea5f472f64765d$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $8bea5f472f64765d$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $8bea5f472f64765d$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $8bea5f472f64765d$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $8bea5f472f64765d$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $8bea5f472f64765d$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $8bea5f472f64765d$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $8bea5f472f64765d$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $8bea5f472f64765d$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $8bea5f472f64765d$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $8bea5f472f64765d$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $8bea5f472f64765d$var$__spreadProps($8bea5f472f64765d$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $8bea5f472f64765d$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $8bea5f472f64765d$var$__spreadProps($8bea5f472f64765d$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $8bea5f472f64765d$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $8bea5f472f64765d$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $8bea5f472f64765d$var$__spreadProps($8bea5f472f64765d$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $8bea5f472f64765d$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $8bea5f472f64765d$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $8bea5f472f64765d$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$8bea5f472f64765d$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $8bea5f472f64765d$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $8bea5f472f64765d$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $8bea5f472f64765d$var$RejectWithValue) throw result;
                                                if (result instanceof $8bea5f472f64765d$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $8bea5f472f64765d$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($8bea5f472f64765d$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $8bea5f472f64765d$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $8bea5f472f64765d$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $8bea5f472f64765d$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $8bea5f472f64765d$var$matches = function(matcher, action) {
    if ($8bea5f472f64765d$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $8bea5f472f64765d$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $8bea5f472f64765d$var$matches(matcher, action);
        });
    };
}
function $8bea5f472f64765d$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $8bea5f472f64765d$var$matches(matcher, action);
        });
    };
}
function $8bea5f472f64765d$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $8bea5f472f64765d$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $8bea5f472f64765d$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $8bea5f472f64765d$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$8bea5f472f64765d$var$isAsyncThunkArray(asyncThunks)) return $8bea5f472f64765d$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $8bea5f472f64765d$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $8bea5f472f64765d$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $8bea5f472f64765d$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$8bea5f472f64765d$var$isAsyncThunkArray(asyncThunks)) return $8bea5f472f64765d$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $8bea5f472f64765d$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $8bea5f472f64765d$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $8bea5f472f64765d$export$9dd1fb32974da385($8bea5f472f64765d$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$8bea5f472f64765d$var$isAsyncThunkArray(asyncThunks)) return $8bea5f472f64765d$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $8bea5f472f64765d$export$9dd1fb32974da385($8bea5f472f64765d$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $8bea5f472f64765d$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $8bea5f472f64765d$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$8bea5f472f64765d$var$isAsyncThunkArray(asyncThunks)) return $8bea5f472f64765d$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $8bea5f472f64765d$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $8bea5f472f64765d$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $8bea5f472f64765d$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$8bea5f472f64765d$var$isAsyncThunkArray(asyncThunks)) return $8bea5f472f64765d$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $8bea5f472f64765d$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $8bea5f472f64765d$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $8bea5f472f64765d$var$noop = function() {};
var $8bea5f472f64765d$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $8bea5f472f64765d$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $8bea5f472f64765d$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $8bea5f472f64765d$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $8bea5f472f64765d$var$task = "task";
var $8bea5f472f64765d$var$listener = "listener";
var $8bea5f472f64765d$var$completed = "completed";
var $8bea5f472f64765d$var$cancelled = "cancelled";
var $8bea5f472f64765d$var$taskCancelled = "task-" + $8bea5f472f64765d$var$cancelled;
var $8bea5f472f64765d$var$taskCompleted = "task-" + $8bea5f472f64765d$var$completed;
var $8bea5f472f64765d$var$listenerCancelled = $8bea5f472f64765d$var$listener + "-" + $8bea5f472f64765d$var$cancelled;
var $8bea5f472f64765d$var$listenerCompleted = $8bea5f472f64765d$var$listener + "-" + $8bea5f472f64765d$var$completed;
var $8bea5f472f64765d$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $8bea5f472f64765d$var$task + " " + $8bea5f472f64765d$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $8bea5f472f64765d$var$validateActive = function(signal) {
    if (signal.aborted) throw new $8bea5f472f64765d$export$cb1bdac908fed7f(signal.reason);
};
function $8bea5f472f64765d$var$raceWithSignal(signal, promise2) {
    var cleanup = $8bea5f472f64765d$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $8bea5f472f64765d$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $8bea5f472f64765d$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $8bea5f472f64765d$var$noop;
    });
}
var $8bea5f472f64765d$var$runTask = function(task2, cleanUp) {
    return $8bea5f472f64765d$var$__async(void 0, null, function() {
        var value, error_1;
        return $8bea5f472f64765d$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $8bea5f472f64765d$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $8bea5f472f64765d$var$createPause = function(signal) {
    return function(promise2) {
        return $8bea5f472f64765d$var$catchRejection($8bea5f472f64765d$var$raceWithSignal(signal, promise2).then(function(output) {
            $8bea5f472f64765d$var$validateActive(signal);
            return output;
        }));
    };
};
var $8bea5f472f64765d$var$createDelay = function(signal) {
    var pause = $8bea5f472f64765d$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $8bea5f472f64765d$var$assign = Object.assign;
var $8bea5f472f64765d$var$INTERNAL_NIL_TOKEN = {};
var $8bea5f472f64765d$var$alm = "listenerMiddleware";
var $8bea5f472f64765d$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $8bea5f472f64765d$var$addAbortSignalListener(parentAbortSignal, function() {
            return $8bea5f472f64765d$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $8bea5f472f64765d$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $8bea5f472f64765d$var$runTask(function() {
            return $8bea5f472f64765d$var$__async(void 0, null, function() {
                var result2;
                return $8bea5f472f64765d$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $8bea5f472f64765d$var$validateActive(parentAbortSignal);
                            $8bea5f472f64765d$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $8bea5f472f64765d$var$createPause(childAbortController.signal),
                                    delay: $8bea5f472f64765d$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $8bea5f472f64765d$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $8bea5f472f64765d$var$abortControllerWithReason(childAbortController, $8bea5f472f64765d$var$taskCompleted);
        });
        return {
            result: $8bea5f472f64765d$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $8bea5f472f64765d$var$abortControllerWithReason(childAbortController, $8bea5f472f64765d$var$taskCancelled);
            }
        };
    };
};
var $8bea5f472f64765d$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $8bea5f472f64765d$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $8bea5f472f64765d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $8bea5f472f64765d$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $8bea5f472f64765d$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $8bea5f472f64765d$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $8bea5f472f64765d$var$catchRejection(take(predicate, timeout));
    };
};
var $8bea5f472f64765d$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $8bea5f472f64765d$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $8bea5f472f64765d$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $8bea5f472f64765d$var$createListenerEntry = function(options) {
    var _c = $8bea5f472f64765d$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $8bea5f472f64765d$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $8bea5f472f64765d$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $8bea5f472f64765d$var$abortControllerWithReason(controller, $8bea5f472f64765d$var$listenerCancelled);
    });
};
var $8bea5f472f64765d$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($8bea5f472f64765d$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $8bea5f472f64765d$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $8bea5f472f64765d$export$f03a6b845d3fb58b = $8bea5f472f64765d$export$309c7a02b0b0bc62($8bea5f472f64765d$var$alm + "/add");
var $8bea5f472f64765d$export$b1b8022855fb2b71 = $8bea5f472f64765d$export$309c7a02b0b0bc62($8bea5f472f64765d$var$alm + "/removeAll");
var $8bea5f472f64765d$export$b03e9483f936dccb = $8bea5f472f64765d$export$309c7a02b0b0bc62($8bea5f472f64765d$var$alm + "/remove");
var $8bea5f472f64765d$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $8bea5f472f64765d$var$__spreadArray([
        $8bea5f472f64765d$var$alm + "/error"
    ], args));
};
function $8bea5f472f64765d$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $8bea5f472f64765d$var$defaultErrorHandler : _c;
    $8bea5f472f64765d$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $8bea5f472f64765d$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $8bea5f472f64765d$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $8bea5f472f64765d$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $8bea5f472f64765d$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $8bea5f472f64765d$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $8bea5f472f64765d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $8bea5f472f64765d$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $8bea5f472f64765d$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $8bea5f472f64765d$var$createDelay(internalTaskController.signal),
                                pause: $8bea5f472f64765d$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $8bea5f472f64765d$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $8bea5f472f64765d$var$abortControllerWithReason(controller, $8bea5f472f64765d$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $8bea5f472f64765d$export$cb1bdac908fed7f)) $8bea5f472f64765d$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $8bea5f472f64765d$var$abortControllerWithReason(internalTaskController, $8bea5f472f64765d$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $8bea5f472f64765d$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$8bea5f472f64765d$export$b956e38827fca970(action)) return next(action);
                if ($8bea5f472f64765d$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($8bea5f472f64765d$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($8bea5f472f64765d$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $8bea5f472f64765d$var$INTERNAL_NIL_TOKEN) throw new Error($8bea5f472f64765d$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $8bea5f472f64765d$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $8bea5f472f64765d$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $8bea5f472f64765d$export$8fb31c0f05df007b = "RTK_autoBatch";
var $8bea5f472f64765d$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$8bea5f472f64765d$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $8bea5f472f64765d$var$promise;
var $8bea5f472f64765d$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($8bea5f472f64765d$var$promise || ($8bea5f472f64765d$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $8bea5f472f64765d$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $8bea5f472f64765d$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $8bea5f472f64765d$var$createQueueWithTimer(10);
var $8bea5f472f64765d$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $8bea5f472f64765d$var$queueMicrotaskShim : options.type === "raf" ? $8bea5f472f64765d$var$rAF : options.type === "callback" ? options.queueNotification : $8bea5f472f64765d$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$8bea5f472f64765d$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $3Llm4.enableES5)();

});
parcelRegister("3Llm4", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $2bd65385ad5a796d$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $2bd65385ad5a796d$export$2e2bcd8739ae039 = fn;

});

parcelRegister("4Xu5k", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $39c40256608fe0eb$export$595d22ed68ca2841);
$parcel$export(module.exports, "defaultMemoize", () => (parcelRequire("fUOIv")).defaultMemoize);

var $fUOIv = parcelRequire("fUOIv");
function $39c40256608fe0eb$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $39c40256608fe0eb$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $39c40256608fe0eb$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $39c40256608fe0eb$export$595d22ed68ca2841 = /* #__PURE__ */ $39c40256608fe0eb$export$5943f4447f6ef248((0, $fUOIv.defaultMemoize));
var $39c40256608fe0eb$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $39c40256608fe0eb$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("fUOIv", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $b9636d4932ac4906$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $b9636d4932ac4906$var$NOT_FOUND = 'NOT_FOUND';
function $b9636d4932ac4906$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b9636d4932ac4906$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $b9636d4932ac4906$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $b9636d4932ac4906$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b9636d4932ac4906$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b9636d4932ac4906$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $b9636d4932ac4906$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b9636d4932ac4906$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $b9636d4932ac4906$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b9636d4932ac4906$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $b9636d4932ac4906$var$createSingletonCache(comparator) : $b9636d4932ac4906$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b9636d4932ac4906$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("gL3ZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3342280c352d26c$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $c3342280c352d26c$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $c3342280c352d26c$var$thunk = $c3342280c352d26c$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$c3342280c352d26c$var$thunk.withExtraArgument = $c3342280c352d26c$var$createThunkMiddleware;
var $c3342280c352d26c$export$2e2bcd8739ae039 = $c3342280c352d26c$var$thunk;

});


parcelRegister("fR0sl", function(module, exports) {

$parcel$export(module.exports, "setupListeners", () => $b8ac28d277d3b6c7$export$120c0dbb0351414c);

var $41dmB = parcelRequire("41dmB");
var $c0Lyo = parcelRequire("c0Lyo");
var $3Llm4 = parcelRequire("3Llm4");
var $4Xu5k = parcelRequire("4Xu5k");

var $3Llm4 = parcelRequire("3Llm4");
parcelRequire("4Xu5k");
var $fUOIv = parcelRequire("fUOIv");

var $ibaza = parcelRequire("ibaza");
var $b8ac28d277d3b6c7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b8ac28d277d3b6c7$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $b8ac28d277d3b6c7$var$__defProp = Object.defineProperty;
var $b8ac28d277d3b6c7$var$__defProps = Object.defineProperties;
var $b8ac28d277d3b6c7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b8ac28d277d3b6c7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b8ac28d277d3b6c7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b8ac28d277d3b6c7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b8ac28d277d3b6c7$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b8ac28d277d3b6c7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b8ac28d277d3b6c7$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b8ac28d277d3b6c7$var$__hasOwnProp.call(b, prop)) $b8ac28d277d3b6c7$var$__defNormalProp(a, prop, b[prop]);
    if ($b8ac28d277d3b6c7$var$__getOwnPropSymbols) for(var _j = 0, _k = $b8ac28d277d3b6c7$var$__getOwnPropSymbols(b); _j < _k.length; _j++){
        var prop = _k[_j];
        if ($b8ac28d277d3b6c7$var$__propIsEnum.call(b, prop)) $b8ac28d277d3b6c7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b8ac28d277d3b6c7$var$__spreadProps = function(a, b) {
    return $b8ac28d277d3b6c7$var$__defProps(a, $b8ac28d277d3b6c7$var$__getOwnPropDescs(b));
};
var $b8ac28d277d3b6c7$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($b8ac28d277d3b6c7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b8ac28d277d3b6c7$var$__getOwnPropSymbols) for(var _j = 0, _k = $b8ac28d277d3b6c7$var$__getOwnPropSymbols(source); _j < _k.length; _j++){
        var prop = _k[_j];
        if (exclude.indexOf(prop) < 0 && $b8ac28d277d3b6c7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $b8ac28d277d3b6c7$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/query/core/apiState.ts
var $b8ac28d277d3b6c7$export$f4258b89f6bad1d6;
(function(QueryStatus2) {
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
})($b8ac28d277d3b6c7$export$f4258b89f6bad1d6 || ($b8ac28d277d3b6c7$export$f4258b89f6bad1d6 = {}));
function $b8ac28d277d3b6c7$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized,
        isLoading: status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.pending,
        isSuccess: status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.fulfilled,
        isError: status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.rejected
    };
}
// src/query/utils/isAbsoluteUrl.ts
function $b8ac28d277d3b6c7$var$isAbsoluteUrl(url) {
    return new RegExp("(^|:)//").test(url);
}
// src/query/utils/joinUrls.ts
var $b8ac28d277d3b6c7$var$withoutTrailingSlash = function(url) {
    return url.replace(/\/$/, "");
};
var $b8ac28d277d3b6c7$var$withoutLeadingSlash = function(url) {
    return url.replace(/^\//, "");
};
function $b8ac28d277d3b6c7$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($b8ac28d277d3b6c7$var$isAbsoluteUrl(url)) return url;
    var delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $b8ac28d277d3b6c7$var$withoutTrailingSlash(base);
    url = $b8ac28d277d3b6c7$var$withoutLeadingSlash(url);
    return "" + base + delimiter + url;
}
// src/query/utils/flatten.ts
var $b8ac28d277d3b6c7$var$flatten = function(arr) {
    return [].concat.apply([], arr);
};
// src/query/utils/isOnline.ts
function $b8ac28d277d3b6c7$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function $b8ac28d277d3b6c7$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
var $b8ac28d277d3b6c7$var$isPlainObject = (0, $c0Lyo.isPlainObject);
function $b8ac28d277d3b6c7$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($b8ac28d277d3b6c7$var$isPlainObject(oldObj) && $b8ac28d277d3b6c7$var$isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    var newKeys = Object.keys(newObj);
    var oldKeys = Object.keys(oldObj);
    var isSameObject = newKeys.length === oldKeys.length;
    var mergeObj = Array.isArray(newObj) ? [] : {};
    for(var _j = 0, newKeys_1 = newKeys; _j < newKeys_1.length; _j++){
        var key = newKeys_1[_j];
        mergeObj[key] = $b8ac28d277d3b6c7$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
var $b8ac28d277d3b6c7$var$defaultFetchFn = function() {
    var args = [];
    for(var _j = 0; _j < arguments.length; _j++)args[_j] = arguments[_j];
    return fetch.apply(void 0, args);
};
var $b8ac28d277d3b6c7$var$defaultValidateStatus = function(response) {
    return response.status >= 200 && response.status <= 299;
};
var $b8ac28d277d3b6c7$var$defaultIsJsonContentType = function(headers) {
    return /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
};
function $b8ac28d277d3b6c7$var$stripUndefined(obj) {
    if (!(0, $c0Lyo.isPlainObject)(obj)) return obj;
    var copy = $b8ac28d277d3b6c7$var$__spreadValues({}, obj);
    for(var _j = 0, _k = Object.entries(copy); _j < _k.length; _j++){
        var _l = _k[_j], k = _l[0], v = _l[1];
        if (v === void 0) delete copy[k];
    }
    return copy;
}
function $b8ac28d277d3b6c7$export$adcf4c6133c49b4e(_a) {
    var _this = this;
    if (_a === void 0) _a = {};
    var _b = _a, baseUrl = _b.baseUrl, _j = _b.prepareHeaders, prepareHeaders = _j === void 0 ? function(x) {
        return x;
    } : _j, _k = _b.fetchFn, fetchFn = _k === void 0 ? $b8ac28d277d3b6c7$var$defaultFetchFn : _k, paramsSerializer = _b.paramsSerializer, _l = _b.isJsonContentType, isJsonContentType = _l === void 0 ? $b8ac28d277d3b6c7$var$defaultIsJsonContentType : _l, _m = _b.jsonContentType, jsonContentType = _m === void 0 ? "application/json" : _m, jsonReplacer = _b.jsonReplacer, defaultTimeout = _b.timeout, globalResponseHandler = _b.responseHandler, globalValidateStatus = _b.validateStatus, baseFetchOptions = $b8ac28d277d3b6c7$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $b8ac28d277d3b6c7$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return function(arg, api) {
        return $b8ac28d277d3b6c7$var$__async(_this, null, function() {
            var signal, getState, extra, endpoint, forced, type, meta, _a2, url, _j, headers, _k, params, _l, responseHandler, _m, validateStatus, _o, timeout, rest, config, _p, isJsonifiable, divider, query, request, requestClone, response, timedOut, timeoutId, e_1, responseClone, resultData, responseText, handleResponseError_1, e_2;
            return $b8ac28d277d3b6c7$var$__generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        signal = api.signal, getState = api.getState, extra = api.extra, endpoint = api.endpoint, forced = api.forced, type = api.type;
                        _a2 = typeof arg == "string" ? {
                            url: arg
                        } : arg, url = _a2.url, _j = _a2.headers, headers = _j === void 0 ? new Headers(baseFetchOptions.headers) : _j, _k = _a2.params, params = _k === void 0 ? void 0 : _k, _l = _a2.responseHandler, responseHandler = _l === void 0 ? globalResponseHandler != null ? globalResponseHandler : "json" : _l, _m = _a2.validateStatus, validateStatus = _m === void 0 ? globalValidateStatus != null ? globalValidateStatus : $b8ac28d277d3b6c7$var$defaultValidateStatus : _m, _o = _a2.timeout, timeout = _o === void 0 ? defaultTimeout : _o, rest = $b8ac28d277d3b6c7$var$__objRest(_a2, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]);
                        config = $b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, baseFetchOptions), {
                            signal: signal
                        }), rest);
                        headers = new Headers($b8ac28d277d3b6c7$var$stripUndefined(headers));
                        _p = config;
                        return [
                            4 /*yield*/ ,
                            prepareHeaders(headers, {
                                getState: getState,
                                extra: extra,
                                endpoint: endpoint,
                                forced: forced,
                                type: type
                            })
                        ];
                    case 1:
                        _p.headers = _q.sent() || headers;
                        isJsonifiable = function(body) {
                            return typeof body === "object" && ((0, $c0Lyo.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
                        };
                        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
                        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
                        if (params) {
                            divider = ~url.indexOf("?") ? "&" : "?";
                            query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($b8ac28d277d3b6c7$var$stripUndefined(params));
                            url += divider + query;
                        }
                        url = $b8ac28d277d3b6c7$var$joinUrls(baseUrl, url);
                        request = new Request(url, config);
                        requestClone = request.clone();
                        meta = {
                            request: requestClone
                        };
                        timedOut = false, timeoutId = timeout && setTimeout(function() {
                            timedOut = true;
                            api.abort();
                        }, timeout);
                        _q.label = 2;
                    case 2:
                        _q.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetchFn(request)
                        ];
                    case 3:
                        response = _q.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String(e_1)
                                },
                                meta: meta
                            }
                        ];
                    case 5:
                        if (timeoutId) clearTimeout(timeoutId);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        responseClone = response.clone();
                        meta.response = responseClone;
                        responseText = "";
                        _q.label = 7;
                    case 7:
                        _q.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                handleResponse(response, responseHandler).then(function(r) {
                                    return resultData = r;
                                }, function(e) {
                                    return handleResponseError_1 = e;
                                }),
                                responseClone.text().then(function(r) {
                                    return responseText = r;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        _q.sent();
                        if (handleResponseError_1) throw handleResponseError_1;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: response.status,
                                    data: responseText,
                                    error: String(e_2)
                                },
                                meta: meta
                            }
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            validateStatus(response, resultData) ? {
                                data: resultData,
                                meta: meta
                            } : {
                                error: {
                                    status: response.status,
                                    data: resultData
                                },
                                meta: meta
                            }
                        ];
                }
            });
        });
    };
    function handleResponse(response, responseHandler) {
        return $b8ac28d277d3b6c7$var$__async(this, null, function() {
            var text;
            return $b8ac28d277d3b6c7$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        if (typeof responseHandler === "function") return [
                            2 /*return*/ ,
                            responseHandler(response)
                        ];
                        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
                        if (!(responseHandler === "json")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        text = _j.sent();
                        return [
                            2 /*return*/ ,
                            text.length ? JSON.parse(text) : null
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.text()
                        ];
                }
            });
        });
    }
}
// src/query/HandledError.ts
var $b8ac28d277d3b6c7$var$HandledError = /** @class */ function() {
    function HandledError(value, meta) {
        if (meta === void 0) meta = void 0;
        this.value = value;
        this.meta = meta;
    }
    return HandledError;
}();
// src/query/retry.ts
function $b8ac28d277d3b6c7$var$defaultBackoff(attempt, maxRetries) {
    if (attempt === void 0) attempt = 0;
    if (maxRetries === void 0) maxRetries = 5;
    return $b8ac28d277d3b6c7$var$__async(this, null, function() {
        var attempts, timeout;
        return $b8ac28d277d3b6c7$var$__generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    attempts = Math.min(attempt, maxRetries);
                    timeout = ~~((Math.random() + 0.4) * (300 << attempts));
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(function(res) {
                                return resolve(res);
                            }, timeout);
                        })
                    ];
                case 1:
                    _j.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b8ac28d277d3b6c7$var$fail(e) {
    throw Object.assign(new $b8ac28d277d3b6c7$var$HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var $b8ac28d277d3b6c7$var$EMPTY_OPTIONS = {};
var $b8ac28d277d3b6c7$var$retryWithBackoff = function(baseQuery, defaultOptions) {
    return function(args, api, extraOptions) {
        return $b8ac28d277d3b6c7$var$__async(void 0, null, function() {
            var possibleMaxRetries, maxRetries, defaultRetryCondition, options, retry2, result, e_3;
            return $b8ac28d277d3b6c7$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        possibleMaxRetries = [
                            5,
                            (defaultOptions || $b8ac28d277d3b6c7$var$EMPTY_OPTIONS).maxRetries,
                            (extraOptions || $b8ac28d277d3b6c7$var$EMPTY_OPTIONS).maxRetries
                        ].filter(function(x) {
                            return x !== void 0;
                        });
                        maxRetries = possibleMaxRetries.slice(-1)[0];
                        defaultRetryCondition = function(_, __, _j) {
                            var attempt = _j.attempt;
                            return attempt <= maxRetries;
                        };
                        options = $b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues({
                            maxRetries: maxRetries,
                            backoff: $b8ac28d277d3b6c7$var$defaultBackoff,
                            retryCondition: defaultRetryCondition
                        }, defaultOptions), extraOptions);
                        retry2 = 0;
                        _j.label = 1;
                    case 1:
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            baseQuery(args, api, extraOptions)
                        ];
                    case 3:
                        result = _j.sent();
                        if (result.error) throw new $b8ac28d277d3b6c7$var$HandledError(result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        e_3 = _j.sent();
                        retry2++;
                        if (e_3.throwImmediately) {
                            if (e_3 instanceof $b8ac28d277d3b6c7$var$HandledError) return [
                                2 /*return*/ ,
                                e_3.value
                            ];
                            throw e_3;
                        }
                        if (e_3 instanceof $b8ac28d277d3b6c7$var$HandledError && !options.retryCondition(e_3.value.error, args, {
                            attempt: retry2,
                            baseQueryApi: api,
                            extraOptions: extraOptions
                        })) return [
                            2 /*return*/ ,
                            e_3.value
                        ];
                        return [
                            4 /*yield*/ ,
                            options.backoff(retry2, options.maxRetries)
                        ];
                    case 5:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $b8ac28d277d3b6c7$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($b8ac28d277d3b6c7$var$retryWithBackoff, {
    fail: $b8ac28d277d3b6c7$var$fail
});
var $b8ac28d277d3b6c7$var$onFocus = /* @__PURE__ */ (0, $c0Lyo.createAction)("__rtkq/focused");
var $b8ac28d277d3b6c7$var$onFocusLost = /* @__PURE__ */ (0, $c0Lyo.createAction)("__rtkq/unfocused");
var $b8ac28d277d3b6c7$var$onOnline = /* @__PURE__ */ (0, $c0Lyo.createAction)("__rtkq/online");
var $b8ac28d277d3b6c7$var$onOffline = /* @__PURE__ */ (0, $c0Lyo.createAction)("__rtkq/offline");
var $b8ac28d277d3b6c7$var$initialized = false;
function $b8ac28d277d3b6c7$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        var handleFocus = function() {
            return dispatch($b8ac28d277d3b6c7$var$onFocus());
        };
        var handleFocusLost = function() {
            return dispatch($b8ac28d277d3b6c7$var$onFocusLost());
        };
        var handleOnline = function() {
            return dispatch($b8ac28d277d3b6c7$var$onOnline());
        };
        var handleOffline = function() {
            return dispatch($b8ac28d277d3b6c7$var$onOffline());
        };
        var handleVisibilityChange = function() {
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$b8ac28d277d3b6c7$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $b8ac28d277d3b6c7$var$initialized = true;
            }
        }
        var unsubscribe = function() {
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $b8ac28d277d3b6c7$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $b8ac28d277d3b6c7$var$onFocus,
        onFocusLost: $b8ac28d277d3b6c7$var$onFocusLost,
        onOffline: $b8ac28d277d3b6c7$var$onOffline,
        onOnline: $b8ac28d277d3b6c7$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var $b8ac28d277d3b6c7$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($b8ac28d277d3b6c7$var$DefinitionType || ($b8ac28d277d3b6c7$var$DefinitionType = {}));
function $b8ac28d277d3b6c7$var$isQueryDefinition(e) {
    return e.type === $b8ac28d277d3b6c7$var$DefinitionType.query;
}
function $b8ac28d277d3b6c7$var$isMutationDefinition(e) {
    return e.type === $b8ac28d277d3b6c7$var$DefinitionType.mutation;
}
function $b8ac28d277d3b6c7$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($b8ac28d277d3b6c7$var$isFunction(description)) return description(result, error, queryArg, meta).map($b8ac28d277d3b6c7$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($b8ac28d277d3b6c7$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $b8ac28d277d3b6c7$var$isFunction(t) {
    return typeof t === "function";
}
function $b8ac28d277d3b6c7$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function $b8ac28d277d3b6c7$var$isNotNullish(v) {
    return v != null;
}
// src/query/core/buildInitiate.ts
var $b8ac28d277d3b6c7$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $b8ac28d277d3b6c7$var$isUpsertQuery = function(arg) {
    return typeof arg[$b8ac28d277d3b6c7$var$forceQueryFnSymbol] === "function";
};
function $b8ac28d277d3b6c7$var$buildInitiate(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, api = _j.api, context = _j.context;
    var runningQueries = new Map();
    var runningMutations = new Map();
    var _k = api.internalActions, unsubscribeQueryResult = _k.unsubscribeQueryResult, removeMutationResult = _k.removeMutationResult, updateSubscriptionOptions = _k.updateSubscriptionOptions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk,
        getRunningOperationPromises: getRunningOperationPromises,
        removalWarning: removalWarning
    };
    function removalWarning() {
        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
    }
    function getRunningOperationPromises() {
        typeof $ibaza;
        var extract = function(v) {
            return Array.from(v.values()).flatMap(function(queriesForStore) {
                return queriesForStore ? Object.values(queriesForStore) : [];
            });
        };
        return $b8ac28d277d3b6c7$var$__spreadArray($b8ac28d277d3b6c7$var$__spreadArray([], extract(runningQueries)), extract(runningMutations)).filter($b8ac28d277d3b6c7$var$isNotNullish);
    }
    function getRunningQueryThunk(endpointName, queryArgs) {
        return function(dispatch) {
            var _a;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return function(dispatch) {
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return function(dispatch) {
            return Object.values(runningQueries.get(dispatch) || {}).filter($b8ac28d277d3b6c7$var$isNotNullish);
        };
    }
    function getRunningMutationsThunk() {
        return function(dispatch) {
            return Object.values(runningMutations.get(dispatch) || {}).filter($b8ac28d277d3b6c7$var$isNotNullish);
        };
    }
    function middlewareWarning(dispatch) {
        var registered;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        var queryAction = function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.subscribe, subscribe = _l === void 0 ? true : _l, forceRefetch = _k.forceRefetch, subscriptionOptions = _k.subscriptionOptions, _m = $b8ac28d277d3b6c7$var$forceQueryFnSymbol, forceQueryFn = _k[_m];
            return function(dispatch, getState) {
                var _j;
                var _a;
                var queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                var thunk = queryThunk((_j = {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey
                }, _j[$b8ac28d277d3b6c7$var$forceQueryFnSymbol] = forceQueryFn, _j));
                var selector = api.endpoints[endpointName].select(arg);
                var thunkResult = dispatch(thunk);
                var stateAfter = selector(getState());
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort;
                var skippedSynchronously = stateAfter.requestId !== requestId;
                var runningQuery = (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
                var selectFromState = function() {
                    return selector(getState());
                };
                var statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    unwrap: function() {
                        return $b8ac28d277d3b6c7$var$__async(this, null, function() {
                            var result;
                            return $b8ac28d277d3b6c7$var$__generator(this, function(_j) {
                                switch(_j.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            statePromise
                                        ];
                                    case 1:
                                        result = _j.sent();
                                        if (result.isError) throw result.error;
                                        return [
                                            2 /*return*/ ,
                                            result.data
                                        ];
                                }
                            });
                        });
                    },
                    refetch: function() {
                        return dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        }));
                    },
                    unsubscribe: function() {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions: function(options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    var running_1 = runningQueries.get(dispatch) || {};
                    running_1[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running_1);
                    statePromise.then(function() {
                        delete running_1[queryCacheKey];
                        if (!Object.keys(running_1).length) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.track, track = _l === void 0 ? true : _l, fixedCacheKey = _k.fixedCacheKey;
            return function(dispatch, getState) {
                var thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                var thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort, unwrap = thunkResult.unwrap;
                var returnValuePromise = thunkResult.unwrap().then(function(data) {
                    return {
                        data: data
                    };
                }).catch(function(error) {
                    return {
                        error: error
                    };
                });
                var reset = function() {
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                var ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    unsubscribe: reset,
                    reset: reset
                });
                var running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(function() {
                    delete running[requestId];
                    if (!Object.keys(running).length) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(function() {
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!Object.keys(running).length) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
        };
    }
}
function $b8ac28d277d3b6c7$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function $b8ac28d277d3b6c7$var$buildThunks(_j) {
    var _this = this;
    var reducerPath = _j.reducerPath, baseQuery = _j.baseQuery, endpointDefinitions = _j.context.endpointDefinitions, serializeQueryArgs = _j.serializeQueryArgs, api = _j.api;
    var patchQueryData = function(endpointName, args, patches) {
        return function(dispatch) {
            var endpointDefinition = endpointDefinitions[endpointName];
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: serializeQueryArgs({
                    queryArgs: args,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                }),
                patches: patches
            }));
        };
    };
    var updateQueryData = function(endpointName, args, updateRecipe) {
        return function(dispatch, getState) {
            var _j, _k;
            var currentState = api.endpoints[endpointName].select(args)(getState());
            var ret = {
                patches: [],
                inversePatches: [],
                undo: function() {
                    return dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches));
                }
            };
            if (currentState.status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized) return ret;
            if ("data" in currentState) {
                if ((0, $3Llm4.isDraftable)(currentState.data)) {
                    var _l = (0, $3Llm4.produceWithPatches)(currentState.data, updateRecipe), patches = _l[1], inversePatches = _l[2];
                    (_j = ret.patches).push.apply(_j, patches);
                    (_k = ret.inversePatches).push.apply(_k, inversePatches);
                } else {
                    var value = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: value
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches));
            return ret;
        };
    };
    var upsertQueryData = function(endpointName, args, value) {
        return function(dispatch) {
            var _j;
            return dispatch(api.endpoints[endpointName].initiate(args, (_j = {
                subscribe: false,
                forceRefetch: true
            }, _j[$b8ac28d277d3b6c7$var$forceQueryFnSymbol] = function() {
                return {
                    data: value
                };
            }, _j)));
        };
    };
    var executeEndpoint = function(_0, _1) {
        return $b8ac28d277d3b6c7$var$__async(_this, [
            _0,
            _1
        ], function(arg, _j) {
            var endpointDefinition, transformResponse, result, baseQueryApi_1, forceQueryFn, what, err, _k, _l, key, _m, error_1, catchedError, transformErrorResponse, _o, e_4;
            var _p, _q;
            var signal = _j.signal, abort = _j.abort, rejectWithValue = _j.rejectWithValue, fulfillWithValue = _j.fulfillWithValue, dispatch = _j.dispatch, getState = _j.getState, extra = _j.extra;
            return $b8ac28d277d3b6c7$var$__generator(this, function(_r) {
                switch(_r.label){
                    case 0:
                        endpointDefinition = endpointDefinitions[arg.endpointName];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            8,
                            ,
                            13
                        ]);
                        transformResponse = $b8ac28d277d3b6c7$var$defaultTransformResponse;
                        result = void 0;
                        baseQueryApi_1 = {
                            signal: signal,
                            abort: abort,
                            dispatch: dispatch,
                            getState: getState,
                            extra: extra,
                            endpoint: arg.endpointName,
                            type: arg.type,
                            forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
                        };
                        forceQueryFn = arg.type === "query" ? arg[$b8ac28d277d3b6c7$var$forceQueryFnSymbol] : void 0;
                        if (!forceQueryFn) return [
                            3 /*break*/ ,
                            2
                        ];
                        result = forceQueryFn();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!endpointDefinition.query) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi_1, endpointDefinition.extraOptions)
                        ];
                    case 3:
                        result = _r.sent();
                        if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            endpointDefinition.queryFn(arg.originalArgs, baseQueryApi_1, endpointDefinition.extraOptions, function(arg2) {
                                return baseQuery(arg2, baseQueryApi_1, endpointDefinition.extraOptions);
                            })
                        ];
                    case 5:
                        result = _r.sent();
                        _r.label = 6;
                    case 6:
                        typeof $ibaza;
                        if (result.error) throw new $b8ac28d277d3b6c7$var$HandledError(result.error, result.meta);
                        _m = fulfillWithValue;
                        return [
                            4 /*yield*/ ,
                            transformResponse(result.data, result.meta, arg.originalArgs)
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _m.apply(void 0, [
                                _r.sent(),
                                (_p = {
                                    fulfilledTimeStamp: Date.now(),
                                    baseQueryMeta: result.meta
                                }, _p[0, $c0Lyo.SHOULD_AUTOBATCH] = true, _p)
                            ])
                        ];
                    case 8:
                        error_1 = _r.sent();
                        catchedError = error_1;
                        if (!(catchedError instanceof $b8ac28d277d3b6c7$var$HandledError)) return [
                            3 /*break*/ ,
                            12
                        ];
                        transformErrorResponse = $b8ac28d277d3b6c7$var$defaultTransformResponse;
                        if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                        _r.label = 9;
                    case 9:
                        _r.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        _o = rejectWithValue;
                        return [
                            4 /*yield*/ ,
                            transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs)
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _o.apply(void 0, [
                                _r.sent(),
                                (_q = {
                                    baseQueryMeta: catchedError.meta
                                }, _q[0, $c0Lyo.SHOULD_AUTOBATCH] = true, _q)
                            ])
                        ];
                    case 11:
                        e_4 = _r.sent();
                        catchedError = e_4;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 12:
                        typeof $ibaza;
                        console.error(catchedError);
                        throw catchedError;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    function isForcedQuery(arg, state) {
        var _a, _b, _c, _d;
        var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[arg.queryCacheKey];
        var baseFetchOnMountOrArgChange = (_c = state[reducerPath]) == null ? void 0 : _c.config.refetchOnMountOrArgChange;
        var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        var refetchVal = (_d = arg.forceRefetch) != null ? _d : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    var queryThunk = (0, $c0Lyo.createAsyncThunk)(reducerPath + "/executeQuery", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $c0Lyo.SHOULD_AUTOBATCH] = true, _j;
        },
        condition: function(queryThunkArgs, _j) {
            var getState = _j.getState;
            var _a, _b, _c;
            var state = getState();
            var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[queryThunkArgs.queryCacheKey];
            var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
            var currentArg = queryThunkArgs.originalArgs;
            var previousArg = requestState == null ? void 0 : requestState.originalArgs;
            var endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if ($b8ac28d277d3b6c7$var$isUpsertQuery(queryThunkArgs)) return true;
            if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if ($b8ac28d277d3b6c7$var$isQueryDefinition(endpointDefinition) && ((_c = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _c.call(endpointDefinition, {
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            }))) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    var mutationThunk = (0, $c0Lyo.createAsyncThunk)(reducerPath + "/executeMutation", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $c0Lyo.SHOULD_AUTOBATCH] = true, _j;
        }
    });
    var hasTheForce = function(options) {
        return "force" in options;
    };
    var hasMaxAge = function(options) {
        return "ifOlderThan" in options;
    };
    var prefetch = function(endpointName, arg, options) {
        return function(dispatch, getState) {
            var force = hasTheForce(options) && options.force;
            var maxAge = hasMaxAge(options) && options.ifOlderThan;
            var queryAction = function(force2) {
                if (force2 === void 0) force2 = true;
                return api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            };
            var latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                var lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                var shouldRetrigger = (Number(new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    };
    function matchesEndpoint(endpointName) {
        return function(action) {
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $c0Lyo.isAllOf)((0, $c0Lyo.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $c0Lyo.isAllOf)((0, $c0Lyo.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $c0Lyo.isAllOf)((0, $c0Lyo.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $b8ac28d277d3b6c7$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $b8ac28d277d3b6c7$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $c0Lyo.isFulfilled)(action) ? action.payload : void 0, (0, $c0Lyo.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $b8ac28d277d3b6c7$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    var substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $b8ac28d277d3b6c7$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $b8ac28d277d3b6c7$var$updateMutationSubstateIfExists(state, id, update) {
    var substate = state[$b8ac28d277d3b6c7$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $b8ac28d277d3b6c7$var$initialState = {};
function $b8ac28d277d3b6c7$var$buildSlice(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, _k = _j.context, definitions = _k.endpointDefinitions, apiUid = _k.apiUid, extractRehydrationInfo = _k.extractRehydrationInfo, hasRehydrationInfo = _k.hasRehydrationInfo, assertTagType = _j.assertTagType, config = _j.config;
    var resetApiState = (0, $c0Lyo.createAction)(reducerPath + "/resetApiState");
    var querySlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/queries",
        initialState: $b8ac28d277d3b6c7$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer: function(draft, _j) {
                    var queryCacheKey = _j.payload.queryCacheKey;
                    delete draft[queryCacheKey];
                },
                prepare: (0, $c0Lyo.prepareAutoBatched)()
            },
            queryResultPatched: function(draft, _j) {
                var _k = _j.payload, queryCacheKey = _k.queryCacheKey, patches = _k.patches;
                $b8ac28d277d3b6c7$var$updateQuerySubstateIfExists(draft, queryCacheKey, function(substate) {
                    substate.data = (0, $3Llm4.applyPatches)(substate.data, patches.concat());
                });
            }
        },
        extraReducers: function(builder) {
            builder.addCase(queryThunk.pending, function(draft, _j) {
                var meta = _j.meta, arg = _j.meta.arg;
                var _a, _b;
                var upserting = $b8ac28d277d3b6c7$var$isUpsertQuery(arg);
                if (arg.subscribe || upserting) (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
                    status: $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized,
                    endpointName: arg.endpointName
                };
                $b8ac28d277d3b6c7$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    substate.status = $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.pending;
                    substate.requestId = upserting && substate.requestId ? substate.requestId : meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, function(draft, _j) {
                var meta = _j.meta, payload = _j.payload;
                $b8ac28d277d3b6c7$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, function(substate) {
                    var _a;
                    if (substate.requestId !== meta.requestId && !$b8ac28d277d3b6c7$var$isUpsertQuery(meta.arg)) return;
                    var merge = definitions[meta.arg.endpointName].merge;
                    substate.status = $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.fulfilled;
                    if (merge) {
                        if (substate.data !== void 0) {
                            var fulfilledTimeStamp_1 = meta.fulfilledTimeStamp, arg_1 = meta.arg, baseQueryMeta_1 = meta.baseQueryMeta, requestId_1 = meta.requestId;
                            var newData = (0, $3Llm4.default)(substate.data, function(draftSubstateData) {
                                return merge(draftSubstateData, payload, {
                                    arg: arg_1.originalArgs,
                                    baseQueryMeta: baseQueryMeta_1,
                                    fulfilledTimeStamp: fulfilledTimeStamp_1,
                                    requestId: requestId_1
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $b8ac28d277d3b6c7$export$b64d4502a1c929bd((0, $3Llm4.isDraft)(substate.data) ? (0, $3Llm4.original)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, function(draft, _j) {
                var _k = _j.meta, condition = _k.condition, arg = _k.arg, requestId = _k.requestId, error = _j.error, payload = _j.payload;
                $b8ac28d277d3b6c7$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.rejected;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var queries = extractRehydrationInfo(action).queries;
                for(var _j = 0, _k = Object.entries(queries); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if ((entry == null ? void 0 : entry.status) === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.rejected) draft[key] = entry;
                }
            });
        }
    });
    var mutationSlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/mutations",
        initialState: $b8ac28d277d3b6c7$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer: function(draft, _j) {
                    var payload = _j.payload;
                    var cacheKey = $b8ac28d277d3b6c7$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $c0Lyo.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(mutationThunk.pending, function(draft, _j) {
                var meta = _j.meta, _k = _j.meta, requestId = _k.requestId, arg = _k.arg, startedTimeStamp = _k.startedTimeStamp;
                if (!arg.track) return;
                draft[$b8ac28d277d3b6c7$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.pending,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, function(draft, _j) {
                var payload = _j.payload, meta = _j.meta;
                if (!meta.arg.track) return;
                $b8ac28d277d3b6c7$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.fulfilled;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, function(draft, _j) {
                var payload = _j.payload, error = _j.error, meta = _j.meta;
                if (!meta.arg.track) return;
                $b8ac28d277d3b6c7$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.rejected;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var mutations = extractRehydrationInfo(action).mutations;
                for(var _j = 0, _k = Object.entries(mutations); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if (((entry == null ? void 0 : entry.status) === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.rejected) && key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
                }
            });
        }
    });
    var invalidationSlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/invalidation",
        initialState: $b8ac28d277d3b6c7$var$initialState,
        reducers: {},
        extraReducers: function(builder) {
            builder.addCase(querySlice.actions.removeQueryResult, function(draft, _j) {
                var queryCacheKey = _j.payload.queryCacheKey;
                for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                    var tagTypeSubscriptions = _l[_k];
                    for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                        var idSubscriptions = _o[_m];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var _a, _b, _c, _d;
                var provided = extractRehydrationInfo(action).provided;
                for(var _j = 0, _k = Object.entries(provided); _j < _k.length; _j++){
                    var _l = _k[_j], type = _l[0], incomingTags = _l[1];
                    for(var _m = 0, _o = Object.entries(incomingTags); _m < _o.length; _m++){
                        var _p = _o[_m], id = _p[0], cacheKeys = _p[1];
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        for(var _q = 0, cacheKeys_1 = cacheKeys; _q < cacheKeys_1.length; _q++){
                            var queryCacheKey = cacheKeys_1[_q];
                            var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                    }
                }
            }).addMatcher((0, $c0Lyo.isAnyOf)((0, $c0Lyo.isFulfilled)(queryThunk), (0, $c0Lyo.isRejectedWithValue)(queryThunk)), function(draft, action) {
                var _a, _b, _c, _d;
                var providedTags = $b8ac28d277d3b6c7$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                var queryCacheKey = action.meta.arg.queryCacheKey;
                for(var _j = 0, _k = Object.values(draft); _j < _k.length; _j++){
                    var tagTypeSubscriptions = _k[_j];
                    for(var _l = 0, _m = Object.values(tagTypeSubscriptions); _l < _m.length; _l++){
                        var idSubscriptions = _m[_l];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
                for(var _o = 0, providedTags_1 = providedTags; _o < providedTags_1.length; _o++){
                    var _p = providedTags_1[_o], type = _p.type, id = _p.id;
                    var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                    var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                    if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                }
            });
        }
    });
    var subscriptionSlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/subscriptions",
        initialState: $b8ac28d277d3b6c7$var$initialState,
        reducers: {
            updateSubscriptionOptions: function(d, a) {},
            unsubscribeQueryResult: function(d, a) {},
            internal_probeSubscription: function(d, a) {}
        }
    });
    var internalSubscriptionsSlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/internalSubscriptions",
        initialState: $b8ac28d277d3b6c7$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer: function(state, action) {
                    return (0, $3Llm4.applyPatches)(state, action.payload);
                },
                prepare: (0, $c0Lyo.prepareAutoBatched)()
            }
        }
    });
    var configSlice = (0, $c0Lyo.createSlice)({
        name: reducerPath + "/config",
        initialState: $b8ac28d277d3b6c7$var$__spreadValues({
            online: $b8ac28d277d3b6c7$var$isOnline(),
            focused: $b8ac28d277d3b6c7$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered: function(state, _j) {
                var payload = _j.payload;
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: function(builder) {
            builder.addCase($b8ac28d277d3b6c7$var$onOnline, function(state) {
                state.online = true;
            }).addCase($b8ac28d277d3b6c7$var$onOffline, function(state) {
                state.online = false;
            }).addCase($b8ac28d277d3b6c7$var$onFocus, function(state) {
                state.focused = true;
            }).addCase($b8ac28d277d3b6c7$var$onFocusLost, function(state) {
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, function(draft) {
                return $b8ac28d277d3b6c7$var$__spreadValues({}, draft);
            });
        }
    });
    var combinedReducer = (0, $41dmB.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    var reducer = function(state, action) {
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    var actions = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), {
        unsubscribeMutationResult: mutationSlice.actions.removeMutationResult,
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $b8ac28d277d3b6c7$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $b8ac28d277d3b6c7$export$8b2f5cccb7eda71d = $b8ac28d277d3b6c7$export$1aa5a89531b7670d;
var $b8ac28d277d3b6c7$var$initialSubState = {
    status: $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized
};
var $b8ac28d277d3b6c7$var$defaultQuerySubState = /* @__PURE__ */ (0, $3Llm4.default)($b8ac28d277d3b6c7$var$initialSubState, function() {});
var $b8ac28d277d3b6c7$var$defaultMutationSubState = /* @__PURE__ */ (0, $3Llm4.default)($b8ac28d277d3b6c7$var$initialSubState, function() {});
function $b8ac28d277d3b6c7$var$buildSelectors(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, reducerPath = _j.reducerPath;
    var selectSkippedQuery = function(state) {
        return $b8ac28d277d3b6c7$var$defaultQuerySubState;
    };
    var selectSkippedMutation = function(state) {
        return $b8ac28d277d3b6c7$var$defaultMutationSubState;
    };
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy
    };
    function withRequestFlags(substate) {
        return $b8ac28d277d3b6c7$var$__spreadValues($b8ac28d277d3b6c7$var$__spreadValues({}, substate), $b8ac28d277d3b6c7$var$getRequestStatusFlags(substate.status));
    }
    function selectInternalState(rootState) {
        var state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return function(queryArgs) {
            var serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            var selectQuerySubstate = function(state) {
                var _a, _b, _c;
                return (_c = (_b = (_a = selectInternalState(state)) == null ? void 0 : _a.queries) == null ? void 0 : _b[serializedArgs]) != null ? _c : $b8ac28d277d3b6c7$var$defaultQuerySubState;
            };
            var finalSelectQuerySubState = queryArgs === $b8ac28d277d3b6c7$export$1aa5a89531b7670d ? selectSkippedQuery : selectQuerySubstate;
            return (0, $4Xu5k.createSelector)(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return function(id) {
            var _a;
            var mutationId;
            if (typeof id === "object") mutationId = (_a = $b8ac28d277d3b6c7$var$getMutationCacheKey(id)) != null ? _a : $b8ac28d277d3b6c7$export$1aa5a89531b7670d;
            else mutationId = id;
            var selectMutationSubstate = function(state) {
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectInternalState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $b8ac28d277d3b6c7$var$defaultMutationSubState;
            };
            var finalSelectMutationSubstate = mutationId === $b8ac28d277d3b6c7$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return (0, $4Xu5k.createSelector)(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        var apiState = state[reducerPath];
        var toInvalidate = new Set();
        for(var _j = 0, _k = tags.map($b8ac28d277d3b6c7$var$expandTagDescription); _j < _k.length; _j++){
            var tag = _k[_j];
            var provided = apiState.provided[tag.type];
            if (!provided) continue;
            var invalidateSubscriptions = (_a = tag.id !== void 0 ? provided[tag.id] : $b8ac28d277d3b6c7$var$flatten(Object.values(provided))) != null ? _a : [];
            for(var _l = 0, invalidateSubscriptions_1 = invalidateSubscriptions; _l < invalidateSubscriptions_1.length; _l++){
                var invalidate = invalidateSubscriptions_1[_l];
                toInvalidate.add(invalidate);
            }
        }
        return $b8ac28d277d3b6c7$var$flatten(Array.from(toInvalidate.values()).map(function(queryCacheKey) {
            var querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
}
var $b8ac28d277d3b6c7$var$cache = WeakMap ? new WeakMap() : void 0;
var $b8ac28d277d3b6c7$export$db8e4edac9bbb67b = function(_j) {
    var endpointName = _j.endpointName, queryArgs = _j.queryArgs;
    var serialized = "";
    var cached = $b8ac28d277d3b6c7$var$cache == null ? void 0 : $b8ac28d277d3b6c7$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $c0Lyo.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $c0Lyo.isPlainObject)(queryArgs)) $b8ac28d277d3b6c7$var$cache == null || $b8ac28d277d3b6c7$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
function $b8ac28d277d3b6c7$export$f957748792d43646() {
    var modules = [];
    for(var _j = 0; _j < arguments.length; _j++)modules[_j] = arguments[_j];
    return function baseCreateApi(options) {
        var extractRehydrationInfo = (0, $fUOIv.defaultMemoize)(function(action) {
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        var optionsWithDefaults = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs: function(queryArgsApi) {
                var finalSerializeQueryArgs = $b8ac28d277d3b6c7$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    var endpointSQA_1 = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = function(queryArgsApi2) {
                        var initialResult = endpointSQA_1(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $b8ac28d277d3b6c7$export$db8e4edac9bbb67b($b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: $b8ac28d277d3b6c7$var$__spreadArray([], options.tagTypes || [])
        });
        var context = {
            endpointDefinitions: {},
            batch: function(fn) {
                fn();
            },
            apiUid: (0, $c0Lyo.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $fUOIv.defaultMemoize)(function(action) {
                return extractRehydrationInfo(action) != null;
            })
        };
        var api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints: function(_j) {
                var addTagTypes = _j.addTagTypes, endpoints = _j.endpoints;
                if (addTagTypes) for(var _k = 0, addTagTypes_1 = addTagTypes; _k < addTagTypes_1.length; _k++){
                    var eT = addTagTypes_1[_k];
                    if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for(var _l = 0, _m = Object.entries(endpoints); _l < _m.length; _l++){
                    var _o = _m[_l], endpointName = _o[0], partialDefinition = _o[1];
                    if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        var initializedModules = modules.map(function(m) {
            return m.init(api, optionsWithDefaults, context);
        });
        function injectEndpoints(inject) {
            var evaluatedEndpoints = inject.endpoints({
                query: function(x) {
                    return $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, x), {
                        type: $b8ac28d277d3b6c7$var$DefinitionType.query
                    });
                },
                mutation: function(x) {
                    return $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, x), {
                        type: $b8ac28d277d3b6c7$var$DefinitionType.mutation
                    });
                }
            });
            for(var _j = 0, _k = Object.entries(evaluatedEndpoints); _j < _k.length; _j++){
                var _l = _k[_j], endpointName = _l[0], definition = _l[1];
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof $ibaza;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for(var _m = 0, initializedModules_1 = initializedModules; _m < initializedModules_1.length; _m++){
                    var m = initializedModules_1[_m];
                    m.injectEndpoint(endpointName, definition);
                }
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
// src/query/fakeBaseQuery.ts
function $b8ac28d277d3b6c7$export$f72b22d3ac378bae() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function $b8ac28d277d3b6c7$var$isObjectEmpty(obj) {
    for(var k in obj)return false;
    return true;
}
var $b8ac28d277d3b6c7$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $b8ac28d277d3b6c7$var$buildCacheCollectionHandler = function(_j) {
    var reducerPath = _j.reducerPath, api = _j.api, context = _j.context, internalState = _j.internalState;
    var _k = api.internalActions, removeQueryResult = _k.removeQueryResult, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$b8ac28d277d3b6c7$var$isObjectEmpty(subscriptions);
    }
    var currentRemovalTimeouts = {};
    var handler = function(action, mwApi, internalState2) {
        var _a;
        if (unsubscribeQueryResult.match(action)) {
            var state = mwApi.getState()[reducerPath];
            var queryCacheKey = action.payload.queryCacheKey;
            handleUnsubscribe(queryCacheKey, (_a = state.queries[queryCacheKey]) == null ? void 0 : _a.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(currentRemovalTimeouts); _j < _k.length; _j++){
            var _l = _k[_j], key = _l[0], timeout = _l[1];
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            var state = mwApi.getState()[reducerPath];
            var queries = context.extractRehydrationInfo(action).queries;
            for(var _m = 0, _o = Object.entries(queries); _m < _o.length; _m++){
                var _p = _o[_m], queryCacheKey = _p[0], queryState = _p[1];
                handleUnsubscribe(queryCacheKey, queryState == null ? void 0 : queryState.endpointName, mwApi, state.config);
            }
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        var finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $b8ac28d277d3b6c7$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            var currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(function() {
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
var $b8ac28d277d3b6c7$var$buildInvalidationByTagsHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, endpointDefinitions = _j.context.endpointDefinitions, mutationThunk = _j.mutationThunk, api = _j.api, assertTagType = _j.assertTagType, refetchQuery = _j.refetchQuery;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var isThunkActionWithTags = (0, $c0Lyo.isAnyOf)((0, $c0Lyo.isFulfilled)(mutationThunk), (0, $c0Lyo.isRejectedWithValue)(mutationThunk));
    var handler = function(action, mwApi) {
        if (isThunkActionWithTags(action)) invalidateTags($b8ac28d277d3b6c7$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        if (api.util.invalidateTags.match(action)) invalidateTags($b8ac28d277d3b6c7$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function invalidateTags(tags, mwApi) {
        var rootState = mwApi.getState();
        var state = rootState[reducerPath];
        var toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(function() {
            var _a;
            var valuesArray = Array.from(toInvalidate.values());
            for(var _j = 0, valuesArray_1 = valuesArray; _j < valuesArray_1.length; _j++){
                var queryCacheKey = valuesArray_1[_j].queryCacheKey;
                var querySubState = state.queries[queryCacheKey];
                var subscriptionSubState = (_a = state.subscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if (Object.keys(subscriptionSubState).length === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $b8ac28d277d3b6c7$var$buildPollingHandler = function(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var currentPolls = {};
    var handler = function(action, mwApi) {
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        var currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        var currentInterval = currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(function() {
                currentInterval.timeout = void 0;
                api2.dispatch(refetchQuery(querySubState, queryCacheKey));
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        var currentPoll = currentPolls[queryCacheKey];
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        var existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for(var _j = 0, _k = Object.keys(currentPolls); _j < _k.length; _j++){
            var key = _k[_j];
            cleanupPollForKey(key);
        }
    }
    function findLowestPollingInterval(subscribers) {
        if (subscribers === void 0) subscribers = {};
        var lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(var key in subscribers)if (!!subscribers[key].pollingInterval) lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
        return lowestPollingInterval;
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $b8ac28d277d3b6c7$var$buildWindowEventHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var handler = function(action, mwApi) {
        if ($b8ac28d277d3b6c7$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($b8ac28d277d3b6c7$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        var state = api2.getState()[reducerPath];
        var queries = state.queries;
        var subscriptions = internalState.currentSubscriptions;
        context.batch(function() {
            for(var _j = 0, _k = Object.keys(subscriptions); _j < _k.length; _j++){
                var queryCacheKey = _k[_j];
                var querySubState = queries[queryCacheKey];
                var subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                var shouldRefetch = Object.values(subscriptionSubState).some(function(sub) {
                    return sub[type] === true;
                }) || Object.values(subscriptionSubState).every(function(sub) {
                    return sub[type] === void 0;
                }) && state.config[type];
                if (shouldRefetch) {
                    if (Object.keys(subscriptionSubState).length === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $b8ac28d277d3b6c7$export$f4258b89f6bad1d6.uninitialized) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
var $b8ac28d277d3b6c7$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $b8ac28d277d3b6c7$var$buildCacheLifecycleHandler = function(_j) {
    var api = _j.api, reducerPath = _j.reducerPath, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, internalState = _j.internalState;
    var isQueryThunk = (0, $c0Lyo.isAsyncThunkAction)(queryThunk);
    var isMutationThunk = (0, $c0Lyo.isAsyncThunkAction)(mutationThunk);
    var isFulfilledThunk = (0, $c0Lyo.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi, stateBefore) {
        var cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            var oldState = stateBefore[reducerPath].queries[cacheKey];
            var state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            var state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(lifecycleMap); _j < _k.length; _j++){
            var _l = _k[_j], cacheKey2 = _l[0], lifecycle = _l[1];
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $b8ac28d277d3b6c7$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        var lifecycle = {};
        var cacheEntryRemoved = new Promise(function(resolve) {
            lifecycle.cacheEntryRemoved = resolve;
        });
        var cacheDataLoaded = Promise.race([
            new Promise(function(resolve) {
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(function() {
                throw $b8ac28d277d3b6c7$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(function() {});
        lifecycleMap[queryCacheKey] = lifecycle;
        var selector = api.endpoints[endpointName].select(endpointDefinition.type === $b8ac28d277d3b6c7$var$DefinitionType.query ? originalArgs : queryCacheKey);
        var extra = mwApi.dispatch(function(_, __, extra2) {
            return extra2;
        });
        var lifecycleApi = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, mwApi), {
            getCacheEntry: function() {
                return selector(mwApi.getState());
            },
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === $b8ac28d277d3b6c7$var$DefinitionType.query ? function(updateRecipe) {
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        var runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch(function(e) {
            if (e === $b8ac28d277d3b6c7$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
var $b8ac28d277d3b6c7$var$buildQueryLifecycleHandler = function(_j) {
    var api = _j.api, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk;
    var isPendingThunk = (0, $c0Lyo.isPending)(queryThunk, mutationThunk);
    var isRejectedThunk = (0, $c0Lyo.isRejected)(queryThunk, mutationThunk);
    var isFullfilledThunk = (0, $c0Lyo.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi) {
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            var _j = action.meta, requestId = _j.requestId, _k = _j.arg, endpointName_1 = _k.endpointName, originalArgs_1 = _k.originalArgs;
            var endpointDefinition = context.endpointDefinitions[endpointName_1];
            var onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                var lifecycle_1 = {};
                var queryFulfilled = new Promise(function(resolve, reject) {
                    lifecycle_1.resolve = resolve;
                    lifecycle_1.reject = reject;
                });
                queryFulfilled.catch(function() {});
                lifecycleMap[requestId] = lifecycle_1;
                var selector_1 = api.endpoints[endpointName_1].select(endpointDefinition.type === $b8ac28d277d3b6c7$var$DefinitionType.query ? originalArgs_1 : requestId);
                var extra = mwApi.dispatch(function(_, __, extra2) {
                    return extra2;
                });
                var lifecycleApi = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, mwApi), {
                    getCacheEntry: function() {
                        return selector_1(mwApi.getState());
                    },
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === $b8ac28d277d3b6c7$var$DefinitionType.query ? function(updateRecipe) {
                        return mwApi.dispatch(api.util.updateQueryData(endpointName_1, originalArgs_1, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs_1, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            var _l = action.meta, requestId = _l.requestId, baseQueryMeta = _l.baseQueryMeta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            var _m = action.meta, requestId = _m.requestId, rejectedWithValue = _m.rejectedWithValue, baseQueryMeta = _m.baseQueryMeta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $b8ac28d277d3b6c7$var$buildDevCheckHandler = function(_j) {
    var api = _j.api, apiUid = _j.context.apiUid, reducerPath = _j.reducerPath;
    return function(action, mwApi) {
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $ibaza;
    };
};
var $b8ac28d277d3b6c7$var$promise;
var $b8ac28d277d3b6c7$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($b8ac28d277d3b6c7$var$promise || ($b8ac28d277d3b6c7$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $b8ac28d277d3b6c7$var$buildBatchedActionsHandler = function(_j) {
    var api = _j.api, queryThunk = _j.queryThunk, internalState = _j.internalState;
    var subscriptionsPrefix = api.reducerPath + "/subscriptions";
    var previousSubscriptions = null;
    var dispatchQueued = false;
    var _k = api.internalActions, updateSubscriptionOptions = _k.updateSubscriptionOptions, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    var actuallyMutateSubscriptions = function(mutableState, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId, options = _j.options;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            var _k = action.payload, queryCacheKey = _k.queryCacheKey, requestId = _k.requestId;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            var _l = action.meta, arg = _l.arg, requestId = _l.requestId;
            if (arg.subscribe) {
                var substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
                substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
                return true;
            }
        }
        if (queryThunk.rejected.match(action)) {
            var _m = action.meta, condition = _m.condition, arg = _m.arg, requestId = _m.requestId;
            if (condition && arg.subscribe) {
                var substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                return true;
            }
        }
        return false;
    };
    return function(action, mwApi) {
        var _a, _b;
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_probeSubscription.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId;
            var hasSubscription = !!((_a = internalState.currentSubscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
            return [
                false,
                hasSubscription
            ];
        }
        var didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate) {
            if (!dispatchQueued) {
                $b8ac28d277d3b6c7$var$queueMicrotaskShim(function() {
                    var newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                    var _j = (0, $3Llm4.produceWithPatches)(previousSubscriptions, function() {
                        return newSubscriptions;
                    }), patches = _j[1];
                    mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                    previousSubscriptions = newSubscriptions;
                    dispatchQueued = false;
                });
                dispatchQueued = true;
            }
            var isSubscriptionSliceAction = !!((_b = action.type) == null ? void 0 : _b.startsWith(subscriptionsPrefix));
            var isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            var actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
            return [
                actionShouldContinue,
                false
            ];
        }
        return [
            true,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function $b8ac28d277d3b6c7$var$buildMiddleware(input) {
    var reducerPath = input.reducerPath, queryThunk = input.queryThunk, api = input.api, context = input.context;
    var apiUid = context.apiUid;
    var actions = {
        invalidateTags: (0, $c0Lyo.createAction)(reducerPath + "/invalidateTags")
    };
    var isThisApiSliceAction = function(action) {
        return !!action && typeof action.type === "string" && action.type.startsWith(reducerPath + "/");
    };
    var handlerBuilders = [
        $b8ac28d277d3b6c7$var$buildDevCheckHandler,
        $b8ac28d277d3b6c7$var$buildCacheCollectionHandler,
        $b8ac28d277d3b6c7$var$buildInvalidationByTagsHandler,
        $b8ac28d277d3b6c7$var$buildPollingHandler,
        $b8ac28d277d3b6c7$var$buildCacheLifecycleHandler,
        $b8ac28d277d3b6c7$var$buildQueryLifecycleHandler
    ];
    var middleware = function(mwApi) {
        var initialized2 = false;
        var internalState = {
            currentSubscriptions: {}
        };
        var builderArgs = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery
        });
        var handlers = handlerBuilders.map(function(build) {
            return build(builderArgs);
        });
        var batchedActionsHandler = $b8ac28d277d3b6c7$var$buildBatchedActionsHandler(builderArgs);
        var windowEventsHandler = $b8ac28d277d3b6c7$var$buildWindowEventHandler(builderArgs);
        return function(next) {
            return function(action) {
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                var mwApiWithNext = $b8ac28d277d3b6c7$var$__spreadProps($b8ac28d277d3b6c7$var$__spreadValues({}, mwApi), {
                    next: next
                });
                var stateBefore = mwApi.getState();
                var _j = batchedActionsHandler(action, mwApiWithNext, stateBefore), actionShouldContinue = _j[0], hasSubscription = _j[1];
                var res;
                if (actionShouldContinue) res = next(action);
                else res = hasSubscription;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for(var _k = 0, handlers_1 = handlers; _k < handlers_1.length; _k++){
                        var handler = handlers_1[_k];
                        handler(action, mwApiWithNext, stateBefore);
                    }
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override) {
        if (override === void 0) override = {};
        return queryThunk($b8ac28d277d3b6c7$var$__spreadValues({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey
        }, override));
    }
}
// src/query/tsHelpers.ts
function $b8ac28d277d3b6c7$var$assertCast(v) {}
function $b8ac28d277d3b6c7$var$safeAssign(target) {
    var args = [];
    for(var _j = 1; _j < arguments.length; _j++)args[_j - 1] = arguments[_j];
    Object.assign.apply(Object, $b8ac28d277d3b6c7$var$__spreadArray([
        target
    ], args));
}
var $b8ac28d277d3b6c7$var$coreModuleName = /* @__PURE__ */ Symbol();
var $b8ac28d277d3b6c7$export$eb718ff92afd6f9b = function() {
    return {
        name: $b8ac28d277d3b6c7$var$coreModuleName,
        init: function(api, _j, context) {
            var baseQuery = _j.baseQuery, tagTypes = _j.tagTypes, reducerPath = _j.reducerPath, serializeQueryArgs = _j.serializeQueryArgs, keepUnusedDataFor = _j.keepUnusedDataFor, refetchOnMountOrArgChange = _j.refetchOnMountOrArgChange, refetchOnFocus = _j.refetchOnFocus, refetchOnReconnect = _j.refetchOnReconnect;
            (0, $3Llm4.enablePatches)();
            $b8ac28d277d3b6c7$var$assertCast(serializeQueryArgs);
            var assertTagType = function(tag) {
                typeof $ibaza;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $b8ac28d277d3b6c7$var$onOnline,
                    onOffline: $b8ac28d277d3b6c7$var$onOffline,
                    onFocus: $b8ac28d277d3b6c7$var$onFocus,
                    onFocusLost: $b8ac28d277d3b6c7$var$onFocusLost
                },
                util: {}
            });
            var _k = $b8ac28d277d3b6c7$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs
            }), queryThunk = _k.queryThunk, mutationThunk = _k.mutationThunk, patchQueryData = _k.patchQueryData, updateQueryData = _k.updateQueryData, upsertQueryData = _k.upsertQueryData, prefetch = _k.prefetch, buildMatchThunkActions = _k.buildMatchThunkActions;
            var _l = $b8ac28d277d3b6c7$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath
                }
            }), reducer = _l.reducer, sliceActions = _l.actions;
            $b8ac28d277d3b6c7$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            $b8ac28d277d3b6c7$var$safeAssign(api.internalActions, sliceActions);
            var _m = $b8ac28d277d3b6c7$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            }), middleware = _m.middleware, middlewareActions = _m.actions;
            $b8ac28d277d3b6c7$var$safeAssign(api.util, middlewareActions);
            $b8ac28d277d3b6c7$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            var _o = $b8ac28d277d3b6c7$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath
            }), buildQuerySelector = _o.buildQuerySelector, buildMutationSelector = _o.buildMutationSelector, selectInvalidatedBy = _o.selectInvalidatedBy;
            $b8ac28d277d3b6c7$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy
            });
            var _p = $b8ac28d277d3b6c7$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildInitiateQuery = _p.buildInitiateQuery, buildInitiateMutation = _p.buildInitiateMutation, getRunningMutationThunk = _p.getRunningMutationThunk, getRunningMutationsThunk = _p.getRunningMutationsThunk, getRunningQueriesThunk = _p.getRunningQueriesThunk, getRunningQueryThunk = _p.getRunningQueryThunk, getRunningOperationPromises = _p.getRunningOperationPromises, removalWarning = _p.removalWarning;
            $b8ac28d277d3b6c7$var$safeAssign(api.util, {
                getRunningOperationPromises: getRunningOperationPromises,
                getRunningOperationPromise: removalWarning,
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $b8ac28d277d3b6c7$var$coreModuleName,
                injectEndpoint: function(endpointName, definition) {
                    var _a, _b;
                    var anyApi = api;
                    (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($b8ac28d277d3b6c7$var$isQueryDefinition(definition)) $b8ac28d277d3b6c7$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if ($b8ac28d277d3b6c7$var$isMutationDefinition(definition)) $b8ac28d277d3b6c7$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    };
};
// src/query/core/index.ts
var $b8ac28d277d3b6c7$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $b8ac28d277d3b6c7$export$f957748792d43646($b8ac28d277d3b6c7$export$eb718ff92afd6f9b());

});

parcelRegister("hJZ3Y", function(module, exports) {

$parcel$export(module.exports, "persistReducer", () => (parcelRequire("5W88v")).default);
$parcel$export(module.exports, "persistStore", () => (parcelRequire("jBKhA")).default);

var $5W88v = parcelRequire("5W88v");

var $cxX95 = parcelRequire("cxX95");

var $jBKhA = parcelRequire("jBKhA");

var $bUN0h = parcelRequire("bUN0h");

var $1URFs = parcelRequire("1URFs");

var $jvFxh = parcelRequire("jvFxh");

var $f1oe3 = parcelRequire("f1oe3");

var $ftAdO = parcelRequire("ftAdO");
parcelRequire("lVtl0");

});
parcelRegister("5W88v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4528ae336eaae69b$export$2e2bcd8739ae039);

var $lVtl0 = parcelRequire("lVtl0");

var $fov52 = parcelRequire("fov52");

var $f1oe3 = parcelRequire("f1oe3");

var $jvFxh = parcelRequire("jvFxh");

var $ftAdO = parcelRequire("ftAdO");
function $4528ae336eaae69b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4528ae336eaae69b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4528ae336eaae69b$var$ownKeys(source, true).forEach(function(key) {
            $4528ae336eaae69b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4528ae336eaae69b$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4528ae336eaae69b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4528ae336eaae69b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4528ae336eaae69b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4528ae336eaae69b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4528ae336eaae69b$var$DEFAULT_TIMEOUT = 5000;
function $4528ae336eaae69b$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $lVtl0.DEFAULT_VERSION);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $fov52.default) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $jvFxh.default);
    var timeout = config.timeout !== undefined ? config.timeout : $4528ae336eaae69b$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $4528ae336eaae69b$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $lVtl0.PERSIST)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $f1oe3.default)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $4528ae336eaae69b$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $4528ae336eaae69b$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $lVtl0.PURGE)) {
            _purge = true;
            action.result((0, $ftAdO.default)(config));
            return $4528ae336eaae69b$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $lVtl0.FLUSH)) {
            action.result(_persistoid && _persistoid.flush());
            return $4528ae336eaae69b$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $lVtl0.PAUSE)) _paused = true;
        else if (action.type === (0, $lVtl0.REHYDRATE)) {
            // noop on restState if purging
            if (_purge) return $4528ae336eaae69b$var$_objectSpread({}, restState, {
                _persist: $4528ae336eaae69b$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $4528ae336eaae69b$var$_objectSpread({}, reconciledRest, {
                    _persist: $4528ae336eaae69b$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($4528ae336eaae69b$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}

});
parcelRegister("lVtl0", function(module, exports) {

$parcel$export(module.exports, "KEY_PREFIX", () => $ff65adb83c4df070$export$711117ad6ad27992);
$parcel$export(module.exports, "FLUSH", () => $ff65adb83c4df070$export$2aaee4793dd13a52);
$parcel$export(module.exports, "REHYDRATE", () => $ff65adb83c4df070$export$1647ef958242c4e2);
$parcel$export(module.exports, "PAUSE", () => $ff65adb83c4df070$export$dd1033c27a16bbd3);
$parcel$export(module.exports, "PERSIST", () => $ff65adb83c4df070$export$913fe0e161ed92a2);
$parcel$export(module.exports, "PURGE", () => $ff65adb83c4df070$export$5514fc3b4067675f);
$parcel$export(module.exports, "REGISTER", () => $ff65adb83c4df070$export$51e82cdd7353a0e1);
$parcel$export(module.exports, "DEFAULT_VERSION", () => $ff65adb83c4df070$export$363ebe89e6e7aeef);
var $ff65adb83c4df070$export$711117ad6ad27992 = 'persist:';
var $ff65adb83c4df070$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $ff65adb83c4df070$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $ff65adb83c4df070$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $ff65adb83c4df070$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $ff65adb83c4df070$export$5514fc3b4067675f = 'persist/PURGE';
var $ff65adb83c4df070$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $ff65adb83c4df070$export$363ebe89e6e7aeef = -1;

});

parcelRegister("fov52", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35134cdcf2613e0$export$2e2bcd8739ae039);
function $b35134cdcf2613e0$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b35134cdcf2613e0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b35134cdcf2613e0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b35134cdcf2613e0$var$_typeof(obj);
}
function $b35134cdcf2613e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b35134cdcf2613e0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b35134cdcf2613e0$var$ownKeys(source, true).forEach(function(key) {
            $b35134cdcf2613e0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b35134cdcf2613e0$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b35134cdcf2613e0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b35134cdcf2613e0$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $b35134cdcf2613e0$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $b35134cdcf2613e0$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}

});

parcelRegister("f1oe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef9bdbf8c238b13$export$2e2bcd8739ae039);

var $lVtl0 = parcelRequire("lVtl0");
function $aef9bdbf8c238b13$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $lVtl0.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $aef9bdbf8c238b13$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $aef9bdbf8c238b13$var$defaultSerialize(data) {
    return JSON.stringify(data);
}

});

parcelRegister("jvFxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34121b6e92a8f6d$export$2e2bcd8739ae039);

var $lVtl0 = parcelRequire("lVtl0");
function $e34121b6e92a8f6d$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $lVtl0.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $e34121b6e92a8f6d$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $e34121b6e92a8f6d$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}

});

parcelRegister("ftAdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b445a9556ffd519b$export$2e2bcd8739ae039);

var $lVtl0 = parcelRequire("lVtl0");
function $b445a9556ffd519b$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $lVtl0.KEY_PREFIX)).concat(config.key);
    return storage.removeItem(storageKey, $b445a9556ffd519b$var$warnIfRemoveError);
}
function $b445a9556ffd519b$var$warnIfRemoveError(err) {}

});


parcelRegister("cxX95", function(module, exports) {

var $41dmB = parcelRequire("41dmB");

var $5W88v = parcelRequire("5W88v");

var $2KBf4 = parcelRequire("2KBf4");
function $9226722b35c1c617$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $2KBf4.default) : config.stateReconciler;
    return (0, $5W88v.default)(config, (0, $41dmB.combineReducers)(reducers));
}

});
parcelRegister("2KBf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $200cc42ab7242221$export$2e2bcd8739ae039);
function $200cc42ab7242221$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $200cc42ab7242221$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $200cc42ab7242221$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $200cc42ab7242221$var$_typeof(obj);
}
function $200cc42ab7242221$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $200cc42ab7242221$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $200cc42ab7242221$var$ownKeys(source, true).forEach(function(key) {
            $200cc42ab7242221$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $200cc42ab7242221$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $200cc42ab7242221$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $200cc42ab7242221$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $200cc42ab7242221$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $200cc42ab7242221$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($200cc42ab7242221$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $200cc42ab7242221$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $200cc42ab7242221$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $200cc42ab7242221$var$_typeof(o) === 'object';
}

});


parcelRegister("jBKhA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4655fcf7d9aeab4$export$2e2bcd8739ae039);

var $41dmB = parcelRequire("41dmB");

var $lVtl0 = parcelRequire("lVtl0");
function $e4655fcf7d9aeab4$var$_toConsumableArray(arr) {
    return $e4655fcf7d9aeab4$var$_arrayWithoutHoles(arr) || $e4655fcf7d9aeab4$var$_iterableToArray(arr) || $e4655fcf7d9aeab4$var$_nonIterableSpread();
}
function $e4655fcf7d9aeab4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $e4655fcf7d9aeab4$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $e4655fcf7d9aeab4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $e4655fcf7d9aeab4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4655fcf7d9aeab4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4655fcf7d9aeab4$var$ownKeys(source, true).forEach(function(key) {
            $e4655fcf7d9aeab4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4655fcf7d9aeab4$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4655fcf7d9aeab4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e4655fcf7d9aeab4$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $e4655fcf7d9aeab4$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e4655fcf7d9aeab4$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $lVtl0.REGISTER:
            return $e4655fcf7d9aeab4$var$_objectSpread({}, state, {
                registry: [].concat($e4655fcf7d9aeab4$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $lVtl0.REHYDRATE:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $e4655fcf7d9aeab4$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $e4655fcf7d9aeab4$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $e4655fcf7d9aeab4$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $41dmB.createStore)($e4655fcf7d9aeab4$var$persistorReducer, $e4655fcf7d9aeab4$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $lVtl0.REGISTER),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $lVtl0.REHYDRATE),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $e4655fcf7d9aeab4$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $lVtl0.PURGE),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $lVtl0.FLUSH),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $lVtl0.PAUSE)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $lVtl0.PERSIST),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}

});

parcelRegister("bUN0h", function(module, exports) {

var $lVtl0 = parcelRequire("lVtl0");
function $8acaefc01341b3b4$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $lVtl0.DEFAULT_VERSION);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

});

parcelRegister("1URFs", function(module, exports) {
function $1654a6b0be49779a$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}

});


parcelRegister("jW68n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e838312ff8ae7d3b$export$2e2bcd8739ae039, (v) => $e838312ff8ae7d3b$export$2e2bcd8739ae039 = v);
var $e838312ff8ae7d3b$export$1e511d4a378977f5;
var $e838312ff8ae7d3b$export$2e2bcd8739ae039;
"use strict";
$e838312ff8ae7d3b$export$1e511d4a378977f5 = true;
$e838312ff8ae7d3b$export$2e2bcd8739ae039 = void 0;

var $e838312ff8ae7d3b$var$_createWebStorage = $e838312ff8ae7d3b$var$_interopRequireDefault((parcelRequire("aneab")));
function $e838312ff8ae7d3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e838312ff8ae7d3b$var$_default = (0, $e838312ff8ae7d3b$var$_createWebStorage.default)('session');
$e838312ff8ae7d3b$export$2e2bcd8739ae039 = $e838312ff8ae7d3b$var$_default;

});
parcelRegister("aneab", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $78d709df517f7efb$export$1e511d4a378977f5, (v) => $78d709df517f7efb$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $78d709df517f7efb$export$2e2bcd8739ae039, (v) => $78d709df517f7efb$export$2e2bcd8739ae039 = v);
var $78d709df517f7efb$export$1e511d4a378977f5;
var $78d709df517f7efb$export$2e2bcd8739ae039;
"use strict";
$78d709df517f7efb$export$1e511d4a378977f5 = true;
$78d709df517f7efb$export$2e2bcd8739ae039 = $78d709df517f7efb$var$createWebStorage;

var $78d709df517f7efb$var$_getStorage = $78d709df517f7efb$var$_interopRequireDefault((parcelRequire("7PNpj")));
function $78d709df517f7efb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78d709df517f7efb$var$createWebStorage(type) {
    var storage = (0, $78d709df517f7efb$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("7PNpj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $5b439f0ea53c8cbe$export$1e511d4a378977f5, (v) => $5b439f0ea53c8cbe$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $5b439f0ea53c8cbe$export$2e2bcd8739ae039, (v) => $5b439f0ea53c8cbe$export$2e2bcd8739ae039 = v);
var $5b439f0ea53c8cbe$export$1e511d4a378977f5;
var $5b439f0ea53c8cbe$export$2e2bcd8739ae039;
"use strict";
$5b439f0ea53c8cbe$export$1e511d4a378977f5 = true;
$5b439f0ea53c8cbe$export$2e2bcd8739ae039 = $5b439f0ea53c8cbe$var$getStorage;
function $5b439f0ea53c8cbe$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5b439f0ea53c8cbe$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5b439f0ea53c8cbe$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5b439f0ea53c8cbe$var$_typeof(obj);
}
function $5b439f0ea53c8cbe$var$noop() {}
var $5b439f0ea53c8cbe$var$noopStorage = {
    getItem: $5b439f0ea53c8cbe$var$noop,
    setItem: $5b439f0ea53c8cbe$var$noop,
    removeItem: $5b439f0ea53c8cbe$var$noop
};
function $5b439f0ea53c8cbe$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $5b439f0ea53c8cbe$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $5b439f0ea53c8cbe$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($5b439f0ea53c8cbe$var$hasStorage(storageType)) return self[storageType];
    else return $5b439f0ea53c8cbe$var$noopStorage;
}

});



parcelRegister("gecCs", function(module, exports) {

$parcel$export(module.exports, "setLoading", () => $9c3b17a12473a510$export$3ac708362c1f96eb);
$parcel$export(module.exports, "setPlaying", () => $9c3b17a12473a510$export$f7a69ff0ce01fe43);
$parcel$export(module.exports, "setMetadata", () => $9c3b17a12473a510$export$f8685c902e685023);
$parcel$export(module.exports, "setVolume", () => $9c3b17a12473a510$export$246e658b67178cb0);
$parcel$export(module.exports, "setIsFullscreen", () => $9c3b17a12473a510$export$9c73b2f282069160);
$parcel$export(module.exports, "setError", () => $9c3b17a12473a510$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "setPlayClicked", () => $9c3b17a12473a510$export$355ccd9293fdb8b1);
$parcel$export(module.exports, "setBuffering", () => $9c3b17a12473a510$export$6ce2c23239e94205);
$parcel$export(module.exports, "setStreamInfo", () => $9c3b17a12473a510$export$877d1fe2eba04217);
$parcel$export(module.exports, "setConfig", () => $9c3b17a12473a510$export$940a7873bb071df8);
$parcel$export(module.exports, "setConfigError", () => $9c3b17a12473a510$export$24e5eedfec174b3b);
$parcel$export(module.exports, "setAdblockerEnabled", () => $9c3b17a12473a510$export$360c899b2634481b);
$parcel$export(module.exports, "selectDarkMode", () => $9c3b17a12473a510$export$99d5c08bdbf79596);
$parcel$export(module.exports, "selectLoading", () => $9c3b17a12473a510$export$95c13f7bd175250d);
$parcel$export(module.exports, "selectPlaying", () => $9c3b17a12473a510$export$b67b70eb757c829);
$parcel$export(module.exports, "selectVolume", () => $9c3b17a12473a510$export$2698512dfb2e96eb);
$parcel$export(module.exports, "selectIsFullscreen", () => $9c3b17a12473a510$export$edf8a2ca5945f65);
$parcel$export(module.exports, "selectMetadata", () => $9c3b17a12473a510$export$3c947cbaab82b2b8);
$parcel$export(module.exports, "selectError", () => $9c3b17a12473a510$export$4848158868f02c89);
$parcel$export(module.exports, "selectPlayClicked", () => $9c3b17a12473a510$export$e4405d39c966c661);
$parcel$export(module.exports, "selectBuffering", () => $9c3b17a12473a510$export$786dab19007a56eb);
$parcel$export(module.exports, "selectStreamInfo", () => $9c3b17a12473a510$export$44ac434bdac9bf64);
$parcel$export(module.exports, "selectRefreshCount", () => $9c3b17a12473a510$export$a89cdffa0ea3e55a);
$parcel$export(module.exports, "selectAdblockerEnabled", () => $9c3b17a12473a510$export$bb27db384e317d9a);
$parcel$export(module.exports, "selectConfig", () => $9c3b17a12473a510$export$7ff911e710ee72fc);
$parcel$export(module.exports, "selectCollapsed", () => $9c3b17a12473a510$export$640f98e0ffdf647b);
$parcel$export(module.exports, "default", () => $9c3b17a12473a510$export$2e2bcd8739ae039);

var $c0Lyo = parcelRequire("c0Lyo");
const $9c3b17a12473a510$var$initialState = {
    isDarkMode: false,
    loading: true,
    playing: false,
    volume: 0.5,
    refreshCount: 0,
    isFullscreen: false,
    metadata: {
        title: "",
        artist: "",
        name: "",
        artworkUrl: ""
    },
    ended: false,
    error: "",
    playClicked: 0,
    buffering: false,
    streamInfo: {
        isAudio: false,
        isVideo: false
    },
    adblockerEnabled: false,
    collapsed: false,
    configError: {
        error: false
    },
    config: {
        loading: true,
        streamURL: "",
        assetKey: '',
        playerName: "",
        websiteName: "",
        domain: '',
        publisher: {
            contactPersonId: '',
            country: '',
            dateAdded: '',
            facebook: '',
            id: '',
            instagram: '',
            isArchived: '',
            linkedIn: '',
            loadingAnimation: '',
            logo: '',
            name: '',
            twitter: '',
            website: '',
            whatsapp: ''
        },
        colors: {
            primary: "gradient.purple",
            secondary: "primary.white",
            text: "primary.white",
            highlight: "gray.500"
        },
        logo: "https://www.dev.atunwadigital.com/assets/atunwa_logo-79836885.svg",
        loadingAnimation: "",
        adUrl: "",
        gptUrl: ""
    }
};
const $9c3b17a12473a510$var$slice = (0, $c0Lyo.createSlice)({
    name: "player",
    initialState: $9c3b17a12473a510$var$initialState,
    reducers: {
        setConfigError: (state, action)=>{
            state.configError = action.payload;
        },
        setConfig: (state, action)=>{
            state.config = action.payload;
        },
        setDarkMode: (state, action)=>{
            state.isDarkMode = action.payload;
        },
        setLoading: (state, action)=>{
            state.loading = action.payload;
        },
        setPlaying: (state, action)=>{
            state.playing = action.payload;
        },
        setVolume: (state, action)=>{
            state.volume = action.payload;
        },
        setRefreshCount: (state, action)=>{
            state.refreshCount = action.payload;
        },
        setIsFullscreen: (state, action)=>{
            state.isFullscreen = action.payload;
        },
        setEnded: (state, action)=>{
            state.ended = action.payload;
        },
        setMetadata: (state, action)=>{
            state.metadata = action.payload;
        },
        setError: (state, action)=>{
            state.error = action.payload;
        },
        setPlayClicked: (state)=>{
            state.playClicked = state.playClicked + 1;
        },
        setBuffering: (state, action)=>{
            state.buffering = action.payload;
        },
        setStreamInfo: (state, action)=>{
            state.streamInfo = action.payload;
        },
        setAdblockerEnabled: (state, action)=>{
            state.adblockerEnabled = action.payload;
        },
        setCollapsed: (state, action)=>{
            state.collapsed = action.payload;
        }
    }
});
const { setDarkMode: $9c3b17a12473a510$export$faf76607d863714d, setLoading: $9c3b17a12473a510$export$3ac708362c1f96eb, setPlaying: $9c3b17a12473a510$export$f7a69ff0ce01fe43, setMetadata: $9c3b17a12473a510$export$f8685c902e685023, setVolume: $9c3b17a12473a510$export$246e658b67178cb0, setRefreshCount: $9c3b17a12473a510$export$3d238e3ad3442a46, setIsFullscreen: $9c3b17a12473a510$export$9c73b2f282069160, setEnded: $9c3b17a12473a510$export$a54fdf6b24b61e5c, setError: $9c3b17a12473a510$export$b8d0bb2aa0adefe5, setPlayClicked: $9c3b17a12473a510$export$355ccd9293fdb8b1, setBuffering: $9c3b17a12473a510$export$6ce2c23239e94205, setStreamInfo: $9c3b17a12473a510$export$877d1fe2eba04217, setConfig: $9c3b17a12473a510$export$940a7873bb071df8, setConfigError: $9c3b17a12473a510$export$24e5eedfec174b3b, setAdblockerEnabled: $9c3b17a12473a510$export$360c899b2634481b, setCollapsed: $9c3b17a12473a510$export$8559c98d157fcda1 } = $9c3b17a12473a510$var$slice.actions;
const $9c3b17a12473a510$export$99d5c08bdbf79596 = (state)=>state.player.isDarkMode;
const $9c3b17a12473a510$export$95c13f7bd175250d = (state)=>state.player.loading;
const $9c3b17a12473a510$export$b67b70eb757c829 = (state)=>state.player.playing;
const $9c3b17a12473a510$export$2698512dfb2e96eb = (state)=>state.player.volume;
const $9c3b17a12473a510$export$edf8a2ca5945f65 = (state)=>state.player.isFullscreen;
const $9c3b17a12473a510$export$3c947cbaab82b2b8 = (state)=>state.player.metadata;
const $9c3b17a12473a510$export$6ae3db971df91f08 = (state)=>state.player.ended;
const $9c3b17a12473a510$export$4848158868f02c89 = (state)=>state.player.error;
const $9c3b17a12473a510$export$e4405d39c966c661 = (state)=>state.player.playClicked;
const $9c3b17a12473a510$export$786dab19007a56eb = (state)=>state.player.buffering;
const $9c3b17a12473a510$export$44ac434bdac9bf64 = (state)=>state.player.streamInfo;
const $9c3b17a12473a510$export$a89cdffa0ea3e55a = (state)=>state.player.refreshCount;
const $9c3b17a12473a510$export$bb27db384e317d9a = (state)=>state.player.adblockerEnabled;
const $9c3b17a12473a510$export$7ff911e710ee72fc = (state)=>state.player.config;
const $9c3b17a12473a510$export$3ab35643446917e = (state)=>state.player.configError;
const $9c3b17a12473a510$export$640f98e0ffdf647b = (state)=>state.player.collapsed;
var $9c3b17a12473a510$export$2e2bcd8739ae039 = $9c3b17a12473a510$var$slice.reducer;

});

parcelRegister("dD8Ud", function(module, exports) {

$parcel$export(module.exports, "setLoading", () => $9365faa0b282c242$export$3ac708362c1f96eb);
$parcel$export(module.exports, "setPlaying", () => $9365faa0b282c242$export$f7a69ff0ce01fe43);
$parcel$export(module.exports, "setPrerollPlayed", () => $9365faa0b282c242$export$59feaf01fe177eb9);
$parcel$export(module.exports, "setHasCompanionAd", () => $9365faa0b282c242$export$aa80eda2283fcd79);
$parcel$export(module.exports, "setCompanionAdContent", () => $9365faa0b282c242$export$b6f3d3de49b3a649);
$parcel$export(module.exports, "setAdCountdown", () => $9365faa0b282c242$export$84f4cd992498a9de);
$parcel$export(module.exports, "selectLoading", () => $9365faa0b282c242$export$95c13f7bd175250d);
$parcel$export(module.exports, "selectPlaying", () => $9365faa0b282c242$export$b67b70eb757c829);
$parcel$export(module.exports, "selectConsent", () => $9365faa0b282c242$export$c0c1550f4f7cc7e0);
$parcel$export(module.exports, "selectAdswizzConsent", () => $9365faa0b282c242$export$26ae5fce7160078b);
$parcel$export(module.exports, "selectPrerollPlayed", () => $9365faa0b282c242$export$f819e66e4da14ca8);
$parcel$export(module.exports, "selectHasCompanionAd", () => $9365faa0b282c242$export$cdf33199afa46b98);
$parcel$export(module.exports, "selectCompanionAdContent", () => $9365faa0b282c242$export$78a8dbeba37f50b3);
$parcel$export(module.exports, "selectAdCountdown", () => $9365faa0b282c242$export$6aae31e119608640);
$parcel$export(module.exports, "default", () => $9365faa0b282c242$export$2e2bcd8739ae039);

var $c0Lyo = parcelRequire("c0Lyo");
// Get consent from localStorage if available
const $9365faa0b282c242$var$getSavedConsent = ()=>{
    try {
        const savedConsent = localStorage.getItem('cookieConsent');
        return savedConsent === 'true';
    } catch (error) {
        // In case localStorage is not available (e.g., in incognito mode)
        console.error('Error accessing localStorage:', error);
        return false;
    }
};
const $9365faa0b282c242$var$initialState = {
    loading: false,
    gptLoading: true,
    playing: false,
    paused: false,
    volume: 0.5,
    isFullscreen: false,
    metadata: {
        title: "",
        name: ""
    },
    error: "",
    url: "",
    contentType: "",
    data: {},
    consent: $9365faa0b282c242$var$getSavedConsent(),
    adswizzConsent: true,
    prerollPlayed: false,
    hasCompanionAd: false,
    companionAdContent: "",
    isSkippable: false,
    skipTimeOffset: 0,
    adCountdown: 0
};
const $9365faa0b282c242$var$slice = (0, $c0Lyo.createSlice)({
    name: "ads",
    initialState: $9365faa0b282c242$var$initialState,
    reducers: {
        setLoading: (state, action)=>{
            state.loading = action.payload;
        },
        setGptLoading: (state, action)=>{
            state.gptLoading = action.payload;
        },
        setPlaying: (state, action)=>{
            state.playing = action.payload;
        },
        setPaused: (state, action)=>{
            state.paused = action.payload;
        },
        setVolume: (state, action)=>{
            state.volume = action.payload;
        },
        setIsFullscreen: (state, action)=>{
            state.isFullscreen = action.payload;
        },
        setMetadata: (state, action)=>{
            state.metadata = action.payload;
        },
        setError: (state, action)=>{
            state.error = action.payload;
        },
        setUrl: (state, action)=>{
            state.url = action.payload;
        },
        setContentType: (state, action)=>{
            state.contentType = action.payload;
        },
        setData: (state, action)=>{
            state.data = action.payload;
        },
        setConsent: (state, action)=>{
            state.consent = action.payload;
        },
        setAdswizzConsent: (state, action)=>{
            state.adswizzConsent = action.payload;
        },
        /**
     * Correctly spelled action. Preferred going forward.
     */ setPrerollPlayed: (state, action)=>{
            state.prerollPlayed = action.payload;
        },
        setHasCompanionAd: (state, action)=>{
            state.hasCompanionAd = action.payload;
        },
        setCompanionAdContent: (state, action)=>{
            state.companionAdContent = action.payload;
        },
        setIsSkippable: (state, action)=>{
            state.isSkippable = action.payload;
        },
        setSkipTimeOffset: (state, action)=>{
            state.skipTimeOffset = action.payload;
        },
        setAdCountdown: (state, action)=>{
            state.adCountdown = action.payload;
        }
    }
});
const { setLoading: $9365faa0b282c242$export$3ac708362c1f96eb, setGptLoading: $9365faa0b282c242$export$df9442936979743f, setPaused: $9365faa0b282c242$export$fe6e5eea1a9bd925, setPlaying: $9365faa0b282c242$export$f7a69ff0ce01fe43, setMetadata: $9365faa0b282c242$export$f8685c902e685023, setVolume: $9365faa0b282c242$export$246e658b67178cb0, setIsFullscreen: $9365faa0b282c242$export$9c73b2f282069160, setError: $9365faa0b282c242$export$b8d0bb2aa0adefe5, setUrl: $9365faa0b282c242$export$6f5f9061e41e006a, setContentType: $9365faa0b282c242$export$f0b2c59960f4bfcc, setData: $9365faa0b282c242$export$3a6802af14bf5fa6, setConsent: $9365faa0b282c242$export$ff06c4c0781050d7, setAdswizzConsent: $9365faa0b282c242$export$586800fc07e1003f, setPrerollPlayed: $9365faa0b282c242$export$59feaf01fe177eb9, setHasCompanionAd: $9365faa0b282c242$export$aa80eda2283fcd79, setCompanionAdContent: $9365faa0b282c242$export$b6f3d3de49b3a649, setIsSkippable: $9365faa0b282c242$export$e87bfb25d88f4912, setSkipTimeOffset: $9365faa0b282c242$export$a935d7122caa6e4f, setAdCountdown: $9365faa0b282c242$export$84f4cd992498a9de } = $9365faa0b282c242$var$slice.actions;
const $9365faa0b282c242$export$95c13f7bd175250d = (state)=>state.ads.loading;
const $9365faa0b282c242$export$5dd4bcfb137dba99 = (state)=>state.ads.gptLoading;
const $9365faa0b282c242$export$b67b70eb757c829 = (state)=>state.ads.playing;
const $9365faa0b282c242$export$4be20825f3aee88f = (state)=>state.ads.paused;
const $9365faa0b282c242$export$2698512dfb2e96eb = (state)=>state.ads.volume;
const $9365faa0b282c242$export$edf8a2ca5945f65 = (state)=>state.ads.isFullscreen;
const $9365faa0b282c242$export$3c947cbaab82b2b8 = (state)=>state.ads.metadata;
const $9365faa0b282c242$export$4848158868f02c89 = (state)=>state.ads.error;
const $9365faa0b282c242$export$ec7417da2197dc18 = (state)=>state.ads.url;
const $9365faa0b282c242$export$dcd2681f07dbad15 = (state)=>state.ads.contentType;
const $9365faa0b282c242$export$703601b7e90536f8 = (state)=>state.ads.data;
const $9365faa0b282c242$export$c0c1550f4f7cc7e0 = (state)=>state.ads.consent;
const $9365faa0b282c242$export$26ae5fce7160078b = (state)=>state.ads.adswizzConsent;
const $9365faa0b282c242$export$f819e66e4da14ca8 = (state)=>state.ads.prerollPlayed;
const $9365faa0b282c242$export$cdf33199afa46b98 = (state)=>state.ads.hasCompanionAd;
const $9365faa0b282c242$export$78a8dbeba37f50b3 = (state)=>state.ads.companionAdContent;
const $9365faa0b282c242$export$4a08107466e569 = (state)=>state.ads.isSkippable;
const $9365faa0b282c242$export$25ebdc9e332ff0fb = (state)=>state.ads.skipTimeOffset;
const $9365faa0b282c242$export$6aae31e119608640 = (state)=>state.ads.adCountdown;
var $9365faa0b282c242$export$2e2bcd8739ae039 = $9365faa0b282c242$var$slice.reducer;

});


parcelRegister("btvu2", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $97b9c53487707b27$export$d8964aec282183a3);
// src/theme/ThemeContext.tsx

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
parcelRequire("l399s");
var $kNYU3 = parcelRequire("kNYU3");

var $gecCs = parcelRequire("gecCs");
const $97b9c53487707b27$var$ThemeContext = /*#__PURE__*/ (0, $8NFma.createContext)({
    isDarkMode: false
});
const $97b9c53487707b27$export$d8964aec282183a3 = ({ children: children })=>{
    const isDarkMode = (0, $kNYU3.useSelector)((0, $gecCs.selectDarkMode)) ?? false;
    (0, $8NFma.useEffect)(()=>{
        document.documentElement.classList.toggle('dark', isDarkMode);
    }, [
        isDarkMode
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($97b9c53487707b27$var$ThemeContext.Provider, {
        value: {
            isDarkMode: isDarkMode
        },
        children: children
    });
};
const $97b9c53487707b27$export$93d4e7f90805808f = ()=>(0, $8NFma.useContext)($97b9c53487707b27$var$ThemeContext);

});

parcelRegister("j88fz", function(module, exports) {

});

parcelRegister("droSZ", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("t99t9")).then(()=>parcelRequire('co2TE'));

});

parcelRegister("iZh84", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("8TD9g"))((parcelRequire("kI8SP")).resolve("mEX82")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("1skPS"))
]).then(()=>parcelRequire('17Eoe'));

});


})();
//# sourceMappingURL=RootApp.2dfffdfa.js.map
